
import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import PersonIcon from '@mui/icons-material/Person';
import StarIcon from '@mui/icons-material/Star';
import PhoneCallbackIcon from '@mui/icons-material/PhoneCallback';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import {
  Box,
  Button,
  DialogActions,
  DialogTitle,
  Divider,
  Menu,
  MenuItem,
  TableBody,
  Typography,
} from "@mui/material";
import { BsThreeDotsVertical } from "react-icons/bs";
import { FaPhone } from "react-icons/fa";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import Row from "react-bootstrap/Row";
import {
  FaBlenderPhone,
  FaEdit,
  FaPhoneSquare,
  FaTrash,
  FaEye,
  FaWindowClose,
} from "react-icons/fa";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Fade from "@mui/material/Fade";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import axios from "axios";
import Pagination from "@mui/material/Pagination";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import moment from "moment";
import { FaMobileAlt } from "react-icons/fa";
import Badge from "react-bootstrap/Badge";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";
import * as XLSX from 'xlsx';
import './primary.css'
import CustomerDetailDialog from "./CustomerDetailDialog";

const isLargeScreen = window.innerWidth >= 1200;

export default function Primary() {
  const [id, setId] = useState();
  const [wapp, setWapp] = useState();
  const [isWhatsappNo, setIsWhatsappNo] = useState(false);
  const [whatsappMobile, setWhatsappMobile] = useState("");
  const handleWhatsappCheckboxChange = (event) => {
    setIsWhatsappNo(event.target.value === "No");
  };

  const [mobile, setMobile] = useState("");
  const [sourceType, setSourceType] = useState("Website");

  const [comment, setComment] = useState();
  const [location, setLocation] = useState();
  const [rname, setRName] = useState();
  const [rucin,setRucin]=useState()
  const [rmobile, setRMobile] = useState();
  const [showReferenceFields, setShowReferenceFields] = useState(false);
  const handleSourceTypeChange = (e) => {
    const selectedSourceType = e.target.value;
    setPst(selectedSourceType);
    setShowReferenceFields(selectedSourceType === "Reference");
  };

  const [intrest, setIntrest] = useState("");
  const [cpName, setCPName] = useState("");
  const [cpMobile,setCPMobile]=useState("")
  const [cpId, setCPId] = useState("");

  const handleIntrestChange = (e) => {
    const selectedIntrest = e.target.value;
    setIntrest(selectedIntrest);
    // Reset the CP Name and CP ID fields when selecting "No"
    if (selectedIntrest === "No") {
      setCPName("");
      setCPId("");
    }
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open2 = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event);
  };

  const handleClose2 = () => {
    setAnchorEl(null);
  };
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setValidated(false);
  };
  const [Validated, setValidated] = useState(false);

  const [open1, setOpen1] = useState(false);

  const formValidation = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      // intrstTab()
      add_basic();
    }

    setValidated(true);
  };

  const [Validatedtabi, setValidatedtabi] = useState(false);

  const formValidationtabi = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      intrstTab();
    }

    setValidatedtabi(true);
  };

  const BulkUpload=()=>{

  }

  const [Validatedtabin, setValidatedtabin] = useState(false);

  const formValidationtabin = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      notintrstTab();
    }

    setValidatedtabin(true);
  };
  const [Validatedtabcb, setValidatedtabcb] = useState(false);

  const formValidationtabcb = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      callbackTab();
    }

    setValidatedtabcb(true);
  };
  const [pname, setPname] = useState("");
  const [Pemail, setPemail] = useState("");
  const [pmobile, setPmobile] = useState("");
  const [pgender, setPgender] = useState("");
  const [ptym, setPtym] = useState("");
  const [pst, setPst] = useState("");

  const viewData = () => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/view-lead", {
        id,
      })
      .then((res) => {
        console.log(res.data);
        setPname(res.data.name);
        setPemail(res.data.email);
        setPmobile(res.data.mobile);
        setPgender(res.data.gender);
        setPst(res.data.sourceType);
        setPtym(res.data.pretime);
      });
  };

  const PrName = sessionStorage.getItem("ProjectName");
  //   https://buildfastvapi.emedha.in/api/v1/lead-managements

  const excutiveEmail = sessionStorage.getItem("emailExcutive");
  const excutiveName = sessionStorage.getItem("user_name");
  console.log(excutiveName)

  const companyId=sessionStorage.getItem("companyId");

  // https://buildfastvapi.emedha.in/api/v1/lead-managements

  // const add_basic = () => {
  //   axios
  //     .post("https://buildfastvapi.emedha.in/api/v1/lead-managements", {
  //       name: pname,
  //       email: Pemail,
  //       mobile: pmobile,
  //       gender: pgender,
  //       pretime: ptym,
  //       sourceType: pst,
  //       location,
  //       refName: rname,
  //       refucin:rucin,
  //       refMobile: rmobile,
  //       channelPartner: intrest,
  //       cpName,
  //       cpId,
  //       commentBox: comment,
  //       ProjectName: PrName,
  //       salesExecutiveEmail: excutiveEmail,

  //       salesExecutive: excutiveName,
  //     })
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setOpen(false);
  //         getlm();
  //         Swal.fire({
  //           icon: "success",
  //           title: "Success !",
  //           text: "Data is added successfully !",
  //           confirmButtonColor: "rgb(126, 110, 228)",
  //           cancelButtonColor: "#d33",
  //           showCancelButton: false,
  //           confirmButtonText: "Ok",
  //         }).then((result) => {
  //           if (result.value) {
  //             return;
  //           }
  //         });
  //       }
  //     });
  // };

  // https://buildfastvapi.emedha.in/api/v1/lead-managements


  const add_basic = () => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/lead-managements", {
        name: pname,
        email: Pemail,
        mobile: pmobile,
        gender: pgender,
        pretime: ptym,
        sourceType: pst,
        location,
        refName: rname,
        refucin: rucin,
        refMobile: rmobile,
        channelPartner: intrest,
        cpName,
        cpId,
        commentBox: comment,
        ProjectName: sessionStorage.getItem('project_name'),
        ProjectType: sessionStorage.getItem('project_type'),
        salesExecutiveEmail: excutiveEmail,
        salesExecutive: excutiveName,
        companyId:companyId
      })
      .then((res) => {
        if (res.data.status === 200) {
          setOpen(false);
          getlm();
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Data is added successfully!",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 409) {
          // Handle conflict case
          Swal.fire({
            icon: "error",
            title: "Conflict!",
            text: "A lead with this email or mobile number already exists.",
            confirmButtonColor: "rgb(126, 110, 228)",
            confirmButtonText: "Ok",
          });
        } else {
          // Handle other errors
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "An error occurred. Please try again later.",
            confirmButtonColor: "rgb(126, 110, 228)",
            confirmButtonText: "Ok",
          });
        }
      });
  };
  

  const editlead = () => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/lead-edit", {
        name: pname,
        email: Pemail,
        mobile: pmobile,
        gender: pgender,
        pretime: ptym,
        sourceType: pst,
        id,
      })
      .then((res) => {
        if (res.data.status === 200) {
          setOpen(false);
          getlm();
        }
      });
  };

  const add_primary = () => {
    setOpen(false);
    Swal.fire({
      icon: "success",
      title: "Success !",
      text: "Data added successfully !",
      confirmButtonColor: "rgb(126, 110, 228)",
      cancelButtonColor: "#d33",
      showCancelButton: false,
      confirmButtonText: "Ok",
    })``;
  };

  const editAlert = () => {
    setOpen1(false);
    handleClose2();
    Swal.fire({
      icon: "warning",
      title: "Warning !",
      text: "Are you sure to edit this data",
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.value) {
        editlead(id);
      }
    });
  };

  const deleteAlert = (id) => {
    handleClose2();
    Swal.fire({
      icon: "warning",
      title: "Warning !",
      text: "Are you sure to delete this data",
      confirmButtonColor: "rgb(126, 110, 228)",
      cancelButtonColor: "#d33",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.value) {
        leadDataDelete(id);
      }
    });
  };

  const leadDataDelete = (id) => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/delete-lead", {
        id,
      })
      .then((res) => {
        if (res.data.status === 200) {
          getlm();
          Swal.fire({
            icon: "success",
            title: "Successfull !",
            text: "Lead is deleted successfully !",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              return;
            }
          });
        }
      });
  };

  // buildfastvapi.emedha.in/api/v1/

  const [data, setData] = useState([]);


  localStorage.setItem('adminCount',data.length)

  const getlm = () => {
    axios.get("https://buildfastvapi.emedha.in/api/v1/lead-data").then((res) => {
      setData(res.data.data);
      console.log(res.data.data);
    });
  };



  React.useEffect(() => {
    getlm();
  }, []);


  
const projectType=sessionStorage.getItem("project_type")
console.log(projectType)

  // https://buildfastvapi.emedha.in/api/v1

  const [isVeiw, setIsVeiw] = useState(false);

  const leadDataSearch = (text) => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/search-lead", {
        text,
      })
      .then((res) => {
        setData(res.data);
      });
  };

  const [page, setPage] = useState(5);
  const [cpage, setCpage] = useState(1);

  const pagehandle = (e, val) => {
    setCpage(val);
  };

  const indexOflpage = cpage * page;
  const indexOffpage = indexOflpage - page;
  const currentpost = data.slice(indexOffpage, indexOflpage);

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [openi, setOpeni] = React.useState(false);

  const handleClickOpeni = () => {
    setOpeni(true);
  };

  const handleClosei = () => {
    setOpeni(false);
  };

  const [openin, setOpenin] = React.useState(false);

  const handleClickOpenin = () => {
    setOpenin(true);
  };

  const handleClosein = () => {
    setOpeni(false);
  };

  const [openc, setOpenc] = React.useState(false);

  const handleClickOpenc = () => {
    setOpenc(true);
  };

  const handleClosec = () => {
    setOpenc(false);
  };

  // https://buildfastvapi.emedha.in/api/v1/intrst-tab

  const [idate, setIdate] = useState("");
  const [icomment, setIcomment] = useState("");

  const intrstTab = () => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/intrst-tab", {
        id,
        intrestDate: idate,
        intrestComment: icomment,
      })
      .then((res) => {
        if (res.status === 200) {
          getlm();
          handleClosei();

          setValidatedtabi(false);
          Swal.fire({
            icon: "success",
            title: "Successfull !",
            text: "Selected customer is interested!",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              return;
            }
          });
        }
      });
  };

  // https://buildfastvapi.emedha.in/api/v1/notintrst-tab

  const [incb, setIncb] = useState("");
  // const [reasonNotIntr,setReasonNotIntr]=useState("")
  const [reasonNotIntr, setReasonNotIntr] = useState('');
  const [saveForLater, setSaveForLater] = useState(false);

  // Handle change for the dropdown
  const handleReasonChange = (e) => {
    setReasonNotIntr(e.target.value);
    // Reset saveForLater checkbox when changing the reason
    if (e.target.value !== 'Save For Later') {
      setSaveForLater(false);
    }
  };

  // Handle change for the checkbox
  const handleCheckboxChange = () => {
    setSaveForLater(!saveForLater);
  };


  // https://buildfastvapi.emedha.in/api/v1/notintrst-tab

  const notintrstTab = () => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/notintrst-tab", {
        id,
        notintrstComment: incb,
        notintrstReason:reasonNotIntr,
        saveforLater:saveForLater
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          getlm();
          setOpenin(false);

          setValidatedtabin(false);
          Swal.fire({
            icon: "success",
            title: "Successfull !",
            text: "Selected customer is Not-interested!",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              return;
            }
          });
        }
      });
  };

  // https://buildfastvapi.emedha.in/api/v1/sitevisit-tab

  const [commentSiteVisit,setCommentSiteVisti]=useState('')

  const [intrstFloor,setIntrstFloor]=useState('')

const handleChangeIntrstFloor=(e)=>{
  setIntrstFloor(e.target.value)
}

// https://buildfastvapi.emedha.in/api/v1/sitevisit-tab"

  const siteVisitTab = () => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/sitevisit-tab", {
        id,
        Occupation: occupation,
        budget: budget,
        aptsize: apartsize,
        facing: apartfacing,
        cornor: Corner,
        ucon: underConstruction,
        rmdate: readyToMove,
        commentSiteVisit:commentSiteVisit,
        interestfloor:intrstFloor,
    
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          getlm();
          setOpensv(false);

          setValidatedtabin(false);
          Swal.fire({
            icon: "success",
            title: "Successfull !",
            text: "Selected customer is move Site Visit!",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              return;
            }
          });
        }
      });
  };

  const [cbd, setCbd] = useState("");
  const [cbc, setCbc] = useState("");

  const callbackTab = () => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/callback-tab", {
        id,
        cbDate: cbd,
        cbComment: cbc,
      })
      .then((res) => {
        
        if (res.data.statusCode === 200) {
          getlm();
          handleClosec();
          setValidatedtabcb(false);
          Swal.fire({
            icon: "success",
            title: "Successfull !",
            text: "Selected customer said to callBack!",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              return;
            }
          });
        }
      });
  };

  const convrtintr = () => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/cnvrttinstrest", { id })
      .then((res) => {
        if (res.data.statusCode === 200) {
          getlm();
          Swal.fire({
            icon: "success",
            title: "Successfull !",
            text: "Selected customer converted to intrest!",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              return;
            }
          });
        }
      });
  };

  const [Validatedsv, setValidatedsv] = useState(false);

  const [opensv, setOpensv] = useState(false);
  const handleClickOpensv = () => {
    setOpensv(true);
  };

  const handleClosesv = () => {
    setOpensv(false);
  };

  const formValidationsv = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      siteVisitTab();
      // add_sitevisit()
    }

    setValidatedsv(true);
  };

  const [pexecutive, setPExecutive] = useState("");

  const [occupation, setOccupation] = useState();
  const [apartsize, setApartSize] = useState();
  const [apartfacing, setApartFacing] = useState();
  const [budget, setBudget] = useState();
  const [Corner, setCorner] = useState();

  const [flatDetails, setFlatDetails] = useState("");
  const [underConstruction, setUnderConstruction] = useState("");
  const [readyToMove, setReadyToMove] = useState("");
  const [nname, setNname] = useState("");
  const [nmobile, setNmobile] = useState("");
  const [nemail, setNemail] = useState("");
  const [nst, setNst] = useState("");
  const [leadloc, setLeadloc] = useState("");
  const [nrefname, setNrefname] = useState("");
  const [nrefmob, setNrefmob] = useState("");
  const [ncp, setNcp] = useState("");
  const [ncpname, setNcpname] = useState("");
  const [ncpid, setNcpid] = useState("");
  const [ncb, setNcb] = useState("");

  const handleFlatDetailsChange = (e) => {
    const selectedFlatDetails = e.target.value;
    setFlatDetails(selectedFlatDetails);
    // Reset the fields when changing the selected flat details
    setUnderConstruction("");
    setReadyToMove("");
  };

  const [res, setRes] = React.useState([]);

  const getLeadname = () => {
    axios.get("https://buildfastvapi.emedha.in/api/v1/lead-data").then((res) => {
      setRes(res.data.data);
      // console.log("leaddata",res.data.data);
      // setIsFilter(true)
    });
  };

  React.useEffect(() => {
    getLeadname();
    get_units();
    // customerObjsi()
    get_unit();
    get_floor();
    get_floorf();
    customerObjsib();
    customerObj();
  }, []);

  const [typicaluzdrop, setTypicaluzdrop] = useState([]);

  const get_units = () => {
    axios
      .get("https://buildfastvapi.emedha.in/project/api/v1/typicalunits")
      .then((res) => {
        setTypicaluzdrop(res.data);
        console.log(res.data.data);
      });
  };

  // const get_units = () => {
  //   axios
  //     .post("https://buildfastvapi.emedha.in/project/api/v1/gettypical-unitsize",)
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setTypicaluzdrop(res.data.data);
  //         console.log(res.data.data);
  //       }
  //     });
  // };

  const [siteId, setSiteId] = useState("");

  // const add_sitevisit = () => {

  //     axios.post("http://localhost:3002/add-sitevistfrm", {
  //       name:nname,mobile:nmobile, email:nemail, location:leadloc, sourceType:nst, reference:nrefname, channelPartner:ncp,executive:pexecutive,  Occupation:occupation, budget:budget, aptsize:apartsize, facing:apartfacing, cornor:Corner, ucon:underConstruction, rmdate:readyToMove,Id:siteId
  //     }).then((res) => {
  //         if (res.status === 200) {
  //             setOpensv(false)
  //             setValidatedsv(false)
  //             customerObjsi()
  //             Swal.fire({
  //                 icon: 'success',
  //                 title: "Success !",
  //                 text: "Data is added successfully !",
  //                 confirmButtonColor: "rgb(126, 110, 228)",
  //                 cancelButtonColor: "#d33",
  //                 showCancelButton: false,
  //                 confirmButtonText: "Ok"
  //             }).then((result) => {
  //                 if (result.value) {
  //                     return
  //                 }
  //             })
  //         }
  //     })
  // }
  const [salessource, setSalesSource] = useState("");

   

  const getdetls = (value) => {
    axios
      .post("https://buildfastvapi.emedha.in/api/v1/get-lead-details", {
        value,
      })
      .then((res) => {
        // setNid(res.data.Id)
        console.log(res.data.Location);
        setNname(res.data.name);
        setNmobile(res.data.mobile);
        setNemail(res.data.email);
        setNst(res.data.sourceType);
        setLeadloc(res.data.location);
        setNrefname(res.data.refName);
        setNrefmob(res.data.refMobile);
        setNcp(res.data.channelPartner);
        setNcpname(res.data.cpName);
        setNcpid(res.data.cpId);
        setNcb(res.data.commentBox);
        setSalesSource(excutiveName);
      });
  };

  const [customerRessi, setCustomerResponsesi] = React.useState([]);

  // const customerObjsi = () => {
  //     axios.get('https://buildfastvapi.emedha.in/api/v1/getsitform').then((res) => {
  //         setCustomerResponsesi(res.data)
  //         console.log(customerRessi)
  //     })
  // }


  
  const [clickedName, setClickedName] = useState(sessionStorage.getItem("clickedName") || "")

  const handleRowClick = (itemName) => {
    sessionStorage.setItem("clickedName", itemName);
    setClickedName(itemName);
    console.log("Stored clicked name:", itemName); // Debug log
  };

  // const clickedName = sessionStorage.getItem("clickedName");
  // console.log("Retrieved clicked name:", clickedName); // Debug log

  React.useEffect(() => {
    const storedName = sessionStorage.getItem("clickedName");
    if (storedName) {
      setClickedName(storedName);
    }
  }, []);


  const filteredItems = clickedName
    ? data.filter((item) => item.name === clickedName)
    : [];

 

  const [Validatedbf, setValidatedbf] = useState(false);

  const [openbf, setOpenbf] = useState(false);

  const handleClickOpenbf = () => {
    setOpenbf(true);
  };

  const handleClosebf = () => {
    setOpenbf(false);
  };

  const formValidationbf = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      add_blockform();
    }

    setValidatedbf(true);
  };

  const [alternatemob, setAlternateMob] = useState("");
  const [aadharnumber, setAadharNumber] = useState("");
  const [pannumber, setPanNumber] = useState("");
  const [peraddress, setPerAddress] = useState("");
  const [addresscom, setAddressCom] = useState("");
  const [paymentsource, setPaymentSource] = useState("");
  const [chequenumber, setChequeNumber] = useState("");
  const [transferdetails, setTransferDetails] = useState("");
  const [amountinwords, setAmountInWords] = useState("");
  const [Amount, setAmount] = useState("");
  const [tflatno, setTowardsFlatNumber] = useState("");
  const [tfloorno, setTowardsFloorNumber] = useState("");
  const [ttowerno, setTowardsTowerNumber] = useState("");

  const [signature, setSignature] = useState("");

  const [sameaspaddress, setSameaspaddress] = useState(false);

  const handlecheck = () => {
    if (sameaspaddress) {
      setAddressCom("");
    } else {
      setAddressCom(peraddress);
    }
    setSameaspaddress(!sameaspaddress);
  };

  // https://buildfastvapi.emedha.in/project/api/v1/unit-show  http://localhost:3003/unit-show
 
  const [unitdata, setUnitdata] = useState([]);
  const get_unit = () => {
    axios
      .post("https://buildfastvapi.emedha.in/project/api/v1/unit-show")
      .then((res) => {
        setUnitdata(res.data);
        console.log(res.data);
      });
  };

  const [responset, setResponset] = useState([]);

  const get_floor = () => {
    axios
      .post("https://buildfastvapi.emedha.in/project/api/v1/towers-getall")
      .then((res) => {
        if (res.data.status === 200) {
          setResponset(res.data.data);
          console.log(res.data.data);
        }
      });
  };

  const [responsef, setResponsef] = useState([]);

  const get_floorf = () => {
    axios
      .get("https://buildfastvapi.emedha.in/project/api/v1/get-floor")
      .then((res) => {
        if (res.data.status === 200) {
          setResponsef(res.data.data);
          console.log(res.data.data)
        }
      });
  };


  const getCurrentDateTime = () => {
    const current = new Date();
    const year = current.getFullYear();
    const month = String(current.getMonth() + 1).padStart(2, "0");
    const day = String(current.getDate()).padStart(2, "0");
    const hours = String(current.getHours()).padStart(2, "0");
    const minutes = String(current.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  // Set the default date and time when the component mounts
  React.useEffect(() => {
    setPtym(getCurrentDateTime());
  }, []);



  const [transactionId, setTransactionId] = useState("");
  const [screenshot, setScreenshot] = useState("");

  //31-07-2024

  // const add_blockform = () => {
  //   console.log({
  //     name: nname,
  //     mobile: nmobile,
  //     alternateMobile: alternatemob,
  //     email: nemail,
  //     permanentAddress: peraddress,
  //     addComm: addresscom,
  //     aadharNo: aadharnumber,
  //     panNo: pannumber,
  //     paySource: paymentsource,
  //     cheqNo: chequenumber,
  //     transferDetail: transferdetails,
  //     amtInWords: amountinwords,
  //     amt: Amount,
  //     tflatNo: tflatno,
  //     ttowerNo: ttowerno,
  //     salesSOurce: salessource,
  //     transactionId:transactionId,
  //     screenshot:screenshot
  //   });
  //   const formdata = new FormData();
  //   formdata.append("name", nname);
  //   formdata.append("mobile", nmobile);
  //   formdata.append("alternateMobile", alternatemob);
  //   formdata.append("email", nemail);
  //   formdata.append("permanentAddress", peraddress);
  //   formdata.append("addComm", addresscom);
  //   formdata.append("aadharNo", aadharnumber);
  //   formdata.append("panNo", pannumber);
   
  //   formdata.append("tflatNo", tflatno);
  //   formdata.append("ttowerNo", ttowerno);
  //   formdata.append("salesSource", excutiveName);

  //   formdata.append("ProjectName", Pname);
  //   formdata.append("salesExecutiveEmail", emailExcutive);
  //   formdata.append("tfloor", floorb);
  //   formdata.append('transactionId',transactionId);
  //   formdata.append('screenshot',screenshot);
  //   formdata.append('facing',facingFlat)
  //   formdata.append('corner',cornerbb)


  //   // https://buildfastvapi.emedha.in/create-customer/api/v1/add-blockform
  //   axios
  //     .post(
  //       "https://buildfastvapi.emedha.in/create-customer/api/v1/add-blockform",
  //       formdata
  //     )
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setOpenbf(false);
  //         setOpenblockForm(false)
  //         customerObjsib();
  //         Swal.fire({
  //           icon: "success",
  //           title: "Success !",
  //           text: "Data is added successfully !",
  //           confirmButtonColor: "rgb(126, 110, 228)",
  //           cancelButtonColor: "#d33",
  //           showCancelButton: false,
  //           confirmButtonText: "Ok",
  //         }).then((result) => {
  //           if (result.value) {
  //             return;
  //           }
  //         });
  //       }
  //     });
  // };

  const [gstPercentage, setGstPercentage] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);


  const handleGstChange = (e) => {
    const percentage = parseFloat(e.target.value) || 0;
    setGstPercentage(percentage);
    calculateTotalAmount(percentage);
  };

  const calculateTotalAmount = (gst) => {
    let total = 0;
    selectedPaymentsBlock.forEach(paymentSource => {
      if (paymentSourcesBlock[paymentSource]?.amtPaid) {
        total += parseFloat(paymentSourcesBlock[paymentSource].amtPaid);
      }
    });
    const gstAmount = (total * gst) / 100;
    setTotalAmount(total + gstAmount);
  };
  
//13-09-2024

  // const add_blockform = () => {
  //   const formdata = new FormData();
  //   formdata.append("name", nname);
  //   formdata.append("mobile", nmobile);
  //   formdata.append("alternateMobile", alternatemob);
  //   formdata.append("email", nemail);
  //   formdata.append("permanentAddress", peraddress);
  //   formdata.append("addComm", addresscom);
  //   formdata.append("aadharNo", aadharnumber);
  //   formdata.append("panNo", pannumber);
  //   formdata.append("tflatNo", tflatno);
  //   formdata.append("ttowerNo", ttowerno);
  //   formdata.append("salesSource", excutiveName);
  //   formdata.append("ProjectName", Pname);
  //   formdata.append("tfloor", floorb);
  //   formdata.append("salesExecutiveEmail", emailExcutive);
  //   formdata.append("facing", facingFlat);
  //   formdata.append("corner", cornerbb);
  //   formdata.append("sig", signature);
  
  //   console.log('Payment Sources Block:', paymentSourcesBlock);
  //   // Serialize paymentSourcesBlock and append it to the form data
  //   formdata.append("paySources", JSON.stringify(paymentSourcesBlock));


  //   for (const [source, details] of Object.entries(paymentSourcesBlock)) {
  //     if (details.screenshot) {
  //       formdata.append(`${source}_screenshot`, details.screenshot);
  //     }
  //     if (details.chequeImage) {
  //       formdata.append(`${source}_chequeImage`, details.chequeImage);
  //     }
  //   }
  //   formdata.append("gstPercentage", gstPercentage);
  //   formdata.append("gstAmount", totalAmount);
  
  //   // Append files if available https://buildfastvapi.emedha.in/create-customer/api/v1/add-blockform

  
  //   axios
  //     .post("https://buildfastvapi.emedha.in/create-customer/api/v1/add-blockform", formdata)
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setOpenbf(false);
  //         setOpenblockForm(false);
  //         customerObjsib();
  //         Swal.fire({
  //           icon: "success",
  //           title: "Success!",
  //           text: "Data is added successfully!",
  //           confirmButtonColor: "rgb(126, 110, 228)",
  //           cancelButtonColor: "#d33",
  //           showCancelButton: false,
  //           confirmButtonText: "Ok",
  //         }).then((result) => {
  //           if (result.value) {
  //             return;
  //           }
  //         });
  //       }
  //     })
  //     .catch(error => {
  //       console.error("Error adding block form:", error);
  //     });
  // };
  
  const add_blockform = () => {
    const formdata = new FormData();
    formdata.append("name", nname);
    formdata.append("mobile", nmobile);
    formdata.append("alternateMobile", alternatemob);
    formdata.append("email", nemail);
    formdata.append("permanentAddress", peraddress);
    formdata.append("addComm", addresscom);
    formdata.append("aadharNo", aadharnumber);
    formdata.append("panNo", pannumber);
    formdata.append("tflatNo", tflatno);
    formdata.append("ttowerNo", ttowerno);
    formdata.append("salesSource", excutiveName);
    formdata.append("ProjectName", sessionStorage.getItem('project_name'));
    formdata.append("tfloor", floorb);
    formdata.append("salesExecutiveEmail", emailExcutive);
    formdata.append("facing", facingFlat);
    formdata.append("corner", cornerbb);
    formdata.append("sig", signature);
    formdata.append('companyId',companyId)
  
    console.log('Payment Sources Block:', paymentSourcesBlock);
    // Serialize paymentSourcesBlock and append it to the form data
    formdata.append("paySources", JSON.stringify(paymentSourcesBlock));
  
    for (const [source, details] of Object.entries(paymentSourcesBlock)) {
      if (details.screenshot) {
        formdata.append(`${source}_screenshot`, details.screenshot);
      }
      if (details.chequeImage) {
        formdata.append(`${source}_chequeImage`, details.chequeImage);
      }
    }
    formdata.append("gstPercentage", gstPercentage);
    formdata.append("gstAmount", totalAmount);

    // https://buildfastvapi.emedha.in/create-customer/api/v1/add-blockform
  
    axios
      .post("https://buildfastvapi.emedha.in/create-customer/api/v1/add-blockform", formdata)
      .then((res) => {
        if (res.data.status === 200) {
          setOpenbf(false);
          setOpenblockForm(false);
          customerObjsib();
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Data is added successfully!",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              return;
            }
          });
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          // Display error message from the server
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: error.response.data.error || "An error occurred. Please try again.",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          });
        } else {
          // Handle other types of errors
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "An unexpected error occurred. Please try again later.",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          });
        }
        console.error("Error adding block form:", error);
      });
  };
  



  const [customerRessib, setCustomerResponsesib] = React.useState([]);

  const customerObjsib = () => {
    axios
      .get("https://buildfastvapi.emedha.in/create-customer/api/v1/getblockform")
      .then((res) => {
        setCustomerResponsesib(res.data);
      });
  };

  console.log(customerRessib)


  const customerSet = new Set(
    customerRessib.map(({ name, mobile }) => `${name}:${mobile}`)
  );
  
  // Filter sitevisit data
  const filteredSiteVisit = data.filter(item => {
    const key = `${item.name}:${item.mobile}`;
    return !customerSet.has(key);
  });
  
  console.log(filteredSiteVisit);

  const [validatedblock,setValidatedblockForm]=useState(false)
  const [openblockForm,setOpenblockForm]=useState(false)


  const handleClickOpenblockForm=()=>{
    setOpenblockForm(true);
  }

  const handleCloseBlockForm=()=>{
    setOpenblockForm(false)
  }


  const formValidationblockForm = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Please fill out all required fields.',
        // footer: '<a href="#">Why do I see this message?</a>',
        customClass: {
          container: 'swal2-container' // Custom class for z-index control
        }
      });
    } else {
      add_blockform();
    }

    setValidatedblockForm(true);
  };


  const [validatedBulkUplaod,setValidatedBulkUpload]=useState(false)
  const [openBulkUploadForm,setOpenBulkUploadForm]=useState(false)


  const handleClickOpenBulkUploadForm=()=>{
    setOpenBulkUploadForm(true);
  }

  const handleCloseBulkUploadForm=()=>{
    setOpenBulkUploadForm(false)
  }


  const formValidationBulkUplaodForm = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      bulkuploadHandle();
    }

    setValidatedBulkUpload(true);
  };

  const[bfile,setBfile] = useState(null)
  // const bulkuploadhandle = () => {
  //   const data = new FormData()
  //   data.append("excel", bfile)
  //   axios.post('http://localhost:3002/addmemberbulk',data)
  //   .then((res) => {
  //     if (res.data.status === 200) {
  //         toggleOpen1();
  //         Swal.fire({
  //             icon: 'success',
  //             title: 'Success',
  //             text: 'Data submitted successfully!',
  //         }).then(() => {
  //           window.location.reload();
  //       });
  //     }
  // })
  // .catch((error) => {
  //     console.error('Error:', error);
  // });
  // }


  const bulkuploadHandle = () => {
    if (bfile) { // Check if file is selected
      const data = new FormData();
      data.append("excel", bfile);

      axios.post('https://buildfastvapi.emedha.in/api/v1/addmemberbulk', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        if (res.data.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Data submitted successfully!',
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: res.data.message || 'An error occurred.',
          });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to upload file.',
        });
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Please select a file to upload.',
      });
    }
  };


  const [Validatedbok, setValidatedbok] = useState(false);
  const [validatedbook,setValidatedbookForm]=useState(false)

  const [openbok, setOpenbok] = useState(false);
  const [openbookForm,setOpenbookForm]=useState(false)

  const handleClickOpenbok = () => {
    setOpenbok(true);
  };

  const handleClickOpenbookForm=()=>{
    setOpenbookForm(true);
  }

  const handleCloseBookForm=()=>{
    setOpenbookForm(false)
  }

  const handleClosebok = () => {
    setOpenbok(false);
  };

  const formValidationbok = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      bookcus();
    }

    setValidatedbok(true);
  };


  
  const [ValidatedbokOne, setValidatedbokOne] = useState(false);
  const [validatedbookOne,setValidatedbookFormOne]=useState(false)

  const [openbokOne, setOpenbokOne] = useState(false);
  const [openbookFormOne,setOpenbookFormOne]=useState(false)

  const handleClickOpenbokOne = () => {
    setOpenbokOne(true);
  };

  const handleClickOpenbookFormOne=()=>{
    setOpenbookFormOne(true);
  }

  const handleCloseBookFormOne=()=>{
    setOpenbookFormOne(false)
  }

  const handleClosebokOne = () => {
    setOpenbokOne(false);
  };

  const formValidationbokOne = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      bookcus();
    }

    setValidatedbokOne(true);
  };



  const formValidationbookForm = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      bookcus();
    }

    setValidatedbookForm(true);
  };

  const [pnameb, setPNameb] = useState("");
  const [blockTotal,setBlockAmt]=useState("")
  const [capname,setCapName]=useState("")
  const [Pemailb, setPEmailb] = useState("");
  const [pmobileb, setPMobileb] = useState("");
  const [alternatemobb, setAlternateMobb] = useState("");
  const [aadharnumberb, setAadharNumberb] = useState("");
  const [pannumberb, setPanNumberb] = useState("");
  const [addressb, setAddressb] = useState("");
  const [currentaddressb, setCurrentAddressb] = useState("");
  const [amountpaidb,setAmountPaidb] = useState("");
  const [towerb, setTowerb] = useState("");
  const [floorb, setFloorb] = useState("");
  const [flatnob, setFlatNob] = useState("");
  const [facingb, setFacingbb] = useState("");
  console.log(facingb)
  const [b, setCornerb] = useState("");

  const [financeTypeb, setFinanceTypeb] = useState("");
  
    
  const [paymentSources, setPaymentSources] = useState({
    UPI: { transactionId: "", screenshot: null, amtPaid: "" },
    Bank: { transactionId: "", screenshot: null, amtPaid: "" },
    Cheque: { chequeNumber: "", chequeImage: null, amtPaid: "" },
    Online: { transferDetails: "", screenshot: null, amtPaid: "" },
  });

  const [selectedPayments, setSelectedPayments] = useState([]);

  const [gstPercentageBook, setGstPercentageBook] = useState(0);
  const [totalAmountBook, setTotalAmountBook] = useState(0);


  const handlePaymentSourceChange = (e) => {
    const { value } = e.target;
    setSelectedPayments(prev =>
      prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
    );
  };

  const handleInputChange = (e, source, field) => {
    const { value } = e.target;
    setPaymentSources(prev => ({
      ...prev,
      [source]: { ...prev[source], [field]: value }
    }));
    calculateTotalAmountBook(gstPercentageBook)

  };

  const handleFileChange = (e, source, field) => {
    setPaymentSources(prev => ({
      ...prev,
      [source]: { ...prev[source], [field]: e.target.files[0] }
    }));
  };


  


  const handleGstChangeBook = (e) => {
    const percentage = parseFloat(e.target.value) || 0;
    setGstPercentageBook(percentage);
    calculateTotalAmountBook(percentage);
  };

  const calculateTotalAmountBook = (gst) => {
    let total = 0;
    selectedPayments.forEach(paymentSource => {
      if (paymentSources[paymentSource]?.amtPaid) {
        total += parseFloat(paymentSources[paymentSource].amtPaid);
      }
    });
    const gstAmount = (total * gst) / 100;
    setTotalAmountBook(total + gstAmount);
  };


  const [paymentSourcesBlock, setPaymentSourcesBlock] = useState({
    UPI: { transactionId: "", screenshot: null, amtPaid: "" },
    Bank: { transactionId: "", screenshot: null, amtPaid: "" },
    Cheque: { chequeNumber: "", chequeImage: null, amtPaid: "" },
    Online: { transferDetails: "", screenshot: null, amtPaid: "" },
  });

  const [selectedPaymentsBlock, setSelectedPaymentsBlock] = useState([]);

  const handlePaymentSourceChangeBlock = (e) => {
    const { value } = e.target;
    setSelectedPaymentsBlock(prev =>
      prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
    );
  };

  

  const handleFileChangeBlock = (e, source, field) => {
    setPaymentSourcesBlock(prev => {
      const updated = {
        ...prev,
        [source]: { ...prev[source], [field]: e.target.files[0] }
      };
      console.log('Updated File State:', updated); // Add this line
      return updated;
    });
  };
  

  // const handleInputChangeBlock = (e, source, field) => {
  //   const { value } = e.target;
  //   setPaymentSourcesBlock(prev => {
  //     const updated = {
  //       ...prev,
  //       [source]: { ...prev[source], [field]: value }
  //     };
  //     console.log('Updated State:', updated); // Add this line
  //     return updated;
  //   });
 
  // };

  const handleInputChangeBlock = (e, source, field) => {
    const { value, type, files } = e.target;
    setPaymentSourcesBlock(prev => ({
      ...prev,
      [source]: {
        ...prev[source],
        [field]: type === "file" ? files[0] : value
      }
    }));
    calculateTotalAmount(gstPercentage);
  };
  


  // https://buildfastvapi.emedha.in/create-customer/api/v1/get-blockform-details
  

  const getdetlsb = (value) => {
    axios
      .post(
        "https://buildfastvapi.emedha.in/create-customer/api/v1/get-blockform-details",
        {
          value,
        }
      )
      .then((res) => {
        setPNameb(res.data.name);
        setBlockAmt(res.data.blockTotal)
        console.log(res.data.blockTotal)
        setPMobileb(res.data.mobile);
        setPEmailb(res.data.email);
        setAlternateMobb(res.data.alternateMobile);
        setAddressb(res.data.permanentAddress);
        setCurrentAddressb(res.data.addComm);
        setAadharNumberb(res.data.aadharNo);
        setPanNumberb(res.data.panNo);
        setFlatNob(res.data.tflatNo);
        setTowerb(res.data.ttowerNo);
        setFloorb(res.data.tfloor);
        console.log(res.data.tfloor)
        setFacingbb(res.data.facing)
        console.log(res.data.facing)
      });
  };

  //   https://buildfastvapi.emedha.in/create-customer/api/v1/customer

  // const bookcus = () => {
  //   axios
  //     .post("http://localhost:3003/customer", {
  //       customerName: pnameb,
  //       mobileNumber: pmobileb,
  //       email: Pemailb,
  //       floor: floorb,
  //       flatNo: flatnob,
  //       Tower: towerb,
  //       Cornor: b,
  //       addres: addressb,
  //       curAddres: currentaddressb,
  //       aadharNo: aadharnumberb,
  //       panNo: pannumberb,
  //       amtPaid: amountpaidb,
  //       loan: financeTypeb,
  //       aadharImg: aadharImg,
  //       panImg: panImg,
  //     })
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setOpenbok(false);
  //         customerObj();
  //         Swal.fire({
  //           icon: "success",
  //           title: "Success !",
  //           text: "Data is added successfully !",
  //           confirmButtonColor: "rgb(126, 110, 228)",
  //           cancelButtonColor: "#d33",
  //           showCancelButton: false,
  //           confirmButtonText: "Ok",
  //         }).then((result) => {
  //           if (result.value) {
  //             return;
  //           }
  //         });
  //       }
  //     });
  // };

  const [cpname,setCpname]=useState()

  console.log(cpname)

  const [cpmobile,setcpmobile]=useState()
  const [cpemail,setcpemail]=useState()
  const [reraNo,setReraNo]=useState()
  const [cpaadhar,setCpAadharNumber]=useState()


  const add_channelp = () => {
    // Assuming cpname, cpmobile, cpemail, reraNo, cpaadhar are defined and have values
  
    const requestData = {
      name: cpname,
      mobile: cpmobile,
      email: cpemail,
      rerano: reraNo,
      aadhar: cpaadhar,
      projectName:Pname,
    };
  
    console.log('Request Data:', requestData); // Optional: Log the request data for debugging https://buildfastvapi.emedha.in/api/v1/add-channelp
  
    // http://localhost:3002/add-channelp

    axios
      .post('https://buildfastvapi.emedha.in/api/v1/add-channelp', requestData)
      .then((res) => {
        console.log('Response from server:', res.data); // Optional: Log response for debugging
        if (res.data.success) {
          setOpenChannelPForm(false);
  
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Data is added successfully!',
            confirmButtonColor: 'rgb(126, 110, 228)',
            cancelButtonColor: '#d33',
            showCancelButton: false,
            confirmButtonText: 'Ok',
          }).then((result) => {
            if (result.value) {
              // Optional: Perform any additional actions after success
            }
          });
        } else {
          // Handle server response indicating failure if needed
          console.error('Error adding channel partner:', res.data.message);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to add channel partner. Please try again.',
            confirmButtonColor: 'rgb(126, 110, 228)',
            cancelButtonColor: '#d33',
            showCancelButton: false,
            confirmButtonText: 'Ok',
          });
        }
      })
      .catch((error) => {
        console.error('Error adding channel partner:', error);
        // Handle error scenarios (e.g., show error message to the user)
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Failed to add channel partner. Please try again.',
          confirmButtonColor: 'rgb(126, 110, 228)',
          cancelButtonColor: '#d33',
          showCancelButton: false,
          confirmButtonText: 'Ok',
        });
      });
  };

  const [validatedChannelP,setValidatedChannelPForm]=useState(false)
  const [openChannerlPForm,setOpenChannelPForm]=useState(false)


  const handleClickChannelPForm=()=>{
    setOpenChannelPForm(true);
  }

  const handleCloseChannelPForm=()=>{
    setOpenChannelPForm(false)
  }


  const formValidationChannelPForm = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      add_channelp();
    }

    setValidatedChannelPForm(true);
  };






const [carPark,setCarPark]=useState('')
const [errorMessage, setErrorMessage] = useState('')

const [transactionIdb, setTransactionIdBok] = useState("");
const [screenshotb, setScreenshotBok] = useState("");

const [paymentsourceb, setPaymentSourceBok] = useState("");
const [chequenumberb, setChequeNumberBok] = useState("");
const [transferdetailsb, setTransferDetailsBok] = useState("");

  // const bookcus = () => {
  //   const formData = new FormData();
  //   formData.append("customerName", pnameb);
  //   formData.append("mobileNumber", pmobileb);
  //   formData.append("email", Pemailb);
  //   formData.append("floor", floorb);
  //   formData.append("flatNo", flatnob);
  //   formData.append("Tower", towerb);
  //   formData.append("Cornor", Corner);
  //   formData.append("addres", addressb);
  //   formData.append("curAddres", currentaddressb);
  //   formData.append("aadharNo", aadharnumberb);
  //   formData.append("panNo", pannumberb);
  //   formData.append("amtPaid", amountpaidb);
  //   formData.append("loan", financeTypeb);
  //   formData.append("ProjectName", Pname);
  //   formData.append("salesSource", salessource);
  //   formData.append("salesExecutiveEmail", emailExcutive);
  //   formData.append("crmExecutive", CrmExecutive);
  //   formData.append("carPark",carPark)
  //   formData.append('transactionId',transactionIdb);
  //   formData.append('screenshot',screenshotb);
  //   formData.append("paySource", paymentsourceb);
  //   formData.append("cheqNo", chequenumberb);
  //   formData.append("transferDetail", transferdetailsb);
  //   if (aadharImg) formData.append("aadharImg", aadharImg);
  //   if (panImg) formData.append("panImg", panImg);

  //   if (financeTypeb === "Customized") {
  //     formData.append("installmentDetails", JSON.stringify(installments));
  //   }
  //   // https://buildfastvapi.emedha.in/create-customer/api/v1/customer

  //   axios
  //     .post(
  //       "http://localhost:3003/customer",

  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setOpenbok(false);
  //         setOpenbookForm(false)
  //         customerObj();
  //         Swal.fire({
  //           icon: "success",
  //           title: "Success!",
  //           text: "Data is added successfully!",
  //           confirmButtonColor: "rgb(126, 110, 228)",
  //           cancelButtonColor: "#d33",
  //           showCancelButton: false,
  //           confirmButtonText: "Ok",
  //         }).then((result) => {
  //           if (result.value) {
  //             return;
  //           }
  //         });
  //       } else {
  //         setErrorMessage("Failed to add data. Please try again later.");
  //         setOpenbookForm(false)
  //         Swal.fire({
  //           icon: "error",
  //           title: "Error!",
  //           text: errorMessage,
  //           confirmButtonColor: "rgb(126, 110, 228)",
  //           cancelButtonColor: "#d33",
  //           showCancelButton: false,
  //           confirmButtonText: "Ok",
  //         });
  //         console.error("Error adding customer data:", errorMessage);
  //       }
  //     })
  //     .catch((error) => {
  //       setOpenbookForm(false)
  //       setErrorMessage("Failed to add data. Please try again later.");
  //       Swal.fire({
  //         icon: "error",
  //         title: "Error!",
  //         text: errorMessage,
  //         confirmButtonColor: "rgb(126, 110, 228)",
  //         cancelButtonColor: "#d33",
  //         showCancelButton: false,
  //         confirmButtonText: "Ok",
  //       });
  //       console.error("Error adding customer data:", error);
  //     });

        
    
  // };


  // const projectType=sessionStorage.getItem('project_type')


  //04-12-2024


  // const bookcus = () => {
  //   const formData = new FormData();
  
  //   formData.append("customerName", pnameb);
  //   formData.append("coapplicantName",capname)
  //   formData.append("mobileNumber", pmobileb);
  //   formData.append("email", Pemailb);
  //   formData.append("floor", floorb);
  //   formData.append("flatNo", flatnob);
  //   formData.append("Tower", towerb);
  //   formData.append("Cornor", Corner);
  //   formData.append("addres", addressb);
  //   formData.append("curAddres", currentaddressb);
  //   formData.append("aadharNo", aadharnumberb);
  //   formData.append("panNo", pannumberb);

  //   formData.append("loan", financeTypeb);
  //   formData.append("ProjectName", sessionStorage.getItem('project_name'));
  //   formData.append("salesSource", salessource);
  //   formData.append("salesExecutiveEmail", emailExcutive);
  //   formData.append("crmExecutive", CrmExecutive);
  //   formData.append("carPark", carPark);
  //   formData.append("gstPercentage", gstPercentageBook);
  //   formData.append("gstAmount", totalAmountBook);
  //   formData.append('companyId',companyId)
  
    
  //   // Add payment sources
  //   formData.append("paySources", JSON.stringify(paymentSources)); 
  //   for (const [source, details] of Object.entries(paymentSources)) {
  //     if (details.screenshot) {
  //       formData.append(`${source}_screenshot`, details.screenshot);
  //     }
  //     if (details.chequeImage) {
  //       formData.append(`${source}_chequeImage`, details.chequeImage);
  //     }
  //   }
  
    
  //   // Pay sources as an array of strings https://buildfastvapi.emedha.in/create-customer/api/v1/customer

  
  //   if (aadharImg) formData.append("aadharImg", aadharImg);
  //   if (panImg) formData.append("panImg", panImg);
   
  
  //   if (financeTypeb === "Customized") {
  //     formData.append("installmentDetails", JSON.stringify(installments));
  //   }

  //   // https://buildfastvapi.emedha.in/create-customer/api/v1/customer-villa
  
  //   axios
  //     .post(
  //       "https://buildfastvapi.emedha.in/create-customer/api/v1/customer-villa",
  //       formData,
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       if (res.data.status === 200) {
  //         setOpenbok(false);
  //         setOpenbookForm(false);
  //         setOpenbokOne(false)
  //         customerObj();
  //         Swal.fire({
  //           icon: "success",
  //           title: "Success!",
  //           text: "Data is added successfully!",
  //           confirmButtonColor: "rgb(126, 110, 228)",
  //           cancelButtonColor: "#d33",
  //           showCancelButton: false,
  //           confirmButtonText: "Ok",
  //         }).then((result) => {
  //           if (result.value) {
  //             return;
  //           }
  //         });
  //       } else {
  //         setErrorMessage("Failed to add data. Please try again later.");
  //         setOpenbookForm(false);
  //         setOpenbokOne(false)
  //         Swal.fire({
  //           icon: "error",
  //           title: "Error!",
  //           text: errorMessage,
  //           confirmButtonColor: "rgb(126, 110, 228)",
  //           cancelButtonColor: "#d33",
  //           showCancelButton: false,
  //           confirmButtonText: "Ok",
  //         });
  //         console.error("Error adding customer data:", errorMessage);
  //       }
  //     })
  //     .catch((error) => {
  //       setOpenbookForm(false);
  //       setOpenbokOne(false)
  //       setErrorMessage("Failed to add data. Please try again later.");
  //       Swal.fire({
  //         icon: "error",
  //         title: "Error!",
  //         text: errorMessage,
  //         confirmButtonColor: "rgb(126, 110, 228)",
  //         cancelButtonColor: "#d33",
  //         showCancelButton: false,
  //         confirmButtonText: "Ok",
  //       });
  //       console.error("Error adding customer data:", error);
  //     });
  // };
  

  const bookcus = () => {
    const formData = new FormData();
    
    formData.append("customerName", pnameb);
    formData.append("coapplicantName", capname);
    formData.append("mobileNumber", pmobileb);
    formData.append("email", Pemailb);
    formData.append("floor", floorb);
    formData.append("flatNo", flatnob);
    formData.append("Tower", towerb);
    formData.append("Cornor", Corner);
    formData.append("addres", addressb);
    formData.append("curAddres", currentaddressb);
    formData.append("aadharNo", aadharnumberb);
    formData.append("panNo", pannumberb);
  
    formData.append("loan", financeTypeb);
    formData.append("ProjectName", sessionStorage.getItem('project_name'));
    formData.append("salesSource", salessource);
    formData.append("salesExecutiveEmail", emailExcutive);
    formData.append("crmExecutive", CrmExecutive);
    formData.append("carPark", carPark);
    formData.append("gstPercentage", gstPercentageBook);
    formData.append("gstAmount", totalAmountBook);
    formData.append('companyId', companyId);
  
    // Add payment sources
    formData.append("paySources", JSON.stringify(paymentSources)); 
    for (const [source, details] of Object.entries(paymentSources)) {
      if (details.screenshot) {
        formData.append(`${source}_screenshot`, details.screenshot);
      }
      if (details.chequeImage) {
        formData.append(`${source}_chequeImage`, details.chequeImage);
      }
    }
  
    // Pay sources as an array of strings https://buildfastvapi.emedha.in/create-customer/api/v1/customer
  
    if (aadharImg) formData.append("aadharImg", aadharImg);
    if (panImg) formData.append("panImg", panImg);
  
    if (financeTypeb === "Customized") {
      formData.append("installmentDetails", JSON.stringify(installments));
    }
  
    // Determine the API endpoint based on project type
    const projectType = sessionStorage.getItem('project_type');
    let apiUrl = '';
  
    if (projectType === "Apartment") {
      apiUrl = "https://buildfastvapi.emedha.in/create-customer/api/v1/customer";
    } else {
      apiUrl = "https://buildfastvapi.emedha.in/create-customer/api/v1/customer-villa";
    }
  
    // Make the API request
    axios
      .post(apiUrl, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.status === 200) {
          setOpenbok(false);
          setOpenbookForm(false);
          setOpenbokOne(false);
          customerObj();
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Data is added successfully!",
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.value) {
              return;
            }
          });
        } else {
          setErrorMessage("Failed to add data. Please try again later.");
          setOpenbookForm(false);
          setOpenbokOne(false);
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: errorMessage,
            confirmButtonColor: "rgb(126, 110, 228)",
            cancelButtonColor: "#d33",
            showCancelButton: false,
            confirmButtonText: "Ok",
          });
          console.error("Error adding customer data:", errorMessage);
        }
      })
      .catch((error) => {
        setOpenbookForm(false);
        setOpenbokOne(false);
        setErrorMessage("Failed to add data. Please try again later.");
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: errorMessage,
          confirmButtonColor: "rgb(126, 110, 228)",
          cancelButtonColor: "#d33",
          showCancelButton: false,
          confirmButtonText: "Ok",
        });
        console.error("Error adding customer data:", error);
      });
  };
  

  const [customerRes, setCustomerResponse] = React.useState([]);

  // https://buildfastvapi.emedha.in/create-customer/api/v1/customers

  const customerObj = () => {
    axios
      .get("https://buildfastvapi.emedha.in/create-customer/api/v1/customers")
      .then((res) => {
        setCustomerResponse(res.data);
        console.log(customerRes)
      });
  };

  console.log(customerRes)

  const customerResSet = new Set(
    customerRes.map(({ customerName, mobileNumber, flatNo }) => `${customerName}:${mobileNumber}:${flatNo}`)
  );
  
  // Filter customerRessib data
  const filteredCustomerRessib = customerRessib.filter(item => {
    const key = `${item.name}:${item.mobile}:${item.tflatNo}`;
    return !customerResSet.has(key);
  });
  
  console.log(filteredCustomerRessib);

  //   const PrName=  sessionStorage.getItem('ProjectName')
  //   console.log(PrName)
  const Pname = sessionStorage.getItem("ProjectName");

  const [aadharImg, setAadharImg] = useState(null);
  const [panImg, setPanImg] = useState(null);

  // const [uploadAadhar, setUploadAadhar] = useState();
  // const [uploadPan, setUploadPan] = useState();

  const handleAadharImgChange = (e) => {
    setAadharImg(e.target.files[0]); // Update state with selected Aadhar image file
  };

  const handlePanImgChange = (e) => {
    setPanImg(e.target.files[0]); // Update state with selected PAN image file
  };

  // const storedName = sessionStorage.getItem("itemName");

  // const handleRowClick = (itemName) => {
  //   let clickedNames = JSON.parse(sessionStorage.getItem("clickedNames")) || [];
  //   console.log('Initial clicked names:', clickedNames); // Debug log

  //   if (!clickedNames.includes(itemName)) {
  //     clickedNames.push(itemName);
  //     sessionStorage.setItem("clickedNames", JSON.stringify(clickedNames));
  //     console.log('Updated clicked names:', clickedNames); // Debug log
  //   }
  // };

  // const clickedNames = JSON.parse(sessionStorage.getItem("clickedNames")) || [];


  const handleBookRowClick = (itemName) => {
    sessionStorage.setItem("clickedBookName", itemName);
    console.log("Stored clicked name:", itemName); // Debug log
  };

  const clickedBookName = sessionStorage.getItem("clickedBookName");
  console.log("Retrieved clicked name:", clickedName); // Debug log

  const filteredBookItems = clickedBookName
    ? customerRessib.filter((item) => item.name === clickedBookName)
    : [];


    const handleBookRowClickOne=(itemName)=>{
      sessionStorage.setItem("clickedBookNameOne", itemName);
      console.log("Stored clicked name:", itemName);
    }

    const clickedBookNameOne = sessionStorage.getItem("clickedBookNameOne");
    console.log("Retrieved clicked name:", clickedBookNameOne); // Debug log
  
    const filteredBookItemsOne = clickedBookNameOne
      ? customerRes.filter((item) => item.customerName === clickedBookNameOne)
      : [];

      console.log(filteredBookItemsOne)

  const emailExcutive = sessionStorage.getItem("emailExcutive");
  console.log(emailExcutive)
  const [projectName, setProjectName] = useState("");

  const [CrmExecutive, setCrmExecutvie] = useState("");
  const [CRMExecutiveList, setCrmList] = useState([]);

  const get_account = () => {
    axios
      .get("https://buildfastvapi.emedha.in/account-setting/api/v1/get-account")
      .then((res) => {
        if (res.data.status === 200) {
          setCrmList(res.data.data);
          console.log(res.data.data)
        }
      });
  };
  React.useEffect(() => {
    get_account();
  }, []);

  console.log(Pname)

  const crmHead = CRMExecutiveList.find(
    (executive) => executive.ProjectName === Pname && executive.UserType.includes('CRM Head')
  );

  const [installments, setInstallments] = useState([]);

  const handleFinanceTypeChange = (e) => {
    setFinanceTypeb(e.target.value);
    if (e.target.value === "Customized") {
      setInstallments([{ dueAmount: "", expectedDate: "" }]);
    } else {
      setInstallments([]);
    }
  };

  const handleInstallmentChange = (index, field, value) => {
    const newInstallments = installments.map((installment, i) => {
      if (i === index) {
        return { ...installment, [field]: value };
      }
      return installment;
    });
    setInstallments(newInstallments);
  };

  const handleInstallmentCountChange = (e) => {
    const count = parseInt(e.target.value);
    const newInstallments = Array(count)
      .fill()
      .map(() => ({ dueAmount: "", expectedDate: "" }));
    setInstallments(newInstallments);
  };

  
// const handleClickOpenCancelForm = (id) => {
//   // Send API request to update the blocked status to 'Cancelled'
//   axios.put(`https://buildfastvapi.emedha.in/create-customer/api/v1/api/updateBlockedStatus/${id}`, { status: 'Cancelled' })
//     .then(response => {
//       console.log('Status updated:', response.data);
     
//     })
//     .catch(error => {
//       console.error('Error updating status:', error);
//     });
// };



const handleClickOpenCancelForm = (id) => {
  Swal.fire({
    title: 'Are you sure?',
    text: "You are about to cancel this item!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, cancel it!',
    cancelButtonText: 'No, keep it'
  }).then((result) => {
    if (result.isConfirmed) {
      // Send API request to update the blocked status to 'Cancelled'
      axios.put(`https://buildfastvapi.emedha.in/create-customer/api/v1/api/updateBlockedStatus/${id}`, { status: 'Cancelled' })
        .then(response => {
          console.log('Status updated:', response.data);
          // Show success alert
          Swal.fire('Cancelled!', 'The status has been updated to "Cancelled".', 'success');
        })
        .catch(error => {
          console.error('Error updating status:', error);
          // Show error alert
          Swal.fire('Error!', 'An error occurred while updating the status. Please try again.', 'error');
        });
    } else {
      // User clicked "Cancel"
      Swal.fire('Cancelled', 'The status was not updated.', 'info');
    }
  });
};


const [typicalUnitdata, setUnitdatas] = useState([]);
console.log(typicalUnitdata)

const get_unitss = () => {
    axios.get("https://buildfastvapi.emedha.in/project/api/v1/get-typical-villa-units", {
        params: { projectName:
            sessionStorage.getItem("project_name") }
    })
    .then((res) => {
        setUnitdatas(res.data.data);
        console.log("Response data:", res.data);
    })
    .catch((error) => {
        console.error("Error fetching units:", error);
    });
};


const [villaUnitdata, setVillaUnitdata] = useState([]);

const get_Villa_unit = () => {
    axios.get("https://buildfastvapi.emedha.in/project/api/v1/get-villa-plots", {
        params: { projectName:sessionStorage.getItem("project_name")  }
    })
    .then((res) => {
      setVillaUnitdata(res.data.data);
        console.log("Response data:", res.data);
    })
    .catch((error) => {
        console.error("Error fetching units:", error);
    });
};


React.useEffect(()=>{
    get_unitss()
    get_Villa_unit()

},[])
   
  // apartsize


  // Reset unit size selection

  const filteredSizes = typicaluzdrop.filter(item => item.pName === Pname);


 const [uniqueFacings,setFilteredFacings]=useState([])

 const handleUnitSizeChange = (e) => {
  const unitSize = e.target.value;
  setApartSize(unitSize);

  console.log("Selected Unit Size:", unitSize);

  const facings = typicaluzdrop
    .filter(item => item.unitsize.toString() === unitSize && item.pName === Pname)
    .map(item => item.facing);

  console.log("Facings Found:", facings);


  setFilteredFacings([...new Set(facings)]);
};


const [projectNames, setProjectNames] = useState([]);

const [ProjectUser,setProjectUsers]=useState('')

const getProjectNames = () => {
  axios
    .get("https://buildfastvapi.emedha.in/project/api/v1/get-basic")
    .then((res) => {
      setProjectNames(res.data.data);
      console.log(projectName);
    })
    .catch((err) => {
      console.log(err);
    });
};

React.useEffect(() => {
  getProjectNames();
}, []);



const [maxLastDigit, setMaxLastDigit] = useState(0);
const [response3p, setResponse3p] = useState([]);
const [floorDatap, setFloorDatap] = useState([]);
const [fcnt, setFcnt] = useState(0)

    const get_floorp = (text) => {
        console.log(text)
        axios.post("https://buildfastvapi.emedha.in/project/api/v1/get-pwfloor", { text }).then((res) => {
            if (res.data.status === 200) {
                setResponse3p(res.data.data);
                console.log(res.data.data)
                console.log('floorcount', res.data.data.map((a) => a.selectType));
    
                // Correctly extract the floor number from selectType
                const maxFloorNumber = Math.max(...res.data.data.map(a => {
                 
                    // Split the string by '-' and get the last part as the floor number
                    const floorNumber = parseInt(a.selectType.split('-').pop());
                    console.log(floorNumber)
                    
                    return isNaN(floorNumber) ? 0 : floorNumber;
                }));
    
               
    
                console.log('Maximum floor number:', maxFloorNumber);
    
                setFcnt(maxFloorNumber);
                setMaxLastDigit(maxFloorNumber);
                setFloorDatap(Array.from({ length: maxFloorNumber }, () => ({ floorAmount: '' })));
            }
        });
    }

React.useEffect(()=>{
  get_floorp(Pname)
},[])



// tflatno
const [facingFlat,setFacing]=useState('')
const [cornerbb,setCronerbb]=useState('')
console.log(cornerbb)

// console.log(facingFlat)

// const handleUnitChange = (e) => {
//   const unitName = e.target.value;
//   console.log(unitName)

// setTowardsFlatNumber(unitName);

//   // Find the selected unit's facing
//   const selectedUnitData = unitdata.find((unit) => unit.unit_name === unitName);
//   setFacing(selectedUnitData ? selectedUnitData.Facing : "");
// }
// Track the selected VillaNo


const handleUnitChange = (e) => {
  const unitName = e.target.value;
  console.log("Selected Unit:", unitName);

  // Log the entire unitdata to check its structure
  console.log("Unit Data:", unitdata);

  setTowardsFlatNumber(unitName);

  // Find the selected unit's facing
  const selectedUnitData = unitdata.find((unit) => unit.unit_name === unitName);
  console.log("Selected Unit Data:", selectedUnitData);

  // Log the facing value
  const facingValue = selectedUnitData ? selectedUnitData.Facing : "";
  console.log("Facing Value:", facingValue);
  
  setFacing(facingValue);
  const foundCornor = unitdata.find((item) => item.unit_name === unitName);
  console.log(foundCornor)
    if (foundCornor) {
      setCronerbb(foundCornor.cornor); // Set cornor value if found
    } else {
      setCronerbb(""); // Set default or empty if not found
    }



    const selectedVillaNo = e.target.value; // Get selected VillaNo
    setTowardsFlatNumber(selectedVillaNo);

    // Find the corresponding villa based on selected VillaNo
    const selectedVilla = villaUnitdata.find(villa => villa.VillaNo === selectedVillaNo);

    // Set the facingFlat state with the facing value of the selected villa
    if (selectedVilla) {
      setFacing(selectedVilla.facing);
    } else {
      setFacing(""); // Clear the facing if no villa is found
    }
  

  
};

// Log facingFlat state whenever it changes
React.useEffect(() => {
  console.log("Facing Flat State Updated:", facingFlat);
}, [facingFlat]);


const [facingFlatB,setFacingB]=useState('')

const handleUnitChangeBook = (e) => {
  const unitName = e.target.value;
  console.log("Selected Unit:", unitName);

  // Log the entire unitdata to check its structure
  console.log("Unit Data:", unitdata);

  setFlatNob(unitName);

  // Find the selected unit's facing
  const selectedUnitData = unitdata.find((unit) => unit.unit_name === unitName);
  console.log("Selected Unit Data:", selectedUnitData);

  const foundCornor = unitdata.find((item) => item.unit_name === unitName);
  console.log(foundCornor)
    if (foundCornor) {
      setCronerbb(foundCornor.cornor); // Set cornor value if found
    } else {
      setCronerbb(""); // Set default or empty if not found
    }

  // Log the facing value flatnob
  const facingValue = selectedUnitData ? selectedUnitData.Facing : "";
  console.log("Facing Value:", facingValue);
  
  setFacingB(facingValue);
};

// Log facingFlat state whenever it changes 

React.useEffect(() => {
  console.log("Facing Flat State Updated:", facingFlatB);
}, [facingFlatB]);




const [cornorOptions, setCornorOptions] = useState([]);


React.useEffect(() => {
  // Build options dynamically based on typicaluzdrop data
  const options = typicaluzdrop.map(item => ({
    unitsizeNum: item.unitsizeNum,
    cornor: item.cornor
  }));

  setCornorOptions(options);
  
  // Set default selected cornor based on the first item in typicaluzdrop, if available
  if (typicaluzdrop.length > 0) {
    setCorner(typicaluzdrop[0].cornor);
  }
}, [typicaluzdrop]);

const handleCornorChange = (e) => {
  setCorner(e.target.value);
};

const isManager = sessionStorage.getItem('userType') === "Manager";


const fetchChannelPartner = async (mobile) => {
  try {
    // Replace with your actual API endpoint
    const response = await axios.get(`https://buildfastvapi.emedha.in/api/v1/channel-partners?mobile=${mobile}`);
    const partner = response.data;
    console.log(response.data)

    if (partner) {
      setCPName(partner.name);
      setCPId(partner.channelId);
    } else {
      setCPName('');
      setCPId('');
    }
  } catch (error) {
    console.error('Error fetching channel partner data', error);
    setCPName('');
    setCPId('');
  }
};

// Function to handle mobile number change
const handleMobileChange = (e) => {
  const mobile = e.target.value;
  setCPMobile(mobile);

  if (mobile) {
    fetchChannelPartner(mobile);
  } else {
    setCPName('');
    setCPId('');
  }
};

React.useEffect(()=>{
  fetchChannelPartner()
},[])


// const [isAadharVerified, setIsAadharVerified] = useState(false);
// const [aadharOTP, setAadharOTP] = useState('');
// const [otpSent, setOtpSent] = useState(false);

// const handleSendAadharOTP = async () => {
//   try {
//     const response = await fetch('http://localhost:3002/api/send-aadhar-otp', {
//       method: 'POST',
//       body: JSON.stringify({
//         aadhaarNumber: aadharnumberb, // Ensure this is correctly formatted
//       }),
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     });

//     if (response.ok) {
//       const data = await response.json();
//       if (data.success) {
//         setOtpSent(true);
//         // Handle successful OTP request
//       } else {
//         console.error('Failed to send OTP:', data.message);
//         // Handle failed OTP request
//       }
//     } else {
//       const errorData = await response.json();
//       console.error('Error sending OTP:', errorData);
//       // Handle error response
//     }
//   } catch (error) {
//     console.error('Error sending OTP:', error);
//   }
// };


// const handleVerifyAadharOTP = async () => {
//   try {
//     const response = await fetch('http://localhost:3002/api/verify-aadhar-otp', {
//       method: 'POST',
//       body: JSON.stringify({ otp: aadharOTP }), // Ensure `aadharOTP` is a valid string
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     });

//     if (response.ok) {
//       const data = await response.json();
//       if (data.success) {
//         setIsAadharVerified(true);
//         // Handle successful OTP verification
//       } else {
//         console.error('Failed to verify OTP:', data);
//         // Handle failed OTP verification
//       }
//     } else {
//       const errorData = await response.json();
//       console.error('Error verifying OTP:', errorData);
//       // Handle error response
//     }
//   } catch (error) {
//     console.error('Error verifying OTP:', error);
//   }
// };


const [isAadharVerified, setIsAadharVerified] = useState(false);
const [aadharOTP, setAadharOTP] = useState('');
const [otpSent, setOtpSent] = useState(false);


// https://buildfastvapi.emedha.in/api/v1/api/send-aadhar-otp

const handleSendAadharOTP = async () => {
  try {
    const response = await fetch('https://buildfastvapi.emedha.in/api/v1/api/send-aadhar-otp', {
      method: 'POST',
      body: JSON.stringify({
        aadhaarNumber: aadharnumberb,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const data = await response.json();
      if (data.status === 'SUCCESS') {
        setOtpSent(true); // Update state to show OTP input field
        // Handle successful OTP request
      } else {
        console.error('Failed to send OTP:', data.message);
        // Handle failed OTP request
      }
    } else {
      const errorData = await response.json();
      console.error('Error sending OTP:', errorData);
      // Handle error response
    }
  } catch (error) {
    console.error('Error sending OTP:', error);
  }
};

// https://buildfastvapi.emedha.in/api/v1/api/verify-aadhar-otp

const handleVerifyAadharOTP = async () => {
  try {
    const response = await fetch('https://buildfastvapi.emedha.in/api/v1/api/verify-aadhar-otp', {
      method: 'POST',
      body: JSON.stringify({ otp: aadharOTP }),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.status===200) {
      const data = await response.json();
      if (data.status==="VALID") {
        setIsAadharVerified(true); // Update state to show verification success
        // Handle successful OTP verification
      
      } else {
        console.error('Failed to verify OTP:', data.message);
        // Handle failed OTP verification
      }
    } else {
      const errorData = await response.json();
      console.error('Error verifying OTP:', errorData);
      // Handle error response
    }
  } catch (error) {
    console.error('Error verifying OTP:', error);
  }
};

const [carParkAmounts, setCarParkAmounts] = useState({});


React.useEffect(() => {
  // Fetch car parking amounts from the backend
  axios.get('https://buildfastvapi.emedha.in/billing/api/v1/api/car-parking-amounts', { params: { Pname } })
    .then(response => setCarParkAmounts(response.data))
    .catch(error => console.error('Error fetching car parking amounts:', error));
}, [Pname]);




// const handleCarParkChange = (e) => {
//   const selectedCarPark = e.target.value;
  
//   // Send update request only if the selection has changed
//   if (selectedCarPark !== oldCarPark) {
//     axios.put('http://localhost:4000/api/update-floor-unit', {
//       flatnob,
//       newCarParkType: selectedCarPark,
//       oldCarParkType: oldCarPark,
//       projName: Pname
//     })
//     .then(response => {
//       console.log('Floor Unit updated successfully');
//       setTotalValue(response.data.totalValue);
//       // Update oldCarPark after a successful update
//       setOldCarPark(selectedCarPark);
//     })
//     .catch(error => console.error('Error updating Floor Unit:', error));
//   }

//   setCarPark(selectedCarPark);
// };

const [amount, setCAmount] = useState(0);
const [totalValue, setTotalValue] = useState(null);
const [oldCarPark, setOldCarPark] = useState('');

const [baseTotalValue, setBaseTotalValue] = useState(null);

// // Fetch baseTotalValue when the component mounts or flatnob changes
// React.useEffect(() => {
//   if (flatnob) {
//     axios.get('http://localhost:4000/api/get-base-total-value', {
//       params: { flatnob: flatnob }
//     })
//     .then(response => {
//       if (response.data.baseTotalValue !== undefined) {
//         setBaseTotalValue(response.data.baseTotalValue);
//       } else {
//         console.error('No baseTotalValue data received');
//       }
//     })
//     .catch(error => {
//       console.error('Error fetching base total value:', error);
//     });
//   }
// }, [flatnob]);

// // Fetch car park amount and update totalValue when carPark or baseTotalValue changes
// React.useEffect(() => {
//   if (carPark && baseTotalValue !== null) {
//     axios.get('http://localhost:4000/api/get-carpark-amount', {
//       params: { flatnob: flatnob, carParkType: carPark }
//     })
//     .then(response => {
//       if (response.data.amount !== undefined) {
//         const newAmount = response.data.amount;
//         setCAmount(newAmount);

//         // Calculate updated total value
//         const updatedTotalValue = baseTotalValue + newAmount;
//         setTotalValue(updatedTotalValue);
//       } else {
//         console.error('No amount data received');
//       }
//     })
//     .catch(error => {
//       console.error('Error fetching car park amount:', error);
//     });
//   }
// }, [carPark, baseTotalValue]);

// const handleCarParkChange = (e) => {
//   const selectedCarPark = e.target.value;
//   setCarPark(selectedCarPark);
// };


// const handleAmountChange = (e) => {
//   setCAmount(parseFloat(e.target.value) || 0);
// };

// const handleUpdate = () => {
//   axios.post('http://localhost:4000/api/calculate-updated-total', {
//     flatnob: flatnob,
//     carParkType: carPark,
//     newAmount: amount
//   })
//   .then(response => {
//     if (response.data.updatedTotalValue !== undefined) {
//       setTotalValue(response.data.updatedTotalValue);
//     } else {
//       console.error('No updatedTotalValue data received');
//     }
//   })
//   .catch(error => {
//     console.error('Error calculating updated total:', error);
//   });
// };

React.useEffect(() => {
  if (flatnob) {
    axios.get('https://buildfastvapi.emedha.in/billing/api/v1/api/get-base-total-value', {
      params: { flatnob }
    })
    .then(response => {
      if (response.data.baseTotalValue !== undefined) {
        setBaseTotalValue(response.data.baseTotalValue);
        // Update total value with initial amount
        setTotalValue(response.data.baseTotalValue + amount);
      } else {
        console.error('No baseTotalValue data received');
      }
    })
    .catch(error => {
      console.error('Error fetching base total value:', error);
    });
  }
}, [flatnob]);

// Fetch car park amount and update total value when carPark changes
React.useEffect(() => {
  if (carPark && baseTotalValue !== null) {
    axios.get('https://buildfastvapi.emedha.in/billing/api/v1/api/get-carpark-amount', {
      params: { flatnob, carParkType: carPark }
    })
    .then(response => {
      if (response.data.amount !== undefined) {
        const newAmount = response.data.amount;
        setCAmount(newAmount);

        // Calculate and set the total value based on baseTotalValue and newAmount
        setTotalValue(baseTotalValue + newAmount);
      } else {
        console.error('No amount data received');
      }
    })
    .catch(error => {
      console.error('Error fetching car park amount:', error);
    });
  }
}, [carPark, baseTotalValue]);

// Handle car park type change
const handleCarParkChange = (e) => {
  const selectedCarPark = e.target.value;
  setCarPark(selectedCarPark);
};

// Handle amount input change
const handleAmountChange = (e) => {
  const newAmount = parseFloat(e.target.value) || 0;
  setCAmount(newAmount);

  // Update total value based on the new amount
  if (baseTotalValue !== null) {
    setTotalValue(baseTotalValue + newAmount);
  }
};

// Handle update button click
const handleUpdate = () => {
  axios.post('https://buildfastvapi.emedha.in/billing/api/v1/api/calculate-updated-total', {
    flatnob,
    carParkType: carPark,
    newAmount: amount
  })
  .then(response => {
    if (response.data.updatedTotalValue !== undefined) {
      setTotalValue(response.data.updatedTotalValue);
    } else {
      console.error('No updatedTotalValue data received');
    }
  })
  .catch(error => {
    console.error('Error calculating updated total:', error);
  });
};


const [openblockPop, setOpenblockPop] = useState(false);
  const [selectedCustomerblockPop, setSelectedCustomerblockPop] = useState(null);

  const handleClickOpenblockPop = (customer) => {
    setSelectedCustomerblockPop(customer);
    setOpenblockPop(true);
  };

  const handleCloseblockPop = () => {
    setOpenblockPop(false);
    setSelectedCustomerblockPop(null);
  };


  const [openBookPop, setOpenBookPop] = useState(false);
  const [selectedCustomerBookPop, setSelectedCustomerBookPop] = useState(null);

  const handleClickOpenBookPop = (customer) => {
    setSelectedCustomerBookPop(customer);
    setOpenBookPop(true);
  };

  const handleCloseBookPop = () => {
    setOpenBookPop(false);
    setSelectedCustomerBookPop(null);
  };


  return (
    <>
      <div>
        {!isVeiw && (
          <div className="leadManagementTable">
             {/* <Form.Group
                              as={Col}
                              md="12"
                              controlId="validationCustom01"
                              style={{ width: "350px",marginLeft:'25px' }}
                            >
                              <Typography
                                style={{ color: "gray", fontSize: 13 }}
                              >
                                Select Project
                              </Typography>
                              <Form.Select
                                value={ProjectUser}
                                onChange={(e) => setProjectUsers(e.target.value)}
                                style={{ padding: "0.42rem", marginBottom: 14 }}
                              >
                              
                              {projectNames.map((item) => (
                              <option
                                key={item.ProjectName}
                                value={item.ProjectName}
                              >
                                {item.ProjectName}
                              </option>
                              ))}
                           
                              </Form.Select>
                              <Form.Control.Feedback type="invalid">
                                Please Enter Valid manager
                              </Form.Control.Feedback>
                            </Form.Group> */}
            <Typography
              style={{
                color: "rgba(41, 16, 105, 1)",
                marginBottom: 6,
                marginLeft: 15.5,
                fontSize: 18,
                color: "gray",
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              Primary Details
            </Typography>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 5,
              }}
            >
          {isManager&&   <Button
                onClick={handleClickChannelPForm}
                style={{
                  width: "10rem",
                  height: "2.3rem",
                  backgroundColor: "rgb(126, 110, 228)",
                  color: "white",
                  marginRight: 10,
                }}
              >
                Channel Partner
              </Button>}
              {isManager&&   <Button
                onClick={handleClickOpenBulkUploadForm}
                style={{
                  width: "10rem",
                  height: "2.3rem",
                  backgroundColor: "rgb(126, 110, 228)",
                  color: "white",
                  marginRight: 10,
                }}
              >
                Bulk Upload
              </Button>}
               {/*  <Button
                onClick={handleClickOpenblockForm}
                style={{
                  width: "9rem",
                  height: "2.3rem",
                  backgroundColor: "rgb(126, 110, 228)",
                  color: "white",
                  marginRight: 10,
                }}
              >
                Block
              </Button> */}
              {/* <Button
                onClick={handleClickOpenbookForm}
                style={{
                  width: "9rem",
                  height: "2.3rem",
                  backgroundColor: "rgb(126, 110, 228)",
                  color: "white",
                  marginRight: 10,
                }}
              >
                Book
              </Button> */}
              {/* <Button onClick={handleClickOpensv} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'rgb(126, 110, 228)', color: 'white', marginRight:10 }}>Site Visit</Button> */}
              <Button
                onClick={() => setOpen(true)}
                style={{
                  width: "9rem",
                  height: "2.3rem",
             background: "linear-gradient(90deg, #4318ff, #6d28d9)",
                  color: "white",
                  marginRight: 10,
                  marginBottom: 10,
                }}
              >
                + Add New Lead
              </Button>
            </div>
            <Paper elevation={0}>
              {/* <TableContainer sx={{ height: 95 + "vh", p: 0.3, pt: 2 }} > */}

              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box
                    sx={{
             
                      borderColor: "divider",
                      color: "rgb(86, 63, 146)",
                    }}
                  >
<TabList
  onChange={handleChange}
  variant="scrollable"
  scrollButtons="auto"
  allowScrollButtonsMobile
  sx={{
    width: '100%',
    minHeight: 'auto', 
    '& .MuiTabs-indicator': { display: 'none' }, // Remove default underline
    '& .MuiTabs-flexContainer': {
      gap: '6px', // Tight spacing between buttons
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      minHeight: '34px', // Slim height
      minWidth: '0px',   // Remove forced wide width
      padding: '4px 10px', // Tight internal space
      borderRadius: '6px',
      fontSize: '12.5px',
      fontWeight: '500',
      color: '#707eae',
      transition: '0.2s',
      flexDirection: 'row',
      gap: '7px',
      // The "Light Border" look
      border: '1px solid #E0E5F2', 
      backgroundColor: 'white',
      whiteSpace: 'nowrap',
      opacity: 0.85,
      '&:hover': {
        backgroundColor: '#f8f9ff',
        borderColor: '#4318ff',
        opacity: 1,
      },
    },
    '& .Mui-selected': {
      // Active Button Style
      background: 'linear-gradient(135deg, #4318ff 0%, #6d28d9 100%) !important',
      color: '#fff !important',
      borderColor: 'transparent',
      boxShadow: '0px 2px 8px rgba(67, 24, 255, 0.2)',
      opacity: 1,
    },
    '& .MuiTabs-scrollButtons': {
      color: '#4318ff',
      width: '20px',
    },
  }}
>
  <Tab icon={<PersonIcon sx={{ fontSize: 17 }} />} iconPosition="start" label="Lead" value="1" />
  <Tab icon={<StarIcon sx={{ fontSize: 17 }} />} iconPosition="start" label="Interested" value="2" />
  <Tab icon={<PhoneCallbackIcon sx={{ fontSize: 17 }} />} iconPosition="start" label="Call Back" value="3" />
  <Tab icon={<ThumbDownIcon sx={{ fontSize: 17 }} />} iconPosition="start" label="Not Interested" value="4" />
  <Tab icon={<DirectionsWalkIcon sx={{ fontSize: 17 }} />} iconPosition="start" label="Site Visit" value="5" />
  <Tab icon={<BlockIcon sx={{ fontSize: 17 }} />} iconPosition="start" label="Blocked" value="6" />
  <Tab icon={<CheckCircleIcon sx={{ fontSize: 17 }} />} iconPosition="start" label="Booked" value="7" />
  <Tab icon={<BookmarkIcon sx={{ fontSize: 17 }} />} iconPosition="start" label="Saved" value="8" />
</TabList>
                  </Box>
                  <TabPanel value="1">
                    <div
                      style={{
                        height: "0.1rem",
                        marginTop:10,
                      }}
                    ></div>
                    <div
                      className="card mt-2"
                      style={{
                        border: "none",
                        paddingLeft: 15,
                        paddingRight: 15,
                        display: "flex",
    flexDirection: isLargeScreen ? "row" : "column",
    justifyContent: isLargeScreen ? "space-between" : "flex-start",
    alignItems: isLargeScreen ? "center" : "flex-start",
    gap: isLargeScreen ? "15px" : "10px"
                      }}
                    >
                      <div  style={{ flex: isLargeScreen ? "1 1 400px" : "1 1 100%" }}>
                        <input
                          onChange={(e) => leadDataSearch(e.target.value)}
                          style={{
                            height: "2.3rem",
                            color: "gray",
                            borderRadius: "0.3rem",
                            outline: "none",
                           width: "100%",
        maxWidth: isLargeScreen ? "400px" : "100%",
       
                            border: "0.7px solid lightgray",
                          }}
                          placeholder="Search..."
                        />
                      </div>
                      <div>
                        {/* <Button onClick={() => setOpen(true)} style={{ width: '9rem', height: '2.3rem', backgroundColor: 'rgb(126, 110, 228)', color: 'white' }}>+ Add New Lead</Button> */}
                        <div
                          style={{
      display: "flex",
      justifyContent: isLargeScreen ? "flex-end" : "flex-end",
      width: isLargeScreen ? "auto" : "100%",
      fontWeight: "bold",
      marginTop: isLargeScreen ? 0 : "10px"
    }}
                        >
                          Total Leads :{" "}
                          {data.filter(item => {
        const isSuperAdmin = sessionStorage.getItem("superAdmin");
        const isManager = sessionStorage.getItem('userType') === "Manager";
        const isAdmin= sessionStorage.getItem('userType') === "Admin"; 

        const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";

        const basicConditions =
          item.intrestTab !== 1 &&
          item.notIntrstTab !== 1 &&
          item.callBackTab !== 1 &&
          item.sitevistTab !== 1 &&
          item.company_id===parseInt(companyId) 

          const projectType = sessionStorage.getItem("project_type");
          let additionalConditions;
if (projectType === "Villa") {
// If the project type is "Villa", check against PrName
additionalConditions = item.ProjectName === sessionStorage.getItem("project_name");

} else {
// If the project type is not "Villa", check against the value stored in sessionStorage for project_name
additionalConditions = item.ProjectName === PrName;
}
          console.log(additionalConditions)

        const executiveConditions =
          item.salesExecutiveEmail === emailExcutive &&
          item.salesExecutive === excutiveName;

        if (isSuperAdmin) {
          return basicConditions;
        } else if (executiveConditions && additionalConditions && basicConditions) {
          return true; // For specific executives
        } else if (basicConditions && additionalConditions && isManager) {
          return true; // For managers
        }  else if (basicConditions && additionalConditions && isAdmin) {
          return true; // For Admin
        }
        
        else {
          return false; // Other roles or conditions
        }
      }).length}
    </div>
      
              
                      </div>
                    </div>
                    <TableContainer component={Paper} sx={{ 
  boxShadow: 'none', 
  border: 'none', 
  mt: 2, 
  overflowX: 'auto', // This is the magic for mobile responsiveness
  '&::-webkit-scrollbar': { height: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
}}>
                  
                    <Table style={{ position: "relative", top: "1.3rem" }}>
                      <TableHead sx={{ borderTop: "1px solid lightgray" }}>
                        <TableRow>
                          {/* <TableCell
                                            align={"start"}
                                            style={{ minWidth: 0, fontSize: 14, fontWeight: '600' }}
                                        >
                                            Lead
                                        </TableCell> */}
                          <TableCell
                            align={"start"}
                            style={{
                              minWidth: 0,
                              fontSize: 14,
                              fontWeight: "600",
                            }}
                          >
                            Name
                          </TableCell>
                          
                        
                          <TableCell
                            align={"start"}
                            style={{
                              minWidth: 0,
                              fontSize: 14,
                              fontWeight: "600",
                            }}
                          >
                            Call
                          </TableCell>
                          {/* <TableCell

                                            align={"start"}
                                            style={{ top: 57, fontWeight: '600' }}
                                        >
                                            Whatsapp Mobile
                                        </TableCell> */}
                          <TableCell
                            align={"left"}
                            style={{ top: 57, fontWeight: "600" }}
                          >
                            Gender
                          </TableCell>
                          <TableCell
                            align={"start"}
                            style={{
                              minWidth: 0,
                              fontSize: 14,
                              fontWeight: "600",
                            }}
                          >
                            Location
                          </TableCell>
                          <TableCell
                            align={"left"}
                            style={{ top: 57, fontWeight: "600" }}
                          >
                            Created Date
                          </TableCell>
                          <TableCell
                            align={"start"}
                            style={{
                              minWidth: 0,
                              fontSize: 14,
                              fontWeight: "600",
                            }}
                          >
                            Source Type
                          </TableCell>
                          <TableCell
        align={"start"}
        style={{ minWidth: 0, fontSize: 14, fontWeight: "600" }}
      >
        Channel Partner
      </TableCell>
                          <TableCell
                            align={"start"}
                            style={{
                              minWidth: 0,
                              fontSize: 14,
                              fontWeight: "600",
                            }}
                          >
                            Comment
                          </TableCell>

                          <TableCell
                            align={"left"}
                            style={{ top: 21, fontWeight: "600", width: 21 }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                      
                          {data
  .filter((item) => {
    const isSuperAdmin = sessionStorage.getItem("superAdmin");
    const isManager = sessionStorage.getItem('userType') === "Manager"; 
    console.log(isManager)
    const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
    console.log(isAdmin)
    const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
    console.log( item.salesExecutiveEmail === emailExcutive)
    
    const basicConditions = 
      item.intrestTab !== 1 &&
      item.notIntrstTab !== 1 &&
      item.callBackTab !== 1 &&
      item.sitevistTab !== 1&&
      item.company_id===parseInt(companyId)

      const projectType = sessionStorage.getItem("project_type");
      let additionalConditions;
if (projectType === "Villa") {
// If the project type is "Villa", check against PrName
additionalConditions = item.ProjectName === sessionStorage.getItem("ProjectName");

} else {
// If the project type is not "Villa", check against the value stored in sessionStorage for project_name
additionalConditions = item.ProjectName === PrName;
}
      console.log(additionalConditions)

      const executiveCondtions=  item.salesExecutiveEmail === emailExcutive&&
      item.salesExecutive===excutiveName ;
      localStorage.setItem("executiveCondtions",executiveCondtions)

    if (isSuperAdmin) {
      return basicConditions;
    } else if (
      (executiveCondtions && additionalConditions&& basicConditions)
     
    ) {

      return true; // For managers
    }   else if  (
        (basicConditions && additionalConditions && isManager)

    ){
return true
    } else if  (
      (basicConditions && additionalConditions && isAdmin)

  ){
return true
  }
     else {
      return false; // Other roles or conditions
    }
  })




                          .map((item) => (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={item.Id}
                            >
                            
                              <TableCell
                                align={"start"}
                                style={{ top: 57, fontSize: 12 }}
                              >
                                {item.name}
                                {/* <FaUserAlt style={{ marginRight: 3, color: 'rgb(126, 110, 228)', marginTop: '-0.16rem', fontSize: 9 }}/> */}
                              </TableCell>
                              <TableCell
                                align={"start"}
                                style={{ top: 57, fontSize: 12 }}
                              >
                                <a
                                  href={`tel:${item.mobile}`}
                                  style={{
                                    textAlign: "center",
                                    marginTop: "20px",
                                  }}
                                >
                                  <FaPhone />
                                </a>
                                {/* <FaUserAlt style={{ marginRight: 3, color: 'rgb(126, 110, 228)', marginTop: '-0.16rem', fontSize: 9 }}/> */}
                              </TableCell>
                              <TableCell
                                align={"start"}
                                style={{ top: 57, fontSize: 12 }}
                              >
                                {item.gender}
                              </TableCell>
                              <TableCell
                                align={"start"}
                                style={{ top: 57, fontSize: 12 }}
                              >
                                {item.location}
                              
                              </TableCell>
                              <TableCell
                                align={"start"}
                                style={{ top: 57, fontSize: 12, width: 100 }}
                              >
                                {item.pretime}
                              </TableCell>
                              <TableCell
                                align={"start"}
                                style={{ top: 57, fontSize: 12 ,width: 70 }}
                              >
                                {item.sourceType}
                                {/* <FaUserAlt style={{ marginRight: 3, color: 'rgb(126, 110, 228)', marginTop: '-0.16rem', fontSize: 9 }}/> */}
                              </TableCell>
                              <TableCell
            align={"start"}
            style={{ top: 57, fontSize: 12 }}
          >
            {item.channelPartner === "Yes" ? item.cpName : "No"}
          </TableCell>
                             
<TableCell
                                align={"start"}
                                style={{ top: 57, fontSize: 12, width: 100 }}
                              >
                                {item.commentBox}
                              </TableCell>
                           
                             

                              <TableCell
                                align={"start"}
                                style={{
                                  top: 57,
                                  fontSize: 12,
                                  color: "rgb(126, 110, 228) ",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <div style={{ cursor: "pointer", marginRight: 10, }}>
                                    <Badge
                                      bg="success"
                                      onClick={() => {
                                        setId(item.Id);
                                        handleClickOpeni();
                                      }}
                                    >
                                      Interested
                                    </Badge>
                                  </div>

                                  <div
                                      style={{
                                        marginRight: 10,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Badge
                                        bg="warning"
                                        onClick={() => {
                                          handleClickOpensv();
                                          setId(item.Id);
                                    
                                        }}
                                      >
                                        Site Visit
                                      </Badge>
                                    </div>
                                 
                                  <div
                                    style={{
                                      marginLeft: 10,
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Badge
                                      bg="secondary"
                                      onClick={() => {
                                        setId(item.Id);
                                        handleClickOpenc();
                                      }}
                                    >
                                      Callback
                                    </Badge>
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: 10,
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Badge
                                      bg="danger"
                                      onClick={() => {
                                        handleClickOpenin();
                                        setId(item.Id);
                                      }}
                                    >
                                      Not Interested
                                    </Badge>
                                  </div>
                                  {/* {
                                                            (sessionStorage.getItem('Delete') === '1' || sessionStorage.getItem('superAdmin')) && (

                                                                <Button onClick={() => deleteAlert(item.Id)} style={{ backgroundColor: 'red', color: 'white', fontSize: 11, height: '1.7rem', position: 'relative', top: '0.4rem', left: '-0.2rem' }} >Delete</Button>
                                                            )
                                                        } */}
                                  {/* <div>
                                                                    <IconButton
                                                                        id="fade-button"
                                                                        aria-controls={open2 ? 'fade-menu' : undefined}
                                                                        aria-haspopup="true"
                                                                        aria-expanded={open2 ? 'true' : undefined}
                                                                        onClick={(e) => {
                                                                            handleClick(e.currentTarget)
                                                                            setId(item.Id)
                                                                        }}
                                                                    >
                                                                        <MoreVertIcon />
                                                                    </IconButton>
                                                                    <Menu
                                                                        id="fade-menu"
                                                                        MenuListProps={{
                                                                            'aria-labelledby': 'fade-button',
                                                                        }}
                                                                        anchorEl={anchorEl}
                                                                        open={open2}
                                                                        onClose={handleClose2}
                                                                        TransitionComponent={Fade}
                                                                    >
                                                                        {
                                                                            (sessionStorage.getItem('Edit') === '1' || sessionStorage.getItem('superAdmin')) && (
                                                                                <MenuItem style={{ color: 'gray' }} onClick={() => {

                                                                                    handleClose2()
                                                                                    viewData(id)
                                                                                    setOpen1(true)
                                                                                }}><FaEdit style={{ marginRight: 4 }} /> Edit</MenuItem>
                                                                            )
                                                                        }
                                                                        {
                                                                            (sessionStorage.getItem('View') === '1' || sessionStorage.getItem('superAdmin')) && (
                                                                                <MenuItem style={{ color: 'gray' }} onClick={() => {
                                                                                    viewData(id)
                                                                                    handleClose2()
                                                                                    setIsVeiw(true)
                                                                                }}><FaEye style={{ marginRight: 4 }} /> View</MenuItem>
                                                                            )

                                                                        }


                                                                        {
                                                                            (sessionStorage.getItem('Delete') === '1' || sessionStorage.getItem('superAdmin')) && (

                                                                                <MenuItem onClick={() => deleteAlert(id)} style={{ color: 'gray' }} ><FaTrash style={{ marginRight: 4 }} /> Delete</MenuItem>
                                                                            )
                                                                        }
                                                                <MenuItem onClick={handleClickOpeni} style={{ color: 'gray' }} > Interested</MenuItem>
                                                                <MenuItem onClick={handleClickOpenc} style={{ color: 'gray' }} > Call Back</MenuItem>
                                                                <MenuItem onClick={handleClickOpenin} style={{ color: 'gray' }} > Not Interested</MenuItem>


                                                                    </Menu>
                                                                </div> */}
                                </div>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
</TableContainer>
                    {data.length === 0 && (
                      <Box
                        className="card"
                        style={{
                          border: "none",
                          height: "58vh",
                          width: "100%",
                          boxShadow: "none",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src="https://cdn-icons-png.flaticon.com/128/2291/2291944.png"
                          width="145px"
                        />
                        <Typography>0 customers</Typography>
                      </Box>
                    )}

                    {/* </TableContainer> */}
                    {/* </Paper> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        height: 56,
                        marginTop: 16,
                      }}
                    >
                      <Pagination
                        count={Math.ceil(data.length / page)}
                        page={cpage}
                        onChange={pagehandle}
                        color="secondary"
                        sx={{ "& .Mui-selected": { backgroundColor: "#6d28d9" } }}
                      />
                    </div>
                  </TabPanel>
                  {/* </TabPanel> */}
                  <TabPanel value="2">
                  
                    
                      <div style={{ fontWeight: "bold" }}>
                        Total Interested Leads :{" "}
                        {data
        .filter(item => {
          const isSuperAdmin = sessionStorage.getItem("superAdmin");
          const isManager = sessionStorage.getItem('userType') === "Manager";
          
          const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
          console.log(isAdmin)
          const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";

          const basicConditions = item.intrestTab === 1 && item.sitevistTab !== 1 && item.blockTab !== 1 && item.company_id=== parseInt(companyId);

          const projectType = sessionStorage.getItem("project_type");
          let additionalConditions;
if (projectType === "Villa") {
// If the project type is "Villa", check against PrName
additionalConditions = item.ProjectName === sessionStorage.getItem("ProjectName");

} else {
// If the project type is not "Villa", check against the value stored in sessionStorage for project_name
additionalConditions = item.ProjectName === PrName;
}
          console.log(additionalConditions)

          const executiveConditions = item.salesExecutiveEmail === emailExcutive &&
            item.salesExecutive === excutiveName;

          if (isSuperAdmin) {
            return basicConditions;
          } else if (executiveConditions && additionalConditions && basicConditions) {
            return true; // For specific executives
          } else if (isManager) {
            return basicConditions && additionalConditions;
          } else if (isAdmin) {
            return basicConditions && additionalConditions;
          }
          
          else {
            return false; // Other roles or conditions
          }
        })
        .length}
                      </div>
                    <TableContainer component={Paper} sx={{ 
  boxShadow: 'none', 
  border: 'none', 
  mt: 2, 
  overflowX: 'auto', // This is the magic for mobile responsiveness
  '&::-webkit-scrollbar': { height: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
}}>
      
                      <Table style={{ position: "relative", top: "1.3rem" }}>
                        <TableHead sx={{ borderTop: "1px solid lightgray" }}>
                          <TableRow>
                            <TableCell
                              align={"start"}
                             style={{
    fontSize: 14,
    fontWeight: "600",
    paddingTop: 8,
    paddingBottom: 8,
  }}
                            >
                              Name
                            </TableCell>
                            <TableCell
                              align={"start"}
                             style={{
    fontSize: 14,
    fontWeight: "600",
    paddingTop: 8,
    paddingBottom: 8,
  }}
                            >
                              Email
                            </TableCell>
                            <TableCell
                              align={"start"}
                              style={{
    fontSize: 14,
    fontWeight: "600",
    paddingTop: 8,
    paddingBottom: 8,
  }}
                            >
                              Mobile
                            </TableCell>
                            <TableCell
                              align={"start"}
                             style={{
    fontSize: 14,
    fontWeight: "600",
    paddingTop: 8,
    paddingBottom: 8,
  }}
                            >
                              Call
                            </TableCell>

                            <TableCell
                              align={"left"}
                            style={{
    fontSize: 14,
    fontWeight: "600",
    paddingTop: 8,
    paddingBottom: 8,
  }}
                            >
                              Comment
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{
    fontSize: 14,
    fontWeight: "600",
    paddingTop: 8,
    paddingBottom: 8,
  }}
                            >
                              Date of site visit
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600", width: 21 }}
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {data
  .filter((item) => {
    const isSuperAdmin = sessionStorage.getItem("superAdmin");
    const isManager = sessionStorage.getItem('userType') === "Manager"; 
    console.log(isManager)
    
    const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
    console.log(isAdmin)
    const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
    console.log( item.salesExecutiveEmail === emailExcutive)
    
    // const basicConditions = item.intrestTab === 1 && item.sitevistTab !== 1 && item.blockTab !== 1

    const basicConditions = item.intrestTab === 1 && item.blockTab !== 1 && item.company_id=== parseInt(companyId)

    const projectType = sessionStorage.getItem("project_type");
    let additionalConditions;
if (projectType === "Villa") {
// If the project type is "Villa", check against PrName
additionalConditions = item.ProjectName === sessionStorage.getItem("ProjectName");

} else {
// If the project type is not "Villa", check against the value stored in sessionStorage for project_name
additionalConditions = item.ProjectName === PrName;
}
    console.log(additionalConditions)

      const executiveCondtions=  item.salesExecutiveEmail === emailExcutive&&
      item.salesExecutive===excutiveName ;

    if (isSuperAdmin) {
      return basicConditions;
    } else if (
      (executiveCondtions && additionalConditions&& basicConditions)
     
    ) {

      return true; // For managers
    }   else if (isManager ) {
      return basicConditions && additionalConditions
    }   else if (isAdmin) {
      return basicConditions && additionalConditions
    }
    
    else {
      return false; // Other roles or conditions
    }
  })

                            .sort(
                              (a, b) =>
                                new Date(b.intrestDate) -
                                new Date(a.intrestDate)
                            )
                            .map((item) => (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={item.Id}
                              >
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {item.name}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.email}`}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                   {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.mobile}`}
                                </TableCell>

                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  <a
                                    href={`tel:${item.mobile}`}
                                    style={{ textAlign: "center" }}
                                  >
                                    <FaPhone />
                                  </a>
                                  {/* <FaUserAlt style={{ marginRight: 3, color: 'rgb(126, 110, 228)', marginTop: '-0.16rem', fontSize: 9 }}/> */}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {item.intrestComment}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12, width: 100 }}
                                >
                                  {moment(item.intrestDate).format(
                                    "MMM DD, YYYY hh:mm A"
                                  )}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{
                                    top: 57,
                                    fontSize: 12,
                                    color: "rgb(126, 110, 228) ",
                                  }}
                                >
                                  <div style={{ display: "flex" }}>
                                    <div
                                      style={{
                                        marginRight: 10,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Badge
                                        bg="warning"
                                        onClick={() => {
                                          handleClickOpensv();
                                          setId(item.Id);
                                    
                                        }}
                                      >
                                        Site Visit
                                      </Badge>
                                    </div>
                                    <Badge
                                            bg="primary"
                                            style={{ cursor: "pointer" ,marginRight: 10, }}
                                            onClick={() => {
                                              setId(item.Id);
                                              handleRowClick(item.name);
                                              handleClickOpenbf();
                                              
                                            }}
                                          >
                                            Block
                                          </Badge>
                                    <div
                                      style={{
                                        marginRight: 10,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Badge
                                        bg="secondary"
                                        onClick={() => {
                                          handleClickOpenc();
                                          setId(item.Id);
                                        }}
                                      >
                                        Call Back
                                      </Badge>
                                    </div>
                                    <div
                                      style={{
                                        marginRight: 10,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Badge
                                        bg="danger"
                                        onClick={() => {
                                          handleClickOpenin();
                                          setId(item.Id);
                                        }}
                                      >
                                        Not Interested
                                      </Badge>
                                    </div>
                                  </div>

                                  <div style={{ display: "flex" }}>
                                    {/* <div>
                                                                                <IconButton
                                                                                    id="fade-button"
                                                                                    aria-controls={open2 ? 'fade-menu' : undefined}
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded={open2 ? 'true' : undefined}
                                                                                    onClick={(e) => {
                                                                                        handleClick(e.currentTarget)
                                                                                        setId(item.Id)
                                                                                    }}
                                                                                >
                                                                                    <MoreVertIcon />
                                                                                </IconButton>
                                                                                <Menu
                                                                                    id="fade-menu"
                                                                                    MenuListProps={{
                                                                                        'aria-labelledby': 'fade-button',
                                                                                    }}
                                                                                    anchorEl={anchorEl}
                                                                                    open={open2}
                                                                                    onClose={handleClose2}
                                                                                    TransitionComponent={Fade}
                                                                                >
                                                                                    {
                                                                                        (sessionStorage.getItem('Edit') === '1' || sessionStorage.getItem('superAdmin')) && (
                                                                                            <MenuItem style={{ color: 'gray' }} onClick={handleClickOpensv}> Site Visit</MenuItem>
                                                                                        )
                                                                                    }
                                                                                    
                                                                                            <MenuItem style={{ color: 'gray' }} onClick={handleClickOpenc}>Call Back</MenuItem>
                                                                                        


                                                                                    

                                                                                            <MenuItem onClick={handleClickOpenin} style={{ color: 'gray' }} > Not Interested</MenuItem>
                                                                                       

                                                                                </Menu>
                                                                            </div> */}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
</TableContainer>
                     
        
                  </TabPanel>
                  <TabPanel value="3">

                      <Typography
                        style={{
                          color: "rgba(41, 16, 105, 1)",
                          marginBottom: 3,
                          marginLeft: 15.5,
                          fontSize: 18,
                          color: "gray",
                          fontWeight: "500",
                          textAlign: "center",
                        }}
                      >
                        Call Back
                      </Typography>
                      <div style={{ fontWeight: "bold" }}>
                        Total CallBack Leads :{" "}
                        {data
        .filter(item => {
          const isSuperAdmin = sessionStorage.getItem("superAdmin");
          const isManager = sessionStorage.getItem('userType') === "Manager";
          const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
          console.log(isAdmin)
          const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";

          const basicConditions = item.callBackTab === 1 && item.company_id===parseInt(companyId);

          const projectType = sessionStorage.getItem("project_type");
          let additionalConditions;
if (projectType === "Villa") {
// If the project type is "Villa", check against PrName
additionalConditions = item.ProjectName === sessionStorage.getItem("ProjectName");

} else {
// If the project type is not "Villa", check against the value stored in sessionStorage for project_name
additionalConditions = item.ProjectName === PrName;
}
          console.log(additionalConditions)

          const executiveConditions = item.salesExecutiveEmail === emailExcutive &&
            item.salesExecutive === excutiveName;

          if (isSuperAdmin) {
            return basicConditions;
          } else if (executiveConditions && additionalConditions && basicConditions) {
            return true; // For specific executives
          } else if (isManager) {
            return basicConditions && additionalConditions;
          }else if (isAdmin) {
            return basicConditions && additionalConditions;
          }
          
          else {
            return false; // Other roles or conditions
          }
        })
        .length}
                      </div>
   <TableContainer component={Paper} sx={{ 
  boxShadow: 'none', 
  border: 'none', 
  mt: 2, 
  overflowX: 'auto', // This is the magic for mobile responsiveness
  '&::-webkit-scrollbar': { height: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
}}>
                      <Table style={{ position: "relative", top: "1.3rem" }}>
                        <TableHead sx={{ borderTop: "1px solid lightgray" }}>
                          <TableRow>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Name
                            </TableCell>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Email
                            </TableCell>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Mobile
                            </TableCell>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Call
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 57, fontWeight: "600" }}
                            >
                              Comment
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{ top: 57, fontWeight: "600" }}
                            >
                              Date of Call Back
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600", width: 21 }}
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {data
  .filter((item) => {
    const isSuperAdmin = sessionStorage.getItem("superAdmin");
    const isManager = sessionStorage.getItem('userType') === "Manager"; 
    console.log(isManager)
    const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
    console.log(isAdmin)
    const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
    console.log( item.salesExecutiveEmail === emailExcutive)
    
    const basicConditions =   item.callBackTab === 1 && item.company_id===parseInt(companyId)

    const projectType = sessionStorage.getItem("project_type");
          let additionalConditions;
if (projectType === "Villa") {
// If the project type is "Villa", check against PrName
additionalConditions = item.ProjectName === sessionStorage.getItem("ProjectName");

} else {
// If the project type is not "Villa", check against the value stored in sessionStorage for project_name
additionalConditions = item.ProjectName === PrName;
}
          console.log(additionalConditions)

      const executiveCondtions=  item.salesExecutiveEmail === emailExcutive&&
      item.salesExecutive===excutiveName ;

    if (isSuperAdmin) {
      return basicConditions;
    } else if (
      (executiveCondtions && additionalConditions&& basicConditions)
     
    ) {

      return true; // For managers
    }   else if (isManager ) {
      return basicConditions && additionalConditions
    }  else if (isAdmin ) {
      return basicConditions && additionalConditions
    } 
    
    else {
      return false; // Other roles or conditions
    }
  })
                            .sort(
                              (a, b) => new Date(b.cbDate) - new Date(a.cbDate)
                            )
                            .map((item) => (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={item.Id}
                              >
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {item.name}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.email}`}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                   {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.mobile}`}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  <a
                                    href={`tel:${item.mobile}`}
                                    style={{
                                      textAlign: "center",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <FaPhone />
                                  </a>
                                  {/* <FaUserAlt style={{ marginRight: 3, color: 'rgb(126, 110, 228)', marginTop: '-0.16rem', fontSize: 9 }}/> */}
                                </TableCell>

                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {item.cbComment}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12, width: 100 }}
                                >
                                  {moment(item.cbDate).format(
                                    "MMM DD, YYYY hh:mm A"
                                  )}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{
                                    top: 57,
                                    fontSize: 12,
                                    color: "rgb(126, 110, 228) ",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-around",
                                    }}
                                  >
                                     <div style={{ cursor: "pointer"  ,marginRight: 10, }}>
                                    <Badge
                                      bg="success"
                                      onClick={() => {
                                        setId(item.Id);
                                        handleClickOpeni();
                                      }}
                                    >
                                      Interested
                                    </Badge>
                                  </div>
                                  <div
                                      style={{
                                        marginRight: 10,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Badge
                                        bg="warning"
                                        onClick={() => {
                                          handleClickOpensv();
                                          setId(item.Id);
                                    
                                        }}
                                      >
                                        Site Visit
                                      </Badge>
                                    </div>
                                    <div
                                      style={{
                                        marginRight: 10,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Badge
                                        bg="secondary"
                                        onClick={() => {
                                          setId(item.Id);
                                          handleClickOpenc();
                                        }}
                                      >
                                        Call Back{" "}
                                      </Badge>
                                    </div>
                                    <div
                                      style={{
                                        marginRight: 10,
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Badge
                                        bg="danger"
                                        onClick={() => {
                                          setId(item.Id);
                                          handleClickOpenin();
                                        }}
                                      >
                                        Not Interested
                                      </Badge>
                                    </div>
                                    {/* <div>
                                                                                <IconButton
                                                                                    id="fade-button"
                                                                                    aria-controls={open2 ? 'fade-menu' : undefined}
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded={open2 ? 'true' : undefined}
                                                                                    onClick={(e) => {
                                                                                        handleClick(e.currentTarget)
                                                                                        setId(item.Id)
                                                                                    }}
                                                                                >
                                                                                    <MoreVertIcon />
                                                                                </IconButton>
                                                                                <Menu
                                                                                    id="fade-menu"
                                                                                    MenuListProps={{
                                                                                        'aria-labelledby': 'fade-button',
                                                                                    }}
                                                                                    anchorEl={anchorEl}
                                                                                    open={open2}
                                                                                    onClose={handleClose2}
                                                                                    TransitionComponent={Fade}
                                                                                >
                                                                                    {
                                                                                        (sessionStorage.getItem('Edit') === '1' || sessionStorage.getItem('superAdmin')) && (
                                                                                            <MenuItem style={{ color: 'gray' }} onClick={() => {

                                                                                                // handleClose2()
                                                                                                // viewData(id)
                                                                                                // setOpen1(true)
                                                                                            }}> CallBack Again</MenuItem>
                                                                                        )
                                                                                    }

{
                                                                                        (sessionStorage.getItem('Edit') === '1' || sessionStorage.getItem('superAdmin')) && (
                                                                                            <MenuItem style={{ color: 'gray' }} onClick={handleClickOpenin}>Not Interested</MenuItem>
                                                                                        )
                                                                                    }
                                                                                    
                                                                                </Menu>
                                                                            </div> */}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
</TableContainer>
                      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', height: 56, marginTop: 16 }}>
                                                <Pagination count={Math.ceil(data.length / page)} page={cpage} onChange={pagehandle} color="secondary" sx={{ "& .Mui-selected": { backgroundColor: "blue" } }} />
                                            </div> */}
         
                  </TabPanel>
                  <TabPanel value="4">

                
                      <div style={{ fontWeight: "bold" }}>
                        Total Not Interested Leads :{" "}
                        {data
  .filter((item) => {
    const isSuperAdmin = sessionStorage.getItem("superAdmin");
    const isManager = sessionStorage.getItem('userType') === "Manager"; 
    console.log(isManager)
    const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
          console.log(isAdmin)
    const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
    console.log( item.salesExecutiveEmail === emailExcutive)
    
    const basicConditions = item.notIntrstTab === 1 && item.company_id === parseInt(companyId)

    const additionalConditions = 
      item.ProjectName === PrName;

      const executiveCondtions=  item.salesExecutiveEmail === emailExcutive&&
      item.salesExecutive===excutiveName ;

    if (isSuperAdmin) {
      return basicConditions;
    } else if (
      (executiveCondtions && additionalConditions&& basicConditions)
     
    ) {

      return true; // For managers
    }   else if (isManager ) {
      return basicConditions && additionalConditions
    }  else if (isAdmin) {
      return basicConditions && additionalConditions
    } 
    
    else {
      return false; // Other roles or conditions
    }
  }).length}
                      </div>
   <TableContainer component={Paper} sx={{ 
  boxShadow: 'none', 
  border: 'none', 
  mt: 2, 
  overflowX: 'auto', // This is the magic for mobile responsiveness
  '&::-webkit-scrollbar': { height: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
}}>
                      <Table style={{ position: "relative", top: "1.3rem" }}>
                        <TableHead sx={{ borderTop: "1px solid lightgray" }}>
                          <TableRow>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Name
                            </TableCell>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Email
                            </TableCell>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Mobile
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 57, fontWeight: "600" }}
                            >
                              Gender
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{ top: 57, fontWeight: "600" }}
                            >
                              Comment
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600", width: 21 }}
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {data
  .filter((item) => {
    const isSuperAdmin = sessionStorage.getItem("superAdmin");
    const isManager = sessionStorage.getItem('userType') === "Manager"; 
    console.log(isManager)
    const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
    console.log(isAdmin)
    const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
    console.log( item.salesExecutiveEmail === emailExcutive)
    
    const basicConditions = item.notIntrstTab === 1 && item.company_id === parseInt(companyId);

    const additionalConditions = 
      item.ProjectName === PrName;

      const executiveCondtions=  item.salesExecutiveEmail === emailExcutive&&
      item.salesExecutive===excutiveName ;

    if (isSuperAdmin) {
      return basicConditions;
    } else if (
      (executiveCondtions && additionalConditions&& basicConditions)
     
    ) {

      return true; // For managers
    }   else if (isManager ) {
      return basicConditions && additionalConditions
    }   else if (isAdmin ) {
      return basicConditions && additionalConditions
    }
    
    else {
      return false; // Other roles or conditions
    }
  })
                            .map((item) => (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={item.Id}
                              >
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {item.name}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.email}`}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                   {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.mobile}`}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {item.gender}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12, width: 100 }}
                                >
                                  {item.notintrstComment}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{
                                    top: 57,
                                    fontSize: 12,
                                    color: "rgb(126, 110, 228) ",
                                  }}
                                >
                                  <Badge
                                    bg="success"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setId(item.Id);
                                      convrtintr();
                                    }}
                                  >
                                    Move to Intrest
                                  </Badge>

                                  <div style={{ display: "flex" }}>
                                    {/* <div>
                                                                                <IconButton
                                                                                    id="fade-button"
                                                                                    aria-controls={open2 ? 'fade-menu' : undefined}
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded={open2 ? 'true' : undefined}
                                                                                    onClick={(e) => {
                                                                                        handleClick(e.currentTarget)
                                                                                        setId(item.Id)
                                                                                    }}
                                                                                >
                                                                                    <MoreVertIcon />
                                                                                </IconButton>
                                                                                <Menu
                                                                                    id="fade-menu"
                                                                                    MenuListProps={{
                                                                                        'aria-labelledby': 'fade-button',
                                                                                    }}
                                                                                    anchorEl={anchorEl}
                                                                                    open={open2}
                                                                                    onClose={handleClose2}
                                                                                    TransitionComponent={Fade}
                                                                                >
                                                                                   
                                                                                    {
                                                                                        (sessionStorage.getItem('View') === '1' || sessionStorage.getItem('superAdmin')) && (
                                                                                            <MenuItem style={{ color: 'gray' }} onClick={convrtintr}>Move To Intrest</MenuItem>
                                                                                        )

                                                                                    }


                                                                                  

                                                                                </Menu>
                                                                            </div> */}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
</TableContainer>
                     
     
                  </TabPanel>


                  <TabPanel value="5">

                      <Typography
                        style={{
                          color: "rgba(41, 16, 105, 1)",
                          marginBottom: 3,
                          marginLeft: 15.5,
                          fontSize: 18,
                          color: "gray",
                          fontWeight: "500",
                          textAlign: "center",
                        }}
                      >
                        Site Visit
                      </Typography>
                      <div style={{ fontWeight: "bold" }}>
                        Total Site Visit :{" "}
                        {filteredSiteVisit
        .filter(item => {
          const isSuperAdmin = sessionStorage.getItem("superAdmin");
          const isManager = sessionStorage.getItem('userType') === "Manager";
          const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
          const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";

          const basicConditions =
            item.callBackTab !== 1 &&
            item.notIntrstTab !== 1 &&
            item.sitevistTab === 1 &&
            item.company_id === parseInt(companyId)

            const projectType = sessionStorage.getItem("project_type");
            let additionalConditions;
if (projectType === "Villa") {
  // If the project type is "Villa", check against PrName
  additionalConditions = item.ProjectName === sessionStorage.getItem("ProjectName");
  
} else {
  // If the project type is not "Villa", check against the value stored in sessionStorage for project_name
  additionalConditions = item.ProjectName === PrName;
}
            console.log(additionalConditions)
 

          const executiveConditions =
            item.salesExecutiveEmail === emailExcutive &&
            item.salesExecutive === excutiveName;

          if (isSuperAdmin) {
            return basicConditions;
          } else if (executiveConditions && additionalConditions && basicConditions) {
            return true; // For specific executives
          } else if (isManager) {
            return basicConditions && additionalConditions;
          }else if (isAdmin) {
            return basicConditions && additionalConditions;
          }
           else {
            return false; // Other roles or conditions
          }
        })
        .length}
                      </div>
                         <TableContainer component={Paper} sx={{ 
  boxShadow: 'none', 
  border: 'none', 
  mt: 2, 
  overflowX: 'auto', // This is the magic for mobile responsiveness
  '&::-webkit-scrollbar': { height: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
}}>

                      <Table style={{ position: "relative", top: "1.3rem" }}>
                        <TableHead sx={{ borderTop: "1px solid lightgray" }}>
                          <TableRow>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Name
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{ top: 57, fontWeight: "600" }}
                            >
                              Mobile
                            </TableCell>
                            <TableCell
                              align={"start"}
                              style={{ top: 57, fontWeight: "600" }}
                            >
                              Call
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Occupation
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Budget
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600", width: 18 }}
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                        {filteredSiteVisit
  .filter((item) => {
    const isSuperAdmin = sessionStorage.getItem("superAdmin");
    const isManager = sessionStorage.getItem('userType') === "Manager"; 
    console.log(isManager)
    const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
    
    const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
    console.log( item.salesExecutiveEmail === emailExcutive)
    
    const basicConditions = item.callBackTab !== 1 && item.notIntrstTab !== 1 && item.sitevistTab === 1 && item.company_id === parseInt(companyId)

    const projectType = sessionStorage.getItem("project_type");
    let additionalConditions;
if (projectType === "Villa") {
// If the project type is "Villa", check against PrName
additionalConditions = item.ProjectName === sessionStorage.getItem("ProjectName");

} else {
// If the project type is not "Villa", check against the value stored in sessionStorage for project_name
additionalConditions = item.ProjectName === PrName;
}
    console.log(additionalConditions)


      const executiveCondtions=  item.salesExecutiveEmail === emailExcutive&&
      item.salesExecutive===excutiveName ;

    if (isSuperAdmin) {
      return basicConditions;
    } else if (
      (executiveCondtions && additionalConditions&& basicConditions)
     
    ) {

      return true; // For managers
    }   else if (isManager ) {
      return basicConditions && additionalConditions
    }   else if (isAdmin ) {
      return basicConditions && additionalConditions
    }
    else {
      return false; // Other roles or conditions
    }
  })
                            .map((item) => (
                              <TableRow
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                key={item.Id}
                                onClick={() => {
                                  console.log("Row clicked:", item.name); // Debug log
                                }}
                              >
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {item.name}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  <button
                                    style={{
                                      fontSize: 10.7,
                                      border: "2px solid rgb(126, 110, 228)",
                                      backgroundColor: "white",
                                      borderRadius: "1.2rem",
                                      cursor: "auto",
                                    }}
                                  >
                                    <FaMobileAlt
                                      style={{
                                        marginRight: 3,
                                        color: "rgb(126, 110, 228)",
                                        marginTop: "-0.16rem",
                                        fontSize: 9,
                                      }}
                                    />
                                   
                                   {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.mobile}`}
                              
                                  </button>
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  <a
                                    href={`tel:${item.mobile}`}
                                    style={{
                                      textAlign: "left",
                                      marginTop: "20px",
                                    }}
                                  >
                                    <FaPhone />
                                  </a>
                                  {/* <FaUserAlt style={{ marginRight: 3, color: 'rgb(126, 110, 228)', marginTop: '-0.16rem', fontSize: 9 }}/> */}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  {item.Occupation}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12, width: 100 }}
                                >
                                  {item.budget}
                                </TableCell>
                                <TableCell
                                  align={"start"}
                                  style={{
                                    top: 57,
                                    fontSize: 12,
                                    color: "rgb(126, 110, 228) ",
                                  }}
                                >
                                  <div>
                                    <Popup
                                      trigger={
                                        <button>
                                          <BsThreeDotsVertical />{" "}
                                        </button>
                                      }
                                      position="bottom center"
                                    >
                                      <div className="d-flex">
                                        <div
                                          style={{
                                            marginRight: 10,
                                            cursor: "pointer",
                                          }}
                                        >
                                          <Badge
                                            bg="secondary"
                                            onClick={() => {
                                              setId(item.Id);
                                              handleClickOpenc();
                                            }}
                                          >
                                            Call Back
                                          </Badge>
                                        </div>
                                        <div
                                          style={{
                                            marginRight: 10,
                                            cursor: "pointer",
                                          }}
                                        >
                                          <Badge
                                            bg="danger"
                                            onClick={() => {
                                              handleClickOpenin();
                                              setId(item.Id);
                                            }}
                                          >
                                            Not Interested
                                          </Badge>
                                          <div
                                            style={{
                                              marginRight: 10,
                                              cursor: "pointer",
                                            }}
                                          >
                                            {" "}
                                          </div>

                                          <Badge
                                            bg="dark"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              setId(item.Id);
                                              handleRowClick(item.name);
                                              handleClickOpenbf();
                                              
                                            }}
                                          >
                                            Block
                                          </Badge>
                                        </div>
                                      </div>
                                    </Popup>
                                  </div>
                                  <div style={{ display: "flex" }}>
                                    {/* <Badge bg="dark" style={{cursor:'pointer'}} onClick={()=>{
                                                                     setId(item.Id)
                                                                    handleClickOpenbf()
                                                                    }} >Block</Badge> */}
                                    {/* <div>
                                                                                <IconButton
                                                                                    id="fade-button"
                                                                                    aria-controls={open2 ? 'fade-menu' : undefined}
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded={open2 ? 'true' : undefined}
                                                                                    onClick={(e) => {
                                                                                        handleClick(e.currentTarget)
                                                                                        setId(item.Id)
                                                                                    }}
                                                                                >
                                                                                    <MoreVertIcon />
                                                                                </IconButton>
                                                                                <Menu
                                                                                    id="fade-menu"
                                                                                    MenuListProps={{
                                                                                        'aria-labelledby': 'fade-button',
                                                                                    }}
                                                                                    anchorEl={anchorEl}
                                                                                    open={open2}
                                                                                    onClose={handleClose2}
                                                                                    TransitionComponent={Fade}
                                                                                >
                                                                                   
                                                                                    {
                                                                                        (sessionStorage.getItem('View') === '1' || sessionStorage.getItem('superAdmin')) && (
                                                                                            <MenuItem style={{ color: 'gray' }} onClick={handleClickOpenbf}>Block</MenuItem>
                                                                                        )

                                                                                    }


                                                                                  

                                                                                </Menu>
                                                                            </div> */}
                                  </div>
                                </TableCell>
                              </TableRow>
                            ))}
                        </TableBody>
                      </Table>
                      </TableContainer>

                      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', height: 56, marginTop: 16 }}>
                                                <Pagination count={Math.ceil(data.length / page)} page={cpage} onChange={pagehandle} color="secondary" sx={{ "& .Mui-selected": { backgroundColor: "blue" } }} />
                                            </div> */}
            
                  </TabPanel>

                  <TabPanel value="6">
        
                      <Typography
                        style={{
                          color: "rgba(41, 16, 105, 1)",
                          marginBottom: 3,
                          marginLeft: 15.5,
                          fontSize: 18,
                          color: "gray",
                          fontWeight: "500",
                          textAlign: "center",
                        }}
                      >
                        Blocked
                      </Typography>
                      <div style={{ fontWeight: "bold" }}>
                        Total Blocked:  {filteredCustomerRessib &&
        filteredCustomerRessib
          .filter(item => {
            const isSuperAdmin = sessionStorage.getItem("superAdmin");
            const isManager = sessionStorage.getItem('userType') === "Manager";
            const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
            console.log(isAdmin)
            const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";

            // const basicConditions = item.status === "Approved";
            const projectType = sessionStorage.getItem("project_type");
            let additionalConditions;
if (projectType === "Villa") {
  // If the project type is "Villa", check against PrName
  additionalConditions = item.ProjectName === sessionStorage.getItem("ProjectName");
  
} else {
  // If the project type is not "Villa", check against the value stored in sessionStorage for project_name
  additionalConditions = item.ProjectName === PrName;
}
            console.log(additionalConditions)
            const executiveConditions = item.salesExecutiveEmail === emailExcutive &&
              item.salesSource === excutiveName;

            if (isSuperAdmin) {
              // For super admins, no filtering is applied
              return item.company_id===parseInt(companyId);
            } else if (executiveConditions && additionalConditions ) {
              return true; // For specific executives
            } else if (isManager) {
              return additionalConditions;
            } 
            else if (isAdmin) {
              return additionalConditions;
            }
            
            else {
              return false; // Other roles or conditions where filtering is not needed
            }
          })
          .length}
                      </div>
                         <TableContainer component={Paper} sx={{ 
  boxShadow: 'none', 
  border: 'none', 
  mt: 2, 
  overflowX: 'auto', // This is the magic for mobile responsiveness
  '&::-webkit-scrollbar': { height: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
}}>
                      <Table style={{ position: "relative", top: "1.3rem" }}>
  <TableHead sx={{ borderTop: "1px solid lightgray" }}>
    <TableRow>
      <TableCell
        align={"start"}
        style={{
          minWidth: 0,
          fontSize: 14,
          fontWeight: "600",
        }}
      >
        Name
      </TableCell>
      <TableCell
        align={"left"}
        style={{ top: 57, fontWeight: "600" }}
      >
        Mobile
      </TableCell>
      <TableCell
        align={"left"}
        style={{ top: 21, fontWeight: "600" }}
      >
        Aadhar
      </TableCell>
      <TableCell
        align={"left"}
        style={{ top: 21, fontWeight: "600" }}
      >
        Address
      </TableCell>
      <TableCell
        align={"left"}
        style={{ top: 21, fontWeight: "600", width: 18 }}
      >
        Tower
      </TableCell>
      <TableCell
        align={"left"}
        style={{ top: 21, fontWeight: "600", width: 18 }}
      >
        FlatNo
      </TableCell>
      {/* <TableCell
        align={"left"}
        style={{ top: 21, fontWeight: "600", width: 18 }}
      >
        Status
      </TableCell> */}
      <TableCell
        align={"left"}
        style={{ top: 21, fontWeight: "600", width: 18 }}
      >
       Block Status
      </TableCell>
      <TableCell
        align={"left"}
        style={{ top: 21, fontWeight: "600", width: 18 }}
      >
        Payments
      </TableCell>
      <TableCell
        align={"left"}
        style={{ top: 21, fontWeight: "600", width: 18 }}
      >
        Action
      </TableCell>
    </TableRow>
  </TableHead>
  <TableBody>
    {filteredCustomerRessib &&
      filteredCustomerRessib
        .filter((item) => {
          const isSuperAdmin = sessionStorage.getItem("superAdmin");
          const isManager = sessionStorage.getItem('userType') === "Manager"; 
          const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
          console.log(isAdmin)
          const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
          const basicConditions = item.status === "Approved" || item.status === "Rejected" || (!item.status);
          const projectType = sessionStorage.getItem("project_type");
          let additionalConditions;
if (projectType === "Villa") {
// If the project type is "Villa", check against PrName
additionalConditions = item.ProjectName === sessionStorage.getItem("project_name");

} else {
// If the project type is not "Villa", check against the value stored in sessionStorage for project_name  item.status === "Approved"
additionalConditions = item.ProjectName === PrName;
}
          console.log(additionalConditions)

          const executiveCondtions = item.salesExecutiveEmail === emailExcutive && item.salesSource === excutiveName;

          if (isSuperAdmin) {
            return item.company_id===parseInt(companyId);
          } else if (executiveCondtions && additionalConditions && basicConditions) {
            return true;
          } else if (isManager) {
            return basicConditions && additionalConditions;
          } 
          else if (isAdmin) {
            return basicConditions && additionalConditions;
          }
          else {
            return false;
          }
        })
        .map((item) => (
          <TableRow
            hover
            role="checkbox"
            tabIndex={-1}
            key={item.Id}
        
          >
            <TableCell
              align={"start"}
              style={{ top: 57, fontSize: 12 }}
            >
             <Button style={{height:'28px'}} onClick={() => handleClickOpenblockPop(item)}>{item.name}</Button>
            </TableCell>
            <TableCell
              align={"start"}
              style={{ top: 57, fontSize: 12, width:'250px' }}
            >
              <button
                style={{
                  fontSize: 10.7,
                  border: "2px solid rgb(126, 110, 228)",
                  backgroundColor: "white",
                  borderRadius: "1.2rem",
                  cursor: "auto",
                }}
              >
                <FaMobileAlt
                  style={{
                    marginRight: 3,
                    color: "rgb(126, 110, 228)",
                    marginTop: "-0.16rem",
                    fontSize: 9,
                  }}
                />
                 {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.mobile}`}
              </button>
            </TableCell>
            <TableCell
              align={"start"}
              style={{ top: 57, fontSize: 12 }}
            >
              {item.aadharNo}
            </TableCell>
            <TableCell
              align={"start"}
              style={{ top: 57, fontSize: 12 }}
            >
              {item.permanentAddress}
            </TableCell>
            <TableCell
              align={"start"}
              style={{ top: 57, fontSize: 12 ,width:'180px'}}
            >
              {item.ttowerNo}
            </TableCell>
            <TableCell
              align={"start"}
              style={{ top: 57, fontSize: 12,width:'280px' }}
            >
              {item.tflatNo}
            </TableCell>
            {/* <TableCell
              align={"start"}
              style={{
                top: 57,
                fontSize: 12,
                color: item.overall_status === "Approved" ? "green" : item.overall_status === "Rejected" ? "red" : "orange",
                fontWeight: "bold",
              }}
            >
              {item.overall_status}
            </TableCell> */}
            <TableCell
            align={"start"}
            style={{
              top: 57,
              fontSize: 12,
              color: item.blockedStatus === "Cancelled" ? "red" : "green",
            }}
          >
            {item.blockedStatus === "Cancelled" ? "Cancelled" : "Active"}
          </TableCell>
            <TableCell
  align={"start"}
  style={{ top: 57, fontSize: 12 }}
>
  {/* Payment details */}
  {item.bank_amtPaid && (
    <div className='d-flex flex-row align-items-center'>
      <div className='mr-2'>Bank: ₹{item.bank_amtPaid}</div>
      <div>Status: {item.bank_status}</div>
    </div>
  )}
  {item.cheque_amtPaid && (
    <div  className='d-flex flex-row align-items-center'>
      <div className='mr-2'>Cheque: ₹{item.cheque_amtPaid}</div>
      <div>Status: {item.cheque_status}</div>
    </div>
  )}
  {item.online_amtPaid && (
    <div  className='d-flex flex-row align-items-center'>
      <div className='mr-2'>Online: ₹{item.online_amtPaid}</div>
      <div>Status: {item.online_status}</div>
    </div>
  )}
  {item.upi_amtPaid && (
    <div  className='d-flex flex-row align-items-center'>
      <div className='mr-2'>UPI: ₹{item.upi_amtPaid}</div>
      <div >Status: {item.upi_status}</div>
    </div>
  )}
</TableCell>

            <TableCell
              align={"start"}
              style={{
                top: 57,
                fontSize: 12,
                color: "rgb(126, 110, 228) ",
              }}
            >
              <div style={{ display: "flex" }}>
              <Badge
                bg={item.blockedStatus === "Cancelled" ? "danger" : "primary"}
                style={{
                  cursor: item.blockedStatus === "Cancelled" ? "not-allowed" : "pointer",
                  opacity: item.blockedStatus === "Cancelled" ? 0.5 : 1,
                }}
                onClick={() => {
                  if (item.blockedStatus !== "Cancelled") {
                    handleClickOpenbok();
                    handleBookRowClick(item.name);
                    setId(item.Id);
                  }
                }}
              >
                Book
              </Badge>
                {isManager&&   <Badge
                onClick={()=>handleClickOpenCancelForm(item.id)}
                bg="primary"
                style={{
                  marginLeft:'8px',
                 cursor: "pointer"
                  
                }}
              >
                Cancel
              </Badge>}
              </div>
            </TableCell>
          </TableRow>
        ))}
  </TableBody>
</Table>
</TableContainer>


                      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', height: 56, marginTop: 16 }}>
                                                <Pagination count={Math.ceil(data.length / page)} page={cpage} onChange={pagehandle} color="secondary" sx={{ "& .Mui-selected": { backgroundColor: "blue" } }} />
                                            </div> */}
           
                  </TabPanel>


                  <TabPanel value="7">
           
                      <Typography
                        style={{
                          color: "rgba(41, 16, 105, 1)",
                          marginBottom: 3,
                          marginLeft: 15.5,
                          fontSize: 18,
                          color: "gray",
                          fontWeight: "500",
                          textAlign: "center",
                        }}
                      >
                        Booked
                      </Typography>
                      <div style={{ fontWeight: "bold" }}>
                        Total Booked:       {customerRes &&
        customerRes
        .filter((item) => {
          const isSuperAdmin = sessionStorage.getItem("superAdmin");
          const isManager = sessionStorage.getItem('userType') === "Manager"; 
          const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
          const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
          const basicConditions = item.status === "approved" || item.status==="Rejected" ||  (!item.status);
          const projectType = sessionStorage.getItem("project_type");
            let additionalConditions;
if (projectType === "Villa") {
  // If the project type is "Villa", check against PrName
  additionalConditions = item.ProjectName === sessionStorage.getItem("project_name");
  
} else {
  // If the project type is not "Villa", check against the value stored in sessionStorage for project_name
  additionalConditions = item.ProjectName === PrName;
}
            console.log(additionalConditions)
          const executiveConditions = item.salesExecutiveEmail === emailExcutive;

          if (isSuperAdmin) {
            return item.company_id ===parseInt(companyId);
          } else if (executiveConditions && additionalConditions && basicConditions) {
            return true;
          } else if (isManager) {
            return basicConditions && additionalConditions;
          }

          else if (isAdmin) {
            return basicConditions && additionalConditions;
          }
          
          else {
            return false;
          }
        })
          .length}
                      </div>

                      {/* <Table style={{ position: "relative", top: "1.3rem" }}>
                        <TableHead sx={{ borderTop: "1px solid lightgray" }}>
                          <TableRow>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Name
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{ top: 57, fontWeight: "600" }}
                            >
                              Mobile
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Aadhar
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Pan
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Address
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Status
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600", width: 18 }}
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {customerRes &&
                            customerRes
                            .filter((item) => {
                              const isSuperAdmin = sessionStorage.getItem("superAdmin");
                              const isManager = sessionStorage.getItem('userType') === "Manager"; 
                              console.log(isManager)
                              const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
                              console.log( item.salesExecutiveEmail === emailExcutive)

                              const basicConditions = item.status === "approved" || item.status==="Rejected" ||  (!item.status);
                              const additionalConditions = item.ProjectName === PrName;
                              const executiveCondtions=  item.salesExecutiveEmail === emailExcutive

                              if (isSuperAdmin) {
                                // For super admins, no filtering is applied
                                return item.status === "approved";
                              }  else if (
                                (executiveCondtions && additionalConditions&& basicConditions)
                               
                              ) {
                          
                                return true; // For managers
                              } 
                              
                              
                              else if (isManager) {
                                return basicConditions && additionalConditions
                              } else {
                                return false; // Other roles or conditions where filtering is not needed
                              }
                            })
                              .map((item) => (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={item.Id}
                                >
                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    {item.customerName}
                                  </TableCell>
                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    <button
                                      style={{
                                        fontSize: 10.7,
                                        border: "2px solid rgb(126, 110, 228)",
                                        backgroundColor: "white",
                                        borderRadius: "1.2rem",
                                        cursor: "auto",
                                      }}
                                    >
                                      <FaMobileAlt
                                        style={{
                                          marginRight: 3,
                                          color: "rgb(126, 110, 228)",
                                          marginTop: "-0.16rem",
                                          fontSize: 9,
                                        }}
                                      />
                                      {item.mobileNumber}
                                    </button>
                                  </TableCell>

                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    {item.aadharNo}
                                  </TableCell>
                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    {item.panNo}
                                  </TableCell>
                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    {item.addres}
                                  </TableCell>
                                  <TableCell
  align={"start"}
  style={{
    top: 57,
    fontSize: 12,
    color: item.status === "approved" ? "green" : item.status === "Rejected" ? "red" : "orange",
    fontWeight: "bold",
  }}
>
  {item.status === "approved" || item.status === "Rejected" ? item.status : "Pending"}
</TableCell>

                                  <TableCell
                                    align={"start"}
                                    style={{
                                      top: 57,
                                      fontSize: 12,
                                      color: "rgb(126, 110, 228) ",
                                    }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      <Badge bg="danger">Cancel</Badge>
                                   
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table> */}

                      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', height: 56, marginTop: 16 }}>
                                                <Pagination count={Math.ceil(data.length / page)} page={cpage} onChange={pagehandle} color="secondary" sx={{ "& .Mui-selected": { backgroundColor: "blue" } }} />
                                            </div> */}
                         <TableContainer component={Paper} sx={{ 
  boxShadow: 'none', 
  border: 'none', 
  mt: 2, 
  overflowX: 'auto', // This is the magic for mobile responsiveness
  '&::-webkit-scrollbar': { height: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
}}>
<Table style={{ position: "relative", top: "1.3rem" }}>
      <TableHead sx={{ borderTop: "1px solid lightgray" }}>
        <TableRow>
          <TableCell
            align={"start"}
            style={{
              minWidth: 0,
              fontSize: 14,
              fontWeight: "600",
            }}
          >
            Name
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 57, fontWeight: "600",width:120 }}
          >
            Mobile
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Aadhar
          </TableCell>
          {/* <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Pan
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Address
          </TableCell> */}
          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Balance
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Excess Amount
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Status
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600" }}
          >
            Payments
          </TableCell>
          <TableCell
            align={"left"}
            style={{ top: 21, fontWeight: "600", width: 18 }}
          >
            Action
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {customerRes &&
          customerRes
            .filter((item) => {
              const isSuperAdmin = sessionStorage.getItem("superAdmin");
              const isManager = sessionStorage.getItem('userType') === "Manager"; 
              const isAdmin= sessionStorage.getItem('userType') === "Admin"; 
              const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
              const basicConditions = item.status === "approved" || item.status==="Rejected" ||  (!item.status);
              const projectType = sessionStorage.getItem("project_type");
              let additionalConditions;
  if (projectType === "Villa") {
    // If the project type is "Villa", check against PrName
    additionalConditions = item.ProjectName === sessionStorage.getItem("project_name");
    
  } else {
    // If the project type is not "Villa", check against the value stored in sessionStorage for project_name
    additionalConditions = item.ProjectName === PrName;
  }
              console.log(additionalConditions)
              const executiveConditions = item.salesExecutiveEmail === emailExcutive;

              if (isSuperAdmin) {
                return item.company_id === parseInt(companyId);
              } else if (executiveConditions && additionalConditions && basicConditions) {
                return true;
              } else if (isManager) {
                return basicConditions && additionalConditions;
              }
              else if (isAdmin) {
                return basicConditions && additionalConditions;
              }
              
              else {
                return false;
              }
            })
            .map((item) => {
              // Determine the overall status based on payment statuses
              const paymentStatus = item.payments && item.payments.length > 0
                ? item.payments.some(payment => payment.status === "20% received")
                  ? "20% received"
                  : "Pending"
                : "Pending";

              return (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={item.id}
              >
                <TableCell
                  align={"start"}
                  style={{ top: 57, fontSize: 12 }}
                >
                   <Button onClick={() => handleClickOpenBookPop(item)}>
                  {item.customerName}
                </Button>
                </TableCell>
                <TableCell
                  align={"start"}
                  style={{ top: 57, fontSize: 12 }}
                >
                  <button
                    style={{
                      fontSize: 10.7,
                      border: "2px solid rgb(126, 110, 228)",
                      backgroundColor: "white",
                      borderRadius: "1.2rem",
                      cursor: "auto",
                    }}
                  >
                    <FaMobileAlt
                      style={{
                        marginRight: 3,
                        color: "rgb(126, 110, 228)",
                        marginTop: "-0.16rem",
                        fontSize: 9,
                      }}
                    />
                    {sessionStorage.getItem('userType') === "Sales Executive"?'**********':`${item.mobileNumber}`} 
                  </button>
                </TableCell>
                <TableCell
                  align={"start"}
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.aadharNo}
                </TableCell>
                {/* <TableCell
                  align={"start"}
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.panNo}
                </TableCell>
                <TableCell
                  align={"start"}
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.addres}
                </TableCell> */}
                <TableCell
                  align={"start"}
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.balance}
                </TableCell>
                <TableCell
                  align={"start"}
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.extraAmount}
                </TableCell>
                <TableCell
                    align={"start"}
                    style={{
                      top: 57,
                      fontSize: 12,
                      color: paymentStatus === "20% received" ? "green" : "orange",
                      fontWeight: "bold",
                    }}
                  >
                    {paymentStatus}
                  </TableCell>
                <TableCell
                  align={"start"}
                  style={{ top: 57, fontSize: 12 }}
                >
                  {item.payments && item.payments.map((payment, index) => (
                    <div key={index} className="d-flex flex-row align-items-center">
                       <strong>{payment.paySource}</strong>: {payment.finalAmount} 
                       <div style={{marginLeft:'8px'}}><strong>Status:</strong> {payment.paidStatus || "Pending"}</div>
                    </div>
                  ))}
                </TableCell>
                <TableCell
                  align={"start"}
                  style={{
                    top: 57,
                    fontSize: 12,
                    color: "rgb(126, 110, 228)",
                  }}
                >
                  <div style={{ display: "flex" }}>
                  {paymentStatus==="Pending"? <Badge   bg="danger"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          handleClickOpenbokOne();
                                          handleBookRowClickOne(item.customerName);
                                          setId(item.Id);
                                        }}>Book</Badge>:
                         <Badge bg="success" disabled>Booked</Badge>}
                  </div>
                </TableCell>
              </TableRow>
              )}
            )}
      </TableBody>
    </Table>
    </TableContainer>
            
                  </TabPanel>

                  <TabPanel value="8">

                      <Typography
                        style={{
                          color: "rgba(41, 16, 105, 1)",
                          marginBottom: 3,
                          marginLeft: 15.5,
                          fontSize: 18,
                          color: "gray",
                          fontWeight: "500",
                          textAlign: "center",
                        }}
                      >
                       Save For Later
                      </Typography>
                      <div style={{ fontWeight: "bold" }}>
                        Total Save For Later:       {data &&
        data
          .filter(item => {
            const isSuperAdmin = sessionStorage.getItem("superAdmin");
            const isManager = sessionStorage.getItem('userType') === "Manager";
            const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";

            const basicConditions = item.saveforLater === 1 && item.intrestTab===0;
            const additionalConditions = item.ProjectName === PrName;
            const executiveConditions = item.salesExecutiveEmail === emailExcutive;

            if (isSuperAdmin) {
              // For super admins, no filtering is applied
              return item.status === "approved";
            } else if (executiveConditions && additionalConditions && basicConditions) {
              return true; // For specific executives
            } else if (isManager) {
              return basicConditions && additionalConditions;
            } else {
              return false; // Other roles or conditions where filtering is not needed
            }
          })
          .length}
                      </div>
                                               <TableContainer component={Paper} sx={{ 
  boxShadow: 'none', 
  border: 'none', 
  mt: 2, 
  overflowX: 'auto', // This is the magic for mobile responsiveness
  '&::-webkit-scrollbar': { height: '6px' },
  '&::-webkit-scrollbar-thumb': { backgroundColor: '#E0E5F2', borderRadius: '10px' }
}}>

                      <Table style={{ position: "relative", top: "1.3rem" }}>
                        <TableHead sx={{ borderTop: "1px solid lightgray" }}>
                          <TableRow>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Name
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{ top: 57, fontWeight: "600" }}
                            >
                              Mobile
                            </TableCell>
                            <TableCell
                              align={"start"}
                              style={{
                                minWidth: 0,
                                fontSize: 14,
                                fontWeight: "600",
                              }}
                            >
                              Call
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Gender
                            </TableCell>
                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Email
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Comment
                            </TableCell>
                            {/* <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600" }}
                            >
                              Status
                            </TableCell>

                            <TableCell
                              align={"left"}
                              style={{ top: 21, fontWeight: "600", width: 18 }}
                            >
                              Action
                            </TableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {data &&
                            data
                            .filter((item) => {
                              const isSuperAdmin = sessionStorage.getItem("superAdmin");
                              const isManager = sessionStorage.getItem('userType') === "Manager"; 
                              console.log(isManager)
                              const isLeadManagement = sessionStorage.getItem("LeadManagement") === "1";
                              console.log( item.salesExecutiveEmail === emailExcutive)

                            const basicConditions = item.saveforLater === 1  && item.intrestTab===0;
                              const additionalConditions = item.ProjectName === PrName;
                              const executiveCondtions=  item.salesExecutiveEmail === emailExcutive

                              if (isSuperAdmin) {
                                // For super admins, no filtering is applied
                                return item.status === "approved";
                              }  else if (
                                (executiveCondtions && additionalConditions&& basicConditions)
                               
                              ) {
                          
                                return true; // For managers
                              } 
                              
                              
                              else if (isManager) {
                                return basicConditions && additionalConditions
                              } else {
                                return false; // Other roles or conditions where filtering is not needed
                              }
                            })
                              .map((item) => (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={item.Id}
                                >
                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    {item.name}
                                  </TableCell>
                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    <button
                                      style={{
                                        fontSize: 10.7,
                                        border: "2px solid rgb(126, 110, 228)",
                                        backgroundColor: "white",
                                        borderRadius: "1.2rem",
                                        cursor: "auto",
                                      }}
                                    >
                                      <FaMobileAlt
                                        style={{
                                          marginRight: 3,
                                          color: "rgb(126, 110, 228)",
                                          marginTop: "-0.16rem",
                                          fontSize: 9,
                                        }}
                                      />
                                      {item.mobile}
                                    </button>
                                  </TableCell>
                                  <TableCell
                                  align={"start"}
                                  style={{ top: 57, fontSize: 12 }}
                                >
                                  <a
                                    href={`tel:${item.mobile}`}
                                    style={{ textAlign: "center" }}
                                  >
                                    <FaPhone />
                                  </a>
                                  {/* <FaUserAlt style={{ marginRight: 3, color: 'rgb(126, 110, 228)', marginTop: '-0.16rem', fontSize: 9 }}/> */}
                                </TableCell>

                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    {item.gender}
                                  </TableCell>
                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    {item.email}
                                  </TableCell>
                                  <TableCell
                                    align={"start"}
                                    style={{ top: 57, fontSize: 12 }}
                                  >
                                    {item.notintrstComment}
                                  </TableCell>
                                  {/* <TableCell
  align={"start"}
  style={{
    top: 57,
    fontSize: 12,
    color: item.status === "approved" ? "green" : item.status === "Rejected" ? "red" : "orange",
    fontWeight: "bold",
  }}
>
  {item.status === "approved" || item.status === "Rejected" ? item.status : "Pending"}
</TableCell> */}

                                  <TableCell
                                    align={"start"}
                                    style={{
                                      top: 57,
                                      fontSize: 12,
                                      color: "rgb(126, 110, 228) ",
                                    }}
                                  >
                                    <div style={{ display: "flex" }}>
                                      {/* <Badge bg="danger">Cancel</Badge> */}
                                      {/* <div>
                                                                                <IconButton
                                                                                    id="fade-button"
                                                                                    aria-controls={open2 ? 'fade-menu' : undefined}
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded={open2 ? 'true' : undefined}
                                                                                    onClick={(e) => {
                                                                                        handleClick(e.currentTarget)
                                                                                        setId(item.Id)
                                                                                    }}
                                                                                >
                                                                                    <MoreVertIcon />
                                                                                </IconButton>
                                                                                <Menu
                                                                                    id="fade-menu"
                                                                                    MenuListProps={{
                                                                                        'aria-labelledby': 'fade-button',
                                                                                    }}
                                                                                    anchorEl={anchorEl}
                                                                                    open={open2}
                                                                                    onClose={handleClose2}
                                                                                    TransitionComponent={Fade}
                                                                                >
                                                                                   
                                                                                    {
                                                                                        (sessionStorage.getItem('View') === '1' || sessionStorage.getItem('superAdmin')) && (
                                                                                            <MenuItem style={{ color: 'gray' }} >Cancel</MenuItem>
                                                                                        )

                                                                                    }


                                                                                  

                                                                                </Menu>
                                                                            </div> */}
                                    </div>
                                  </TableCell>
                                </TableRow>
                              ))}
                        </TableBody>
                      </Table>

                      {/* <div style={{ display: 'flex', justifyContent: 'flex-end', height: 56, marginTop: 16 }}>
                                                <Pagination count={Math.ceil(data.length / page)} page={cpage} onChange={pagehandle} color="secondary" sx={{ "& .Mui-selected": { backgroundColor: "blue" } }} />
                                            </div> */}
             </TableContainer>
                  </TabPanel>
                </TabContext>
              </Box>
            </Paper>
          </div>
        )}
        {isVeiw && (
          <div
            className="leadManagementTable leadManagementTable1 p-4"
            style={{
              backgroundColor: "white",
              borderRadius: "0.4rem",
              position: "relative",
            }}
          >
            <FaWindowClose
              onClick={() => {
                setIsVeiw(false);
              }}
              style={{
                position: "absolute",
                right: 10,
                top: 12,
                color: "rgb(126, 110, 228)",
                fontSize: 21,
                cursor: "pointer",
                zIndex: 10000,
              }}
            ></FaWindowClose>
            <div
              className="card"
              style={{
                backgroundColor: "white",
                borderRadius: "0.4rem",
                border: "none",
                boxShadow: "none",
                alignItems: "center",
              }}
            >
              <Typography
                style={{
                  fontSize: 26,
                  fontWeight: "bold",
                  color: "rgb(126, 110, 228)",
                }}
              >
                <img
                  src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                  width="145px"
                />
              </Typography>
              <Typography>Lead customers information details</Typography>
            </div>
            <br />
            <div style={{ padding: 21, paddingLeft: 46, paddingRight: 46 }}>
              <div
                className="card"
                style={{
                  paddingTop: 43,
                  border: "1px solid rgb(126, 110, 228)",
                  borderRadius: "0.3rem",
                  padding: 11,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="card"
                  style={{
                    backgroundColor: "white",
                    borderRadius: "0.4rem",
                    border: "none",
                    boxShadow: "none",
                    alignItems: "start",
                    justifyContent: "space-between",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    style={{ marginBottom: 34, color: "rgb(163, 163, 165)" }}
                  >
                    <span style={{ fontSize: 17, color: "black" }}> Name:</span>{" "}
                    {pname}
                  </Typography>
                  <Typography
                    style={{ marginBottom: 34, color: "rgb(163, 163, 165)" }}
                  >
                    <span style={{ fontSize: 17, color: "black" }}>Email:</span>{" "}
                    {Pemail}
                  </Typography>
                  <Typography
                    style={{ marginBottom: 34, color: "rgb(163, 163, 165)" }}
                  >
                    <span style={{ fontSize: 17, color: "black" }}>
                      Mobile:
                    </span>{" "}
                    {pmobile}
                  </Typography>
                  <Typography
                    style={{ marginBottom: 34, color: "rgb(163, 163, 165)" }}
                  >
                    <span style={{ fontSize: 17, color: "black" }}>
                      {" "}
                      Gender:
                    </span>{" "}
                    {pgender}
                  </Typography>
                  <Typography
                    style={{ marginBottom: 34, color: "rgb(163, 163, 165)" }}
                  >
                    <span style={{ fontSize: 17, color: "black" }}>
                      Preffered Timings:
                    </span>{" "}
                    {ptym}
                  </Typography>
                  <Typography
                    style={{ marginBottom: 34, color: "rgb(163, 163, 165)" }}
                  >
                    <span style={{ fontSize: 17, color: "black" }}>
                      Source Type :
                    </span>{" "}
                    {pst}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        )}


        <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
             maxWidth="sm" // Set to small for a professional popup look
                  sx={{
    "& .MuiPaper-root": {
      borderRadius: "16px",
      width: "100%", // always full width of container
      maxWidth: "800px", // Desktop max width
      margin: "0 16px", // small margin on mobile
      "@media (max-width:600px)": {
        width: "calc(100% - 32px)", // slightly narrower for mobile
      },
      "@media (min-width:601px) and (max-width:900px)": {
        width: "90%", // medium screens
      },
    },
  }}
    
  fullWidth
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>

                <Form
                  noValidate
                  validated={Validated}
                  onSubmit={formValidation}
                >
                  <div className="mb-4 mt-1">
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Add Lead
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Full Name *
                      </Typography>
                      <Form.Control
                        required
                        onChange={(e) => setPname(e.target.value)}
                        placeholder="Enter Full Name"
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Name
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Email *
                      </Typography>
                      <Form.Control
                        required
                        onChange={(e) => setPemail(e.target.value)}
                        type="text"
                        placeholder="Enter Email"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid email
                      </Form.Control.Feedback>
                    </Form.Group>
                    {wapp !== "" && (
                      <>
                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationCustom01"
                        >
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Mobile *
                          </Typography>
                          <Form.Control
                            required
                            placeholder="Enter Mobile"
                            onChange={(e) => setPmobile(e.target.value)}
                            type="number"
                            style={{ padding: "0.42rem", marginBottom: 14 }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter valid mobile
                          </Form.Control.Feedback>
                        </Form.Group>

                        <Form.Group
                          as={Col}
                          md="6"
                          controlId="validationCustom02"
                        >
                          <label style={{ color: "gray", fontSize: 13 }}>
                            Is This Your WhatsApp Mobile? *
                          </label>
                          {["radio"].map((type) => (
                            <div key={`inline-${type}`} className="mb-3">
                              <Form.Check
                                inline
                                label="Yes"
                                name="whatsappGroup"
                                type={type}
                                id={`inline-${type}-1`}
                                value="Yes"
                                onChange={handleWhatsappCheckboxChange}
                              />
                              <Form.Check
                                inline
                                label="No"
                                name="whatsappGroup"
                                type={type}
                                id={`inline-${type}-2`}
                                value="No"
                                onChange={handleWhatsappCheckboxChange}
                              />
                            </div>
                          ))}
                          <Form.Control.Feedback type="invalid">
                            Please select WhatsApp option
                          </Form.Control.Feedback>
                        </Form.Group>

                        {isWhatsappNo && (
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom03"
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              WhatsApp Mobile *
                            </Typography>
                            <Form.Control
                              required
                              placeholder="Enter Whatsapp Mobile"
                              onChange={(e) =>
                                setWhatsappMobile(e.target.value)
                              }
                              type="number"
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid WhatsApp mobile
                            </Form.Control.Feedback>
                          </Form.Group>
                        )}
                      </>
                    )}

                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                      <div class="radio-wrapper">
                        <div
                          className="radio-container d-flex"
                          style={{ marginBottom: 14 }}
                        >
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Gender *
                          </Typography>
                          <div style={{ marginRight: "5rem", marginLeft: 30 }}>
                            <input
                              onChange={(e) => setPgender(e.target.value)}
                              type="radio"
                              name="gender"
                              value="Male"
                              id="male"
                            />
                            <label for="male">MALE</label>
                          </div>
                          <div>
                            <input
                              onChange={(e) => setPgender(e.target.value)}
                              type="radio"
                              name="gender"
                              value="Female"
                            />
                            <label for="female">FEMALE</label>
                          </div>
                        </div>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        Please select valid Gender
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Location *
                      </Typography>
                      <Form.Control
                        required
                        onChange={(e) => setLocation(e.target.value)}
                        placeholder="Enter Location"
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Location
                      </Form.Control.Feedback>
                    </Form.Group>
                    {/* <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Lead Created Date
                      </Typography>
                      <Form.Control
                        required
                        value={ptym}
                        onChange={(e) => setPtym(e.target.value)}
                        type="datetime-local"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Timings
                      </Form.Control.Feedback>
                    </Form.Group> */}
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Lead Created Date
                      </Typography>
                      <Form.Control
                        required
                        value={ptym}
                        onChange={(e) => setPtym(e.target.value)}
                        type="datetime-local"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Timings
                      </Form.Control.Feedback>
                    </Form.Group>
                    <>
                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="validationCustom01"
                      >
                        <div style={{ marginBottom: 14 }}>
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Source Type
                          </Typography>
                          <select
                            onChange={handleSourceTypeChange}
                            style={{
                              height: "2.3rem",
                              color: "gray",
                              borderRadius: "0.3rem",
                              outline: "none",
                              width: "100%",
                              border: "0.7px solid lightgray",
                            }}
                          >
                            <option>--select--</option>
                            <option>Online</option>
                            <option>Walk In</option>
                            <option>Reference</option>
                            <option>Online/Website</option>
                            <option>OTH</option>
                            <option>Paper Ad</option>
                          </select>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Source type
                        </Form.Control.Feedback>
                      </Form.Group>

                      {showReferenceFields && (
                        <>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Reference Name *
                            </Typography>
                            <Form.Control
                              required
                              value={rname}
                              placeholder="Enter Reference Name"
                              onChange={(e) => setRName(e.target.value)}
                              type="text"
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid Reference UCIN
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Reference UCIN *
                            </Typography>
                            <Form.Control
                              required
                              value={rucin}
                              placeholder="Enter Reference Name"
                              onChange={(e) => setRucin(e.target.value)}
                              type="text"
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid Reference Ucin
                            </Form.Control.Feedback>
                          </Form.Group>

                          <Form.Group
                            as={Col}
                            md="6"
                            controlId="validationCustom01"
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Reference Mobile *
                            </Typography>
                            <Form.Control
                              required
                              value={rmobile}
                              placeholder="Enter Reference Mobile"
                              onChange={(e) => setRMobile(e.target.value)}
                              type="number"
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter valid Reference Mobile
                            </Form.Control.Feedback>
                          </Form.Group>
                        </>
                      )}
                    </>
                    <>
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom02"
                      >
                        <label style={{ color: "gray", fontSize: 13 }}>
                          Channel Partner*
                        </label>
                        {["radio"].map((type) => (
                          <div key={`inline-${type}`} className="mb-3">
                            <Form.Check
                              inline
                              label="Yes"
                              name="interest"
                              type={type}
                              id={`inline-${type}-1`}
                              value="Yes"
                              onChange={handleIntrestChange}
                            />
                            <Form.Check
                              inline
                              label="No"
                              name="intrest"
                              type={type}
                              id={`inline-${type}-2`}
                              value="No"
                              onChange={handleIntrestChange}
                            />
                          </div>
                        ))}
                        <Form.Control.Feedback type="invalid">
                          Please select Interest option
                        </Form.Control.Feedback>
                      </Form.Group>

                      {intrest === "Yes" && (
                        <>
                         <Form.Group as={Col} md="6" controlId="validationCustom01">
        <Typography style={{ color: "gray", fontSize: 13 }}>
          Channel Partner Mobile
        </Typography>
        <Form.Control
          required
          value={cpMobile}
          onChange={handleMobileChange}
          type="text"
          placeholder="Enter Channel Partner Mobile"
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
        <Form.Control.Feedback type="invalid">
          Please Enter Valid Channel Partner mobile
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group as={Col} md="6" controlId="validationCustom01">
        <Typography style={{ color: "gray", fontSize: 13 }}>
          Channel Partner Name
        </Typography>
        <Form.Control
          required
          value={cpName}
          onChange={(e) => setCPName(e.target.value)}
          type="text"
          placeholder="Enter Channel Partner Name"
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
        <Form.Control.Feedback type="invalid">
          Please Enter Valid Channel Partner Name
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group as={Col} md="6" controlId="validationCustom01">
        <Typography style={{ color: "gray", fontSize: 13 }}>
          Channel Partner ID
        </Typography>
        <Form.Control
          required
          value={cpId}
          onChange={(e) => setCPId(e.target.value)}
          type="text"
          placeholder="Enter Channel Partner ID"
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
        <Form.Control.Feedback type="invalid">
          Please Enter Valid Channel Partner ID
        </Form.Control.Feedback>
      </Form.Group>
                        </>
                      )}
                    </>
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Comment{" "}
                      </Typography>
                      <Form.Control
                        required
                        as="textarea"
                        onChange={(e) => setComment(e.target.value)}
                        style={{
                          padding: "0.42rem",
                          marginBottom: 14,
                          minHeight: "40px",
                        }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Comment
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpen(false);
                          setValidated(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>

            </DialogContent>
          </Dialog>
        </div>

        <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
            maxWidth="xl"
            open={open1}
            onClose={() => setOpen1(!open1)}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div style={{ width: "37rem" }}>
                <Form
                  noValidate
                  validated={Validated}
                  onSubmit={formValidation}
                >
                  <div className="mb-4 mt-1">
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Add Project
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Name *
                      </Typography>
                      <Form.Control
                        required
                        value={pname}
                        onChange={(e) => setPname(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Name
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Email *
                      </Typography>
                      <Form.Control
                        required
                        value={Pemail}
                        onChange={(e) => setPemail(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid email
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Mobile *
                      </Typography>
                      <Form.Control
                        required
                        value={pmobile}
                        onChange={(e) => setPmobile(e.target.value)}
                        type="number"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter valid moible
                      </Form.Control.Feedback>
                    </Form.Group>
                    {/* 
                                        <Form.Group as={Col} md="4" controlId="validationCustom01">
                                            <Typography style={{ color: 'gray', fontSize: 13 }}>Whatsapp Mobile *</Typography>
                                            <Form.Control
                                                required
                                                
                                                onChange={(e) => setWhatsappMobile(e.target.value)}
                                                type="number"

                                                style={{ padding: '0.42rem', marginBottom: 14 }}


                                            />
                                            <Form.Control.Feedback type="invalid">
                                                Please Enter Valid whatsapp mobile
                                            </Form.Control.Feedback>
                                        </Form.Group> */}

                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                      <div class="radio-wrapper">
                        <div
                          className="radio-container d-flex"
                          style={{ marginBottom: 14 }}
                        >
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Gender *
                          </Typography>
                          <div style={{ marginRight: "5rem", marginLeft: 30 }}>
                            <input
                              onChange={(e) => setPgender(e.target.value)}
                              type="radio"
                              name="gender"
                              value={pgender}
                              id="male"
                            />
                            <label for="male">MALE</label>
                          </div>
                          <div>
                            <input
                              onChange={(e) => setPgender(e.target.value)}
                              type="radio"
                              name="gender"
                              value={pgender}
                            />
                            <label for="female">FEMALE</label>
                          </div>
                        </div>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        Please select valid Gender
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Preffered Timings
                      </Typography>
                      <Form.Control
                        required
                        value={ptym}
                        onChange={(e) => setPtym(e.target.value)}
                        type="datetime-local"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Timings
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <div style={{ marginBottom: 14 }}>
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Source Type
                        </Typography>
                        <select
                          onChange={(e) => setPst(e.target.value)}
                          value={pst}
                          style={{
                            height: "2.3rem",
                            color: "gray",
                            borderRadius: "0.3rem",
                            outline: "none",
                            width: "100%",
                            border: "0.7px solid lightgray",
                          }}
                        >
                          <option>Website</option>
                          <option>Tradeshow</option>
                          <option>Walkins</option>
                          <option>Social Media</option>
                          <option>Relatives</option>
                          <option>Freinds</option>
                        </select>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Source type
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        onClick={() => editAlert()}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Update
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => setOpen1(false)}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </DialogContent>
          </Dialog>
        </div>

              {/*  Interested */}


        <React.Fragment>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
            sx={{
    "& .MuiPaper-root": {
    
      borderRadius: "16px",
      width: "100%", // Critical for mobile
    },
  }}
          maxWidth="sm" // Set to small for a professional popup look
  fullWidth // Automatically expands to maxWidth
            open={openi}
            onClose={handleClosei}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
       
                <Form
                  noValidate
                  validated={Validatedtabi}
                  onSubmit={formValidationtabi}
                >
                  <div className="mb-4 mt-1">
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Interested
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Date of Visit *
                      </Typography>
                      <Form.Control
                        required
                        onChange={(e) => setIdate(e.target.value)}
                        type="datetime-local"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Name
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Comment Box
                      </Typography>
                      <Form.Control
                        re
                        onChange={(e) => setIcomment(e.target.value)}
                        required
                        as="textarea"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Permanent Address
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpeni(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
     
            </DialogContent>
          </Dialog>
        </React.Fragment>

      {/* Call Back*/}


        <React.Fragment>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
           maxWidth="sm" // Set to small for a professional popup look
                  sx={{
    "& .MuiPaper-root": {
      borderRadius: "16px",
      width: "100%", // always full width of container
      maxWidth: "800px", // Desktop max width
      margin: "0 16px", // small margin on mobile
      "@media (max-width:600px)": {
        width: "calc(100% - 32px)", // slightly narrower for mobile
      },
      "@media (min-width:601px) and (max-width:900px)": {
        width: "90%", // medium screens
      },
    },
  }}
    
  fullWidth // Automatically expands to maxWidth
            open={openc}
            onClose={handleClosec}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>

                <Form
                  noValidate
                  validated={Validatedtabcb}
                  onSubmit={formValidationtabcb}
                >
                  <div className="mb-4 mt-1">
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Call Back
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Date of Visit *
                      </Typography>
                      <Form.Control
                        required
                        onChange={(e) => setCbd(e.target.value)}
                        type="datetime-local"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Name
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Comment Box
                      </Typography>
                      <Form.Control
                        re
                        onChange={(e) => setCbc(e.target.value)}
                        required
                        as="textarea"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Permanent Address
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpenc(false);
                          setValidatedtabcb(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>

            </DialogContent>
          </Dialog>
        </React.Fragment>

        {/*    Not Interested */}

        <React.Fragment>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
           maxWidth="sm" // Set to small for a professional popup look
                  sx={{
    "& .MuiPaper-root": {
      borderRadius: "16px",
      width: "100%", // always full width of container
      maxWidth: "800px", // Desktop max width
      margin: "0 16px", // small margin on mobile
      "@media (max-width:600px)": {
        width: "calc(100% - 32px)", // slightly narrower for mobile
      },
      "@media (min-width:601px) and (max-width:900px)": {
        width: "90%", // medium screens
      },
    },
  }}
    
  fullWidth // Automatically expands to maxWidth
            open={openin}
            onClose={handleClosein}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>

                <Form
                  noValidate
                  validated={Validatedtabin}
                  onSubmit={formValidationtabin}
                >
                  <div className="mb-4 mt-1">
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Not Interested
                    </Typography>
                  </div>
                  <Row className="mb-3">
                  {/* <Form.Group as={Col} md="8" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Reason For Not Interest
                      </Typography>
                      <Form.Select
                        required
                        onChange={(e) => setReasonNotIntr(e.target.value)}
                        value={reasonNotIntr}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select A Reason</option>

                  
                          <option>Budget</option>
                          <option>Time</option>
                          <option>Location</option>
                          <option>Save For Later</option>
           
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Interested Apartment Size
                      </Form.Control.Feedback>
                    </Form.Group> */}
                     <Form.Group as={Col} md="8" controlId="validationCustom01">
      <Typography style={{ color: "gray", fontSize: 13 }}>
        Reason For Not Interested
      </Typography>
      <Form.Select
        required
        onChange={handleReasonChange}
        value={reasonNotIntr}
        type="text"
        style={{ padding: "0.42rem", marginBottom: 14 }}
      >
        <option value="">Select A Reason</option>
        <option value="Budget">Budget</option>
        <option value="Time">Time</option>
        <option value="Location">Location</option>
      
      </Form.Select>
      {/* Conditionally render the checkbox */}
      {(reasonNotIntr === 'Budget' || reasonNotIntr === 'Time' || reasonNotIntr === 'Location') && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Form.Check
            type="checkbox"
            id="saveForLater"
            checked={saveForLater}
            onChange={handleCheckboxChange}
            style={{ marginRight: '0.5rem' }}
          />
          <label htmlFor="saveForLater">Save For Later</label>
        </div>
      )}
      <Form.Control.Feedback type="invalid">
        Please Enter Valid Interested Apartment Size
      </Form.Control.Feedback>
    </Form.Group>
                    <Form.Group as={Col} md="12" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Comment Box
                      </Typography>
                      <Form.Control
                        re
                        onChange={(e) => setIncb(e.target.value)}
                        required
                        as="textarea"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Permanent Address
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpenin(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
         
            </DialogContent>
          </Dialog>
        </React.Fragment>

        {/* Site visit form */}

        <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
                  maxWidth="sm" // Set to small for a professional popup look
                  sx={{
    "& .MuiPaper-root": {
      borderRadius: "16px",
      width: "100%", // always full width of container
      maxWidth: "800px", // Desktop max width
      margin: "0 16px", // small margin on mobile
      "@media (max-width:600px)": {
        width: "calc(100% - 32px)", // slightly narrower for mobile
      },
      "@media (min-width:601px) and (max-width:900px)": {
        width: "90%", // medium screens
      },
    },
  }}
    
  fullWidth // Automatically expands to maxWidth
   
            open={opensv}
            onClose={handleClosesv}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
        
                <Form
                  noValidate
                  validated={Validatedsv}
                  onSubmit={formValidationsv}
                >
                  <div className="mb-4 mt-1">
                    <center>
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                        width="145px"
                      />
                    </center>
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Site Visit
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <div style={{ marginBottom: 14 }}>
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          {" "}
                          Occupation
                        </Typography>
                        <Form.Select
                          onChange={(e) => setOccupation(e.target.value)}
                          style={{
                            height: "2.3rem",
                            color: "gray",
                            borderRadius: "0.3rem",
                            outline: "none",
                            width: "100%",
                            border: "0.7px solid lightgray",
                          }}
                        >
                          <option>--select--</option>
                          <option>Private</option>
                          <option>Public</option>
                          <option>Self Employed</option>
                          <option>Business</option>
                          <option>Others</option>
                        </Form.Select>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        Please Select valid Occupation option
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Budget
                      </Typography>
                      <Form.Control
                        required
                        onChange={(e) => setBudget(e.target.value)}
                        type="text"
                        value={budget}
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Budget
                      </Form.Control.Feedback>
                    </Form.Group>

{projectType!=="Villa"?(
    <>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Interested Floor
                      </Typography>
                      <Form.Select
                        required
                        value={intrstFloor}
                        onChange={handleChangeIntrstFloor}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Interested Floor</option>

                        {floorDatap.map((floor, index) => (

                                 
                                     <option key={index}>{`floor${index + 1}`}</option>
                                   
                               
                                  ))} 
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Interested Floor
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Interested Apartment Size
                      </Typography>
                      <Form.Select
                        required
                        value={apartsize}
                        onChange={handleUnitSizeChange}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>select Apartment Size</option>

                        {/* {filteredSizes.map((data, index) => (
                          <option key={index}>{`${data.unitsize}`}</option>
                        ))} */}
                        <option>1100-1300</option>
                        <option>1300-1500</option>
                        <option>1500-1700</option>
                        <option>1700-1900</option>
                        <option>1900-2100</option>
                        <option>2100-2300</option>
                        <option>2300-above</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Interested Apartment Size
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Interested Apartment Facing
                      </Typography>
                      <Form.Select
                        required
                        onChange={(e) => setApartFacing(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>select Facing</option>
                        {/* {uniqueFacings.map((data, index) => (
                          <option key={index}>{`${data}`}</option>
                        ))} */}
                        <option>East</option>
                        <option>West</option>
                        <option>South</option>
                        <option>North</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Interested Apartment Facing
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <div style={{ marginBottom: 14 }}>
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          {" "}
                          Corner
                        </Typography>
                        {/* <Form.Select
                          onChange={(e) => setCorner(e.target.value)}
                          style={{
                            height: "2.3rem",
                            color: "gray",
                            borderRadius: "0.3rem",
                            outline: "none",
                            width: "100%",
                            border: "0.7px solid lightgray",
                          }}
                        >
                          <option>--select--</option>
                          <option>Yes</option>
                          <option>No</option>
                        </Form.Select> */}


<div>
    
        <Form.Select
         value={Corner}
          onChange={handleCornorChange}
          style={{
            height: "2.3rem",
            color: "gray",
            borderRadius: "0.3rem",
            outline: "none",
            width: "100%",
            border: "0.7px solid lightgray",
            marginBottom: "10px"
          }}
        
        >
          <option>--select--</option>
         
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </Form.Select>

    </div>

                      </div>
                      <Form.Control.Feedback type="invalid">
                        Please Select valid Corner option
                      </Form.Control.Feedback>
                    </Form.Group>
                    </>
):( 
    <>
<Form.Group as={Col} md="3" controlId="validationCustom01">
    <Typography style={{ color: "gray", fontSize: 13 }}>
      Interested Villa Size
    </Typography>
    <Form.Select
      required
      value={apartsize}
      onChange={handleUnitSizeChange}
      type="text"
      style={{ padding: "0.42rem", marginBottom: 14 }}
    >
      <option>Select Interested VillaSize</option>

      {typicalUnitdata.map((floor, index) => (

               
                   <option key={index}>{floor.unitsize}</option>
                 
             
                ))} 
    </Form.Select>
    <Form.Control.Feedback type="invalid">
      Please Enter Valid Interested Floor
    </Form.Control.Feedback>
  </Form.Group>

  </>
  )}

                    <>
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <div style={{ marginBottom: 14 }}>
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                           Preference
                          </Typography>
                          <select
                            onChange={handleFlatDetailsChange}
                            style={{
                              height: "2.3rem",
                              color: "gray",
                              borderRadius: "0.3rem",
                              outline: "none",
                              width: "100%",
                              border: "0.7px solid lightgray",
                            }}
                          >
                            <option>--select--</option>
                            <option>Under Construction</option>
                            <option>Ready To Move</option>
                          </select>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Flat Details
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* {flatDetails === "Under Construction" && (
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom01"
                        >
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Under Construction
                          </Typography>
                          <Form.Control
                            required
                            value={underConstruction}
                            onChange={(e) =>
                              setUnderConstruction(e.target.value)
                            }
                            type="text"
                            style={{ padding: "0.42rem", marginBottom: 14 }}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Valid Under Construction
                          </Form.Control.Feedback>
                        </Form.Group>
                      )} */}

{flatDetails === "Under Construction" && (
  <Form.Group as={Col} md="4" controlId="validationCustom01">
    <Typography style={{ color: "gray", fontSize: 13 }}>
      Under Construction
    </Typography>
    <Form.Control
      as="select"
      required
      value={underConstruction}
      onChange={(e) => setUnderConstruction(e.target.value)}
      style={{ padding: "0.42rem", marginBottom: 14 }}
    >
      <option value="">Select...</option>
      <option value="1-2 years">1-2 years</option>
      <option value="2-3 years">2-3 years</option>
      <option value="3 and above">3 and above</option>
    </Form.Control>
    <Form.Control.Feedback type="invalid">
      Please Select a Valid Option
    </Form.Control.Feedback>
  </Form.Group>
)}


                      {/* {flatDetails === "Ready To Move" && (
                        <Form.Group
                          as={Col}
                          md="4"
                          controlId="validationCustom01"
                        >
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Ready To Move
                          </Typography>
                          <Form.Control
                            required
                            value={readyToMove}
                            onChange={(e) => setReadyToMove(e.target.value)}
                            type="date"
                            style={{ padding: "0.42rem", marginBottom: 14 }}
                          />
</Form.Group>

                      )} */}

{flatDetails === "Ready To Move" && (
  <Form.Group as={Col} md="4" controlId="validationCustom01">
    <Typography style={{ color: "gray", fontSize: 13 }}>
      Ready To Move
    </Typography>
    <Form.Control
      as="select"
      required
      value={readyToMove}
      onChange={(e) => setReadyToMove(e.target.value)}
      style={{ padding: "0.42rem", marginBottom: 14 }}
    >
      <option value="">Select...</option>
      <option value="Immediately">Immediately</option>
      <option value="3-6 Months">3-6 Months</option>
      <option value="6-9 Months">6-9 Months</option>
      <option value="9-12 Months">9-12 Months</option>
    </Form.Control>
  </Form.Group>
)}
                     
                    </>
                     <Form.Group as={Col} md="6" controlId="validationCustom01">
                     <Typography style={{ color: "gray", fontSize: 13 }}>
                       Comment{" "}
                     </Typography>
                     <Form.Control
                       required
                       as="textarea"
                       onChange={(e) => setCommentSiteVisti(e.target.value)}
                       style={{
                         padding: "0.42rem",
                         marginBottom: 14,
                         minHeight: "40px",
                       }}
                     />
                     <Form.Control.Feedback type="invalid">
                       Please Enter Valid Comment
                     </Form.Control.Feedback>
                   </Form.Group>
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpensv(false);
                          setValidatedsv(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
         
            </DialogContent>
          </Dialog>
        </div>

        {/* Block Form  */}

        <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
           maxWidth="sm" // Set to small for a professional popup look
                  sx={{
    "& .MuiPaper-root": {
      borderRadius: "16px",
      width: "100%", // always full width of container
      maxWidth: "1000px", // Desktop max width
      margin: "0 16px", // small margin on mobile
      "@media (max-width:600px)": {
        width: "calc(100% - 32px)", // slightly narrower for mobile
      },
      "@media (min-width:601px) and (max-width:900px)": {
        width: "90%", // medium screens
      },
    },
  }}
    
  fullWidth // Automatically expands to maxWidth
            open={openbf}
            onClose={handleClosebf}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>

                <Form
                  noValidate
                  validated={Validatedbf}
                  onSubmit={formValidationbf}
                >
                  <div className="mb-4 mt-1">
                    <center>
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                        width="145px"
                      />
                    </center>
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Block Form
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Row>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <div style={{ marginBottom: 14 }}>
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Lead Name
                          </Typography>
                          <select
                            onChange={(e) => getdetls(e.target.value)}
                            style={{
                              height: "2.3rem",
                              color: "gray",
                              borderRadius: "0.3rem",
                              outline: "none",
                              width: "100%",
                              border: "0.7px solid lightgray",
                            }}
                            value={clickedName} 
                          >
                            <option>--Select--</option>
                            {filteredItems.map((item) => (
                              <option key={item.Id}>
                                {item.name},{item.mobile}
                              </option>
                            ))}
                          </select>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Source type
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Name *
                        </Typography>
                        <Form.Control
                          type="text"
                          value={nname}
                          onChange={(e) => setNname(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Mobile{" "}
                        </Typography>
                        <Form.Control
                          
                          type="number"
                          value={nmobile}
                          onChange={(e)=>setNmobile(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Mobile
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Email{" "}
                        </Typography>
                        <Form.Control
                          value={nemail}
                          type="text"
                          onChange={(e)=>setNemail(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid email
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Alternate Mobile{" "}
                      </Typography>
                      <Form.Control
                        type="number"
                        placeholder="Enter Alternate Mobile Number"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                        onChange={(e) => setAlternateMob(e.target.value)}
                      
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Alternate Mobile
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Aadhar Number
                      </Typography>
                      <Form.Control
                        placeholder="Enter Aadhar Number"
                        onChange={(e) => setAadharNumber(e.target.value)}
                        required
                        type="number"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter valid Aadhar Number
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom03">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Pan Number
                      </Typography>
                      <Form.Control
                        required
                        placeholder="Enter Pan Number"
                        onChange={(e) => setPanNumber(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Pan Number
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Permanent Address
                      </Typography>
                      <Form.Control
                        re
                        onChange={(e) => setPerAddress(e.target.value)}
                        required
                        as="textarea"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Permanent Address
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        {" "}
                        Current Address
                      </Typography>
                      <Form.Control
                        onChange={(e) => setAddressCom(e.target.value)}
                        value={addresscom}
                        required
                        as="textarea"
                        disabled={sameaspaddress}
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Check
                        style={{ color: "red", fontSize: 12 }}
                        onChange={handlecheck}
                        label="Same As Permanent Address"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter valid Address For Communication
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Typography style={{ color: "gray", fontSize: 13 }}>
          Payment Source
        </Typography>

                    <Form.Group as={Col} md="4" controlId="paymentSource" className='d-flex flex-row align-items-center w-100'>
        <div className='d-flex flex-row align-items-center w-100'>
        <Form.Check
          type="checkbox"
          label="UPI"
          onChange={handlePaymentSourceChangeBlock}
          value="UPI"
        />
        <Form.Check
          type="checkbox"
          label="Bank"
          onChange={handlePaymentSourceChangeBlock}
          value="Bank"
        />
        <Form.Check
          type="checkbox"
          label="Cheque"
          onChange={handlePaymentSourceChangeBlock}
          value="Cheque"
        />
        <Form.Check
          type="checkbox"
          label="Online"
          onChange={handlePaymentSourceChangeBlock}
          value="Online"
        />
        </div>
      </Form.Group>

      {selectedPaymentsBlock.includes("Online") && (
        <>
          <Form.Group as={Col} md="4" controlId="transferDetails">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Transaction Details
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Online", "transferDetails")}
              type="text"
              placeholder="Enter Transfer Details"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transfer Details
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="onlineScreenshot">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChangeBlock(e, "Online", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="onlineAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Online Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Online", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPaymentsBlock.includes("Cheque") && (
        <>
          <Form.Group as={Col} md="4" controlId="chequeNumber">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Cheque Number
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Cheque", "chequeNumber")}
              type="text"
              placeholder="Enter Cheque Number"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Cheque Number
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="chequeImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Cheque Image
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChangeBlock(e, "Cheque", "chequeImage")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Cheque Image
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="chequeAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Cheque Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Cheque", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPaymentsBlock.includes("UPI") && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              UPI Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "UPI", "transactionId")}
              type="text"
              placeholder="Enter UPI Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChangeBlock(e, "UPI", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            UPI  Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "UPI", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPaymentsBlock.includes("Bank") && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Bank Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Bank", "transactionId")}
              type="text"
              placeholder="Enter Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="bankImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChangeBlock(e, "Bank", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="bankAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Bank Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Bank", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

<Form.Group as={Col} md="4" controlId="gstPercentage">
        <Typography style={{ color: "gray", fontSize: 13 }}>GST Percentage</Typography>
        <Form.Control
          type="number"
          placeholder="Enter GST Percentage"
          onChange={handleGstChange}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
      </Form.Group>

      {/* Total Amount with GST */}
      <Form.Group as={Col} md="4" controlId="totalAmount">
        <Typography style={{ color: "gray", fontSize: 13 }}>Total Amount with GST</Typography>
        <Form.Control
          type="text"
          readOnly
          value={totalAmount.toFixed(2)}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
      </Form.Group>

      {projectType!=="Villa"?(

<>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        ProjectName
                      </Typography>
                      <Form.Select
                        required
                        onChange={(e) => setProjectName(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Project</option>
                        <option>{PrName}</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Tower{" "}
                      </Typography>
                      <Form.Select
                        required
                        value={ttowerno}
                        onChange={(e) => setTowardsTowerNumber(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Tower </option>
                        {responset
                          .filter((item) => item.Towers.startsWith(projectName)) // Filter towers that start with the project name
                          .map((item) => (
                            <option>{item.Towers}</option>
                          ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Tower Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Floor
                      </Typography>
                      <Form.Select
                        required
                        value={floorb}
                        onChange={(e) => setFloorb(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Floor</option>
                        {responsef
                          .filter(
                            (item) =>
                              item.Floors.startsWith(ttowerno) &&
                              item.Floors.includes(projectName)
                          )
                          .map((item) => (
                            <option>{item.selectType}</option>
                          ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Flat/Unit
                      </Typography>
                      <Form.Select
                        required
                        // onChange={(e) => setTowardsFlatNumber(e.target.value)}
                        value={tflatno}
                       onChange={handleUnitChange}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select unit</option>
                        {unitdata
    .filter(
      (item) =>
        item.unit_name.startsWith(floorb + "-") &&
        item.unit_name.includes(ttowerno)
    )
    .map((item) => {
      console.log(`Unit Name: ${item.unit_name}`);
      console.log(`Booking Status: ${item.booking_status}`);
      console.log(`Mortgage Status: ${item.mortgage_status}`);

      // Determine disabled status for booking status
      const isBooked = item.booking_status === "booked";

      // Determine disabled status for mortgage status
      const isMortgage = item.mortgage_status === "Mortgage";

      return (
        <option
          key={item.unit_name}
          value={item.unit_name}
          disabled={isMortgage || isBooked }
        >
          {item.unit_name}
        </option>
      );
    })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        {" "}
                        Facing {" "}
                      </Typography>

                      <Form.Control
                        value={facingFlat}
                        disabled
                        // onChange={(e) => setSalesSource(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      

                      <Form.Control.Feedback type="invalid">
                        Please Select valid FacingValue
                      </Form.Control.Feedback>
                    </Form.Group>
                    </>

  ):(

<>
<Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        ProjectName
                      </Typography>
                      <Form.Select
                        required
                        onChange={(e) => setProjectName(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Project</option>
                        <option>{sessionStorage.getItem("project_name")}</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>  

                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Flat/Unit
                      </Typography>
                      <Form.Select
                        required
                        // onChange={(e) => setTowardsFlatNumber(e.target.value)}
                        value={tflatno}
                       onChange={handleUnitChange}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Villa No</option>
                        {villaUnitdata
    .map((item) => {
      // console.log(`Unit Name: ${item.unit_name}`);
      // console.log(`Booking Status: ${item.booking_status}`);
      // console.log(`Mortgage Status: ${item.mortgage_status}`);

      // // Determine disabled status for booking status
      // const isBooked = item.booking_status === "booked";

      // // Determine disabled status for mortgage status
      const isMortgage = item.mortgage === 1;

      return (
        <option
          key={item.VillaNo}
          value={item.VillaNo}
          disabled={isMortgage }
        >
          {item.VillaNo}
        </option>
      );
    })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
               

      <Form.Group as={Col} md="4" controlId="validationCustom01">
        <Typography style={{ color: "gray", fontSize: 13 }}>
          Facing
        </Typography>
        <Form.Control
          value={facingFlat}
          disabled
          type="text"
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
        <Form.Control.Feedback type="invalid">
          Please Select Valid Facing Value
        </Form.Control.Feedback>
      </Form.Group>
</>

  )}
                   
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        {" "}
                        Corner {" "}
                      </Typography>

                      <Form.Control
                        value={cornerbb}
                        disabled
                        // onChange={(e) => setSalesSource(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      

                      <Form.Control.Feedback type="invalid">
                        Please Select valid Corner
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        {" "}
                        Sales Source{" "}
                      </Typography>

                      <Form.Control
                        value={excutiveName}
                        disabled
                        // onChange={(e) => setSalesSource(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Select valid Sales Source
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Signature
                      </Typography>
                      <Form.Control
                        required
                        onChange={(e) => setSignature(e.target.files[0])}
                        type="file"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Signature
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpenbf(false);
                          setValidatedbf(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
    
            </DialogContent>
          </Dialog>
        </div>

  {/* Walkin Block Form  */}


        <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
         maxWidth="sm" // Set to small for a professional popup look
                  sx={{
    "& .MuiPaper-root": {
      borderRadius: "16px",
      width: "100%", // always full width of container
      maxWidth: "800px", // Desktop max width
      margin: "0 16px", // small margin on mobile
      "@media (max-width:600px)": {
        width: "calc(100% - 32px)", // slightly narrower for mobile
      },
      "@media (min-width:601px) and (max-width:900px)": {
        width: "90%", // medium screens
      },
    },
  }}
    
  fullWidth // Automatically expands to maxWidth
            open={openblockForm}
            onClose={handleCloseBlockForm}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
            
                <Form
                  noValidate
                  validated={validatedblock}
                  onSubmit={formValidationblockForm}
                >
                  <div className="mb-4 mt-1">
                    <center>
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                        width="145px"
                      />
                    </center>
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Block Form
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Row>
                      {/* <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <div style={{ marginBottom: 14 }}>
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Lead Name
                          </Typography>
                          <select
                            onChange={(e) => getdetls(e.target.value)}
                            style={{
                              height: "2.3rem",
                              color: "gray",
                              borderRadius: "0.3rem",
                              outline: "none",
                              width: "100%",
                              border: "0.7px solid lightgray",
                            }}
                          >
                            <option>--Select--</option>
                            {filteredItems.map((item) => (
                              <option key={item.Id}>
                                {item.name},{item.mobile}
                              </option>
                            ))}
                          </select>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Source type
                        </Form.Control.Feedback>
                      </Form.Group> */}

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Name *
                        </Typography>
                        <Form.Control
                          type="text"
                          value={nname}
                          onChange={(e) => setNname(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Mobile{" "}
                        </Typography>
                        <Form.Control
                          
                          type="number"
                          value={nmobile}
                          onChange={(e)=>setNmobile(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Mobile
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Email{" "}
                        </Typography>
                        <Form.Control
                          value={nemail}
                          type="text"
                          onChange={(e)=>setNemail(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid email
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Alternate Mobile{" "}
                      </Typography>
                      <Form.Control
                        type="number"
                        placeholder="Enter Alternate Mobile Number"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                        onChange={(e) => setAlternateMob(e.target.value)}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Alternate Mobile
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Aadhar Number
                      </Typography>
                      <Form.Control
                        placeholder="Enter Aadhar Number"
                        onChange={(e) => setAadharNumber(e.target.value)}
                        required
                        type="number"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter valid Aadhar Number
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom03">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Pan Number
                      </Typography>
                      <Form.Control
                        required
                        placeholder="Enter Pan Number"
                        onChange={(e) => setPanNumber(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Pan Number
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Permanent Address
                      </Typography>
                      <Form.Control
                        re
                        onChange={(e) => setPerAddress(e.target.value)}
                        required
                        as="textarea"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Permanent Address
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="6" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        {" "}
                        Current Address
                      </Typography>
                      <Form.Control
                        onChange={(e) => setAddressCom(e.target.value)}
                        value={addresscom}
                        required
                        as="textarea"
                        disabled={sameaspaddress}
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Check
                        style={{ color: "red", fontSize: 12 }}
                        onChange={handlecheck}
                        label="Same As Permanent Address"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter valid Address For Communication
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Typography style={{ color: "gray", fontSize: 13 }}>
          Payment Source
        </Typography>

                    <Form.Group as={Col} md="4" controlId="paymentSource" className='d-flex flex-row align-items-center w-100'>
        
        <div className='d-flex flex-row align-items-center w-100'>
        <Form.Check
          type="checkbox"
          label="UPI"
          onChange={handlePaymentSourceChangeBlock}
          value="UPI"
        />
        <Form.Check
          type="checkbox"
          label="Bank"
          onChange={handlePaymentSourceChangeBlock}
          value="Bank"
        />
        <Form.Check
          type="checkbox"
          label="Cheque"
          onChange={handlePaymentSourceChangeBlock}
          value="Cheque"
        />
        <Form.Check
          type="checkbox"
          label="Online"
          onChange={handlePaymentSourceChangeBlock}
          value="Online"
        />
        </div>
      </Form.Group>

      {selectedPaymentsBlock.includes("Online") && (
        <>
          <Form.Group as={Col} md="4" controlId="transferDetails">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Transaction Details
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Online", "transferDetails")}
              type="text"
              placeholder="Enter Transfer Details"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transfer Details
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="onlineScreenshot">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleInputChangeBlock(e, "Online", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="onlineAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Online Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Online", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPaymentsBlock.includes("Cheque") && (
        <>
          <Form.Group as={Col} md="4" controlId="chequeNumber">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Cheque Number
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Cheque", "chequeNumber")}
              type="text"
              placeholder="Enter Cheque Number"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Cheque Number
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="chequeImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Cheque Image
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleInputChangeBlock(e, "Cheque", "chequeImage")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Cheque Image
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="chequeAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Cheque  Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Cheque", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPaymentsBlock.includes("UPI") && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              UPI Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "UPI", "transactionId")}
              type="text"
              placeholder="Enter UPI Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleInputChangeBlock(e, "UPI", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            UPI Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "UPI", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPaymentsBlock.includes("Bank") && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Bank Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Bank", "transactionId")}
              type="text"
              placeholder="Enter Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="bankImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleInputChangeBlock(e, "Bank", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="bankAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Bank  Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChangeBlock(e, "Bank", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      
<Form.Group as={Col} md="4" controlId="gstPercentage">
        <Typography style={{ color: "gray", fontSize: 13 }}>GST Percentage</Typography>
        <Form.Control
          type="number"
          placeholder="Enter GST Percentage"
          onChange={handleGstChange}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
      </Form.Group>

      {/* Total Amount with GST */}
      <Form.Group as={Col} md="4" controlId="totalAmount">
        <Typography style={{ color: "gray", fontSize: 13 }}>Total Amount with GST</Typography>
        <Form.Control
          type="text"
          readOnly
          value={totalAmount.toFixed(2)}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
      </Form.Group>

                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        ProjectName
                      </Typography>
                      <Form.Select
                        required
                        onChange={(e) => setProjectName(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Project</option>
                        <option>{PrName}</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Tower{" "}
                      </Typography>
                      <Form.Select
                        required
                        value={ttowerno}
                        onChange={(e) => setTowardsTowerNumber(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Tower </option>
                        {responset
                          .filter((item) => item.Towers.startsWith(projectName)) // Filter towers that start with the project name
                          .map((item) => (
                            <option>{item.Towers}</option>
                          ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Tower Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Floor
                      </Typography>
                      <Form.Select
                        required
                        value={floorb}
                        onChange={(e) => setFloorb(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Floor</option>
                        {responsef
                          .filter(
                            (item) =>
                              item.Floors.startsWith(ttowerno) &&
                              item.Floors.includes(projectName)
                          )
                          .map((item) => (
                            <option>{item.selectType}</option>
                          ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Flat/Unit
                      </Typography>
                      <Form.Select
                        required
                        // onChange={(e) => setTowardsFlatNumber(e.target.value)}
                        value={tflatno}
                       onChange={handleUnitChange}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select unit</option>
                        {unitdata
    .filter(
      (item) =>
        item.unit_name.startsWith(floorb + "-") &&
        item.unit_name.includes(ttowerno)
    )
    .map((item) => {
      console.log(`Unit Name: ${item.unit_name}`);
      console.log(`Booking Status: ${item.booking_status}`);
      console.log(`Mortgage Status: ${item.mortgage_status}`);

      // Determine disabled status for booking status
      const isBooked = item.booking_status === "booked";

      // Determine disabled status for mortgage status
      const isMortgage = item.mortgage_status === "Mortgage";

      return (
        <option
          key={item.unit_name}
          value={item.unit_name}
          disabled={isMortgage || isBooked }
        >
          {item.unit_name}
        </option>
      );
    })}



                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        {" "}
                        Facing {" "}
                      </Typography>

                      <Form.Control
                        value={facingFlat}
                        disabled
                        // onChange={(e) => setSalesSource(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Select valid FacingValue
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        {" "}
                        Corner {" "}
                      </Typography>

                      <Form.Control
                        value={cornerbb}
                        disabled
                        // onChange={(e) => setSalesSource(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      

                      <Form.Control.Feedback type="invalid">
                        Please Select valid Corner
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        {" "}
                        Sales Source{" "}
                      </Typography>

                      <Form.Control
                        value={excutiveName}
                        disabled
                        // onChange={(e) => setSalesSource(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Select valid Sales Source
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Signature
                      </Typography>
                      <Form.Control
                        required
                        onChange={(e) => setSignature(e.target.files[0])}
                        type="file"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Signature
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpenblockForm(false);
                          setValidatedblockForm(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
  
            </DialogContent>
          </Dialog>
        </div>



        {/* Booking Form */}

        <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
        maxWidth="sm" // Set to small for a professional popup look
                  sx={{
    "& .MuiPaper-root": {
      borderRadius: "16px",
      width: "100%", // always full width of container
      maxWidth: "1000px", // Desktop max width
      margin: "0 16px", // small margin on mobile
      "@media (max-width:600px)": {
        width: "calc(100% - 32px)", // slightly narrower for mobile
      },
      "@media (min-width:601px) and (max-width:900px)": {
        width: "90%", // medium screens
      },
    },
  }}
    
  fullWidth // Automatically expands to maxWidth
            open={openbok}
            onClose={handleClosebok}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>

                <Form
                  noValidate
                  validated={Validatedbok}
                  onSubmit={formValidationbok}
                >
                  <div className="mb-4 mt-1">
                    <center>
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                        width="145px"
                      />
                    </center>
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Book Customer
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Row>
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <div style={{ marginBottom: 14 }}>
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Lead Name
                          </Typography>
                          <select
                            onChange={(e) => getdetlsb(e.target.value)}
                            style={{
                              height: "2.3rem",
                              color: "gray",
                              borderRadius: "0.3rem",
                              outline: "none",
                              width: "100%",
                              border: "0.7px solid lightgray",
                            }}
                          >
                            <option>--Select--</option>
                            {filteredBookItems.map((item) => (
                              <option>
                                {item.name},{item.mobile}
                              </option>
                            ))}
                          </select>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Source type
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Name
                        </Typography>
                        <Form.Control
                           required
                          type="text"
                          value={pnameb}
                          onChange={(e) => setPNameb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                         Co-Applicant Name
                        </Typography>
                        <Form.Control
                      
                          type="text"
                          value={capname}
                          onChange={(e) => setCapName(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>

                   
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Mobile{" "}
                        </Typography>
                        <Form.Control
                            required
                          type="number"
                          value={pmobileb}
                          onChange={(e)=>setPMobileb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Mobile
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Alternate Mobile{" "}
                        </Typography>
                        <Form.Control
                          
                          type="text"
                          value={alternatemobb}
                          onChange={(e)=>setAlternateMobb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Email{" "}
                        </Typography>
                        <Form.Control
                          required
                          value={Pemailb}
                          type="text"
                          onChange={(e)=>setPEmailb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid email
                        </Form.Control.Feedback>
                      </Form.Group>



                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Aadhar Number
                        </Typography>
                        <Form.Control
                          value={aadharnumberb}
                          type="text"
                          disabled
                          required
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter valid Aadhar Number
                        </Form.Control.Feedback>
                      </Form.Group>

                  {/*    <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Upload Aadhar
                        </Typography>
                        <Form.Control
                         required
                          onChange={handleAadharImgChange}
                          disabled={Validated}
                          type="file"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        {aadharImg && (
                          <Typography style={{ color: "gray", fontSize: 11 }}>
                            {aadharImg.name}
                          </Typography>
                        )}
                        <Typography
                          style={{
                            color: "gray",
                            fontSize: 11,
                            marginTop: 12,
                          }}
                        >
                          Note : Image Size Needs to be less than 1mb
                        </Typography>

                        <Form.Control.Feedback type="invalid">
                          Please Upload a Valid Aadhar File
                        </Form.Control.Feedback>
                      </Form.Group>*/}
                      <Form.Group
  as={Col}
  md="3"
  controlId="verificationAadhar"
>
  <Typography style={{ color: "gray", fontSize: 13 }}>
    Upload Aadhar
  </Typography>
  <Form.Control
    required
    onChange={handleAadharImgChange}
    disabled={isAadharVerified}
    type="file"
    style={{ padding: "0.42rem", marginBottom: 14 }}
  />
  {aadharImg && (
    <Typography style={{ color: "gray", fontSize: 11 }}>
      {aadharImg.name}
    </Typography>
  )}
  <Typography
    style={{
      color: "gray",
      fontSize: 11,
      marginTop: 12,
    }}
  >
    Note: Image Size Needs to be less than 1MB
  </Typography>
  <Form.Control.Feedback type="invalid">
    Please Upload a Valid Aadhar File
  </Form.Control.Feedback>
  {!otpSent && (
    <Button
      onClick={handleSendAadharOTP}
      style={{
        width: "9rem",
        height: "2.3rem",
        backgroundColor: "rgb(126, 110, 228)",
        color: "white",
        marginTop: 10,
      }}
    >
      Verify Aadhar
    </Button>
  )}
  {otpSent && !isAadharVerified &&(
    <>
      <Form.Control
        type="text"
        placeholder="Enter OTP"
        value={aadharOTP}
        onChange={(e) => setAadharOTP(e.target.value)}
        style={{ marginTop: 10 }}
      />
      <Button
        onClick={handleVerifyAadharOTP}
        style={{
          width: "9rem",
          height: "2.3rem",
          backgroundColor: "rgb(126, 110, 228)",
          color: "white",
          marginTop: 10,
        }}
      >
        Verify OTP
      </Button>
    </>
  )}
  {isAadharVerified && (
    <Typography style={{ color: "green", fontSize: 13 }}>
      Aadhar Verified
    </Typography>
  )}
</Form.Group>


                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom03"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Pan Number
                        </Typography>
                        <Form.Control
                          value={pannumberb}
                          type="text"
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Pan Number
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Upload PAN
                        </Typography>
                        <Form.Control
                        required
                          onChange={handlePanImgChange}
                          disabled={Validated}
                          type="file"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        {panImg && (
                          <Typography style={{ color: "gray", fontSize: 11 }}>
                            {panImg.name}
                          </Typography>
                        )}
                        <Typography
                          style={{
                            color: "gray",
                            fontSize: 11,
                            marginTop: 12,
                          }}
                        >
                          Note : Image Size Needs to be less than 1mb
                        </Typography>

                        <Form.Control.Feedback type="invalid">
                          Please Upload a Valid Project Layout File
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          {" "}
                          Address
                        </Typography>
                        <Form.Control
                          value={addressb}
                          type="text"
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Address
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          {" "}
                          Current Address
                        </Typography>
                        <Form.Control
                          disabled
                          required
                          value={currentaddressb}
                          type="text"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter valid Current Address
                        </Form.Control.Feedback>
                      </Form.Group>

                   {sessionStorage.getItem("project_type")!=="Villa"  && 
                   
                   <>
                   <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Tower
                        </Typography>
                        <Form.Control
                          required
                          disabled
                          type="text"
                          value={towerb}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Tower
                        </Form.Control.Feedback>
                  
                 
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Floor
                        </Typography>
                        <Form.Control
                          required
                          disabled
                          type="text"
                          value={floorb}
                        
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Floor
                        </Form.Control.Feedback>
                      </Form.Group>

                      </>
}

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Flat No/Villa No
                        </Typography>
                        <Form.Control
                          required
                          type="text"
                          disabled
                          value={flatnob}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Flat No
                        </Form.Control.Feedback>
                      </Form.Group>
                     

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          CRM Head
                        </Typography>
                        <Form.Control
                          required
                          disabled
                          value={crmHead ? crmHead.UserName : ""}
                          type="text"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                          
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Towards Flat Number
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Facing
                        </Typography>

                        <Form.Control
                          required
                          type="text"
                          value={facingb}
                          // onChange={(e) => setFacingb(e.target.value)}
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >

                         
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Facing
                        </Form.Control.Feedback>
                      </Form.Group>
  {sessionStorage.getItem("project_type")!=="Villa"  && 
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Corner
                        </Typography>
                        <Form.Control
                          required
                          type="text"
                          value={Corner}
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                       
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Corner
                        </Form.Control.Feedback>
                      </Form.Group>}

{sessionStorage.getItem("project_type")!=="Villa"  && 

                      <div className="d-flex flex-row align-items-center">
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Car Parkingggg
                        </Typography>
                        <Form.Select
                            isInvalid={Validatedbok && !carPark}
                          type="text"
                          value={carPark}
                          onChange={handleCarParkChange}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                          <option>Select CarParking</option>
                          <option>One Car Park</option>
                          <option>Two Car Park</option>
                          <option>Three Car Park</option>
                        </Form.Select>
                        {carPark && (
    <>
      <Form.Control
        type="number"
        value={amount}
        onChange={handleAmountChange}
        style={{ marginBottom: 14 }}
        disabled
      />
    
    </>
  )}
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Car Park
                        </Form.Control.Feedback>
                      </Form.Group>
                      <div className="d-flex flex-row align-items-center">
                      {totalValue !== null && (
  <div className="d-flex flex-row align-items-center">
    <p style={{ display: 'inline',color: 'blue', marginRight: '8px',marginLeft:'25px',width:'180px' }}>
      Total Value: <span style={{ color: 'black' }}>{totalValue}</span>
    </p>
    <p style={{ display: 'inline',color: 'green' }}>
      20% Amount: <span style={{ color: 'black' }}>{(totalValue * 0.20).toFixed(2)}</span>
    </p>
    <p style={{ display: 'inline',color: 'blue', marginRight: '8px',marginLeft:'25px',width:'180px' }}>
      Blocked Amount: <span style={{ color: 'black' }}>{blockTotal}</span>
    </p>
    <Button onClick={handleUpdate} style={{ marginTop: '1px' }}>
      Update
    </Button>
  </div>
)}
</div>    
</div>    }
                    </Row>
                    <Typography style={{ color: "gray", fontSize: 13 }}>
          Payment Source
        </Typography>
                    <Form.Group as={Col} md="4" controlId="paymentSource" className='d-flex flex-row align-items-center'>
       
        <div className='d-flex flex-row align-items-center'>
        <Form.Check
          type="checkbox"
          label="UPI"
          onChange={handlePaymentSourceChange}
          value="UPI"
        />
        <Form.Check
          type="checkbox"
          label="Bank"
          onChange={handlePaymentSourceChange}
          value="Bank"
        />
        <Form.Check
          type="checkbox"
          label="Cheque"
          onChange={handlePaymentSourceChange}
          value="Cheque"
        />
        <Form.Check
          type="checkbox"
          label="Online"
          onChange={handlePaymentSourceChange}
          value="Online"
        />
        </div>
      </Form.Group>

      {selectedPayments.includes("Online") && (
        <>
          <Form.Group as={Col} md="4" controlId="transferDetails">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Transaction Details
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Online", "transferDetails")}
              type="text"
              placeholder="Enter Transfer Details"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transfer Details
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="onlineScreenshot">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChange(e, "Online", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="onlineAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Online Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Online", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPayments.includes("Cheque") && (
        <>
          <Form.Group as={Col} md="4" controlId="chequeNumber">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Cheque Number
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Cheque", "chequeNumber")}
              type="text"
              placeholder="Enter Cheque Number"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Cheque Number
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="chequeImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Cheque Image
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChange(e, "Cheque", "chequeImage")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Cheque Image
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="chequeAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Cheque  Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Cheque", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPayments.includes("UPI") && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              UPI Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "UPI", "transactionId")}
              type="text"
              placeholder="Enter UPI Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChange(e, "UPI", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            UPI Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "UPI", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPayments.includes("Bank") && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Bank Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Bank", "transactionId")}
              type="text"
              placeholder="Enter Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="bankImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChange(e, "Bank", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="bankAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Bank Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Bank", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      

<Form.Group as={Col} md="4" controlId="gstPercentage">
        <Typography style={{ color: "gray", fontSize: 13 }}>GST Percentage</Typography>
        <Form.Control
          type="number"
          placeholder="Enter GST Percentage"
          onChange={handleGstChangeBook}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
      </Form.Group>

      {/* Total Amount with GST */}
      <Form.Group as={Col} md="4" controlId="totalAmount">
        <Typography style={{ color: "gray", fontSize: 13 }}>Total Amount with GST</Typography>
        <Form.Control
          type="text"
          readOnly
          value={totalAmountBook.toFixed(2)}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
      </Form.Group>





                  
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <div style={{ marginBottom: 14 }}>
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Finance Type
                        </Typography>
                        <Form.Select
                     isInvalid={Validatedbok && !financeTypeb}
                          onChange={handleFinanceTypeChange}
                          style={{
                            height: "2.3rem",
                            color: "gray",
                            borderRadius: "0.3rem",
                            outline: "none",
                            width: "100%",
                            border: "0.7px solid lightgray",
                            ...(Validatedbok && !financeTypeb ? { borderColor: 'red' } : {}),
                          }}
                        >
                          <option>--select--</option>
                          <option>PRE EMI</option>
                          <option>RERA</option>
                          <option>Customized</option>
                        </Form.Select>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid finance Type
                      </Form.Control.Feedback>
                    </Form.Group>
                    {financeTypeb === "Customized" && (
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom02"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Installment Count
                        </Typography>
                        <Form.Control
                        required
                          type="number"
                          onChange={handleInstallmentCountChange}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Installment Count
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                    {financeTypeb === "Customized" &&
                      installments.map((installment, index) => (
                        <Row key={index}>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId={`dueAmount${index}`}
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Due Amount
                            </Typography>
                            <Form.Control
                            required
                              type="text"
                              value={installment.dueAmount}
                              onChange={(e) =>
                                handleInstallmentChange(
                                  index,
                                  "dueAmount",
                                  e.target.value
                                )
                              }
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid Due Amount
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId={`expectedDate${index}`}
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Expected Date
                            </Typography>
                            <Form.Control
                            required
                              type="date"
                              value={installment.expectedDate}
                              onChange={(e) =>
                                handleInstallmentChange(
                                  index,
                                  "expectedDate",
                                  e.target.value
                                )
                              }
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid Expected Date
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Row>
                      ))}
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpenbok(false);
                          setValidatedbok(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
 
            </DialogContent>
          </Dialog>
        </div>
      </div>

  {/* WalkinBooking Form */}


      {/* <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
            maxWidth="xl"
            open={openbookForm}
            onClose={handleCloseBookForm}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div style={{ width: "74rem" }}>
                <Form
                  noValidate
                  validated={validatedbook}
                  onSubmit={formValidationbookForm}
                >
                  <div className="mb-4 mt-1">
                    <center>
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                        width="145px"
                      />
                    </center>
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Book Customer
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Row>
                   

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Name
                        </Typography>
                        <Form.Control
                          type="text"
                          value={pnameb}
                          onChange={(e) => setPNameb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Mobile{" "}
                        </Typography>
                        <Form.Control
                          
                          type="number"
                          value={pmobileb}
                          onChange={(e)=>setPMobileb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Mobile
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Alternate Mobile{" "}
                        </Typography>
                        <Form.Control
                          
                          type="text"
                          value={alternatemobb}
                          onChange={(e)=>setAlternateMobb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Email{" "}
                        </Typography>
                        <Form.Control
                          value={Pemailb}
                          type="text"
                          onChange={(e)=>setPEmailb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid email
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Aadhar Number
                        </Typography>
                        <Form.Control
                          value={aadharnumberb}
                          type="text"
                          onChange={(e)=>
                            setAadharNumberb(e.target.value)}
                          required
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter valid Aadhar Number
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Upload Aadhar
                        </Typography>
                        <Form.Control
                          onChange={handleAadharImgChange}
                          disabled={Validated}
                          type="file"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        {aadharImg && (
                          <Typography style={{ color: "gray", fontSize: 11 }}>
                            {aadharImg.name}
                          </Typography>
                        )}
                        <Typography
                          style={{
                            color: "gray",
                            fontSize: 11,
                            marginTop: 12,
                          }}
                        >
                          Note : Image Size Needs to be less than 1mb
                        </Typography>

                        <Form.Control.Feedback type="invalid">
                          Please Upload a Valid Aadhar File
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom03"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Pan Number
                        </Typography>
                        <Form.Control
                          value={pannumberb}
                          type="text"
                          onChange={(e)=>setPanNumberb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Pan Number
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Upload PAN
                        </Typography>
                        <Form.Control
                          onChange={handlePanImgChange}
                          disabled={Validated}
                          type="file"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        {panImg && (
                          <Typography style={{ color: "gray", fontSize: 11 }}>
                            {panImg.name}
                          </Typography>
                        )}
                        <Typography
                          style={{
                            color: "gray",
                            fontSize: 11,
                            marginTop: 12,
                          }}
                        >
                          Note : Image Size Needs to be less than 1mb
                        </Typography>

                        <Form.Control.Feedback type="invalid">
                          Please Upload a Valid Project Layout File
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          {" "}
                          Permanent Address
                        </Typography>
                        <Form.Control
                          value={addressb}
                          type="text"
                          onChange={(e)=>setAddressb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Address
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          {" "}
                          Current Address
                        </Typography>
                        <Form.Control
                          
                          required
                          value={currentaddressb}
                          onChange={(e)=>setCurrentAddressb(e.target.value)}
                          disabled={sameaspaddress}
                          type="text"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                          <Form.Check
                        style={{ color: "red", fontSize: 12 }}
                        onChange={handlecheck}
                        label="Same As Permanent Address"
                      />
                        <Form.Control.Feedback type="invalid">
                          Please Enter valid Current Address
                        </Form.Control.Feedback>
                      </Form.Group>
                    
                      <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        ProjectName
                      </Typography>
                      <Form.Select
                        required
                        onChange={(e) => setProjectName(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Project</option>
                        <option>{PrName}</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Tower{" "}
                      </Typography>
                      <Form.Select
                        required
                        value={towerb}
                        onChange={(e) => setTowerb(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Tower </option>
                        {responset
                          .filter((item) => item.Towers.startsWith(projectName)) // Filter towers that start with the project name
                          .map((item) => (
                            <option>{item.Towers}</option>
                          ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Tower Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Floor
                      </Typography>
                      <Form.Select
                        required
                        value={floorb}
                        onChange={(e) => setFloorb(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select Floor</option>
                        {responsef
                          .filter(
                            (item) =>
                              item.Floors.startsWith(towerb) &&
                              item.Floors.includes(projectName)
                          )
                          .map((item) => (
                            <option>{item.selectType}</option>
                          ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="3" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Flat/Unit
                      </Typography>
                      <Form.Select
                        required
                        value={flatnob}
                        onChange={handleUnitChangeBook}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      >
                        <option>Select unit</option>
  {unitdata
    .filter(
      (item) =>
        item.unit_name.startsWith(floorb + "-") &&
        item.unit_name.includes(ttowerno)
    )
    .map((item) => {
      console.log(`Unit Name: ${item.unit_name}`);
      console.log(`Booking Status: ${item.booking_status}`);
      console.log(`Mortgage Status: ${item.mortgage_status}`);

      // Determine disabled status for booking status
      const isBooked = item.booking_status === "booked";

      // Determine disabled status for mortgage status
      const isMortgage = item.mortgage_status === "Mortgage";

      return (
        <option
          key={item.unit_name}
          value={item.unit_name}
          disabled={isMortgage || isBooked }
        >
          {item.unit_name}
        </option>
      );
    })}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Towards Flat Number
                      </Form.Control.Feedback>
                    </Form.Group>



                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Facing
                        </Typography>

                        <Form.Control
                          required
                          type="text"
                          value={facingFlatB}
                          // onChange={(e) => setFacingb(e.target.value)}
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >

                         
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Facing
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          CRM Executive
                        </Typography>
                        <Form.Control
                          required
                          disabled
                          value={crmHead ? crmHead.UserName : ""}
                          type="text"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                          
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Towards Flat Number
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Corner
                        </Typography>
                        <Form.Control
                          disabled
                          type="text"
                          value={cornerbb}
                        
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                          
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Corner
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="4" controlId="paymentSource">
                    <Typography style={{ color: "gray", fontSize: 13 }}>
        Payment Source
      </Typography>
        <Form.Select
          required
          onChange={(e) => setPaymentSourceBok(e.target.value)}
          value={paymentsourceb}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        >
          <option>select payment type</option>
          <option>UPI</option>
          <option>Online</option>
          <option>Cheque</option>
          <option>Bank</option>
        </Form.Select>
        <Form.Control.Feedback type="invalid">
          Please Enter Valid Payment Source
        </Form.Control.Feedback>
      </Form.Group>
      {paymentsourceb === "Online" && (
        <>
          <Form.Group as={Col} md="4" controlId="chequeNumber">
        <Typography style={{ color: "gray", fontSize: 13 }}>
        Transaction Details
      </Typography>
      <Form.Control
            required
            onChange={(e) => setTransferDetailsBok(e.target.value)}
            type="text"
            placeholder="Enter Transfer Details"
            style={{ padding: "0.42rem", marginBottom: 14 }}
          />
          </Form.Group>
            <Form.Group as={Col} md="4" controlId="upiImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => setScreenshotBok(e.target.files[0])}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          </>

      )}

      {paymentsourceb === "Cheque" && (
        <Form.Group as={Col} md="4" controlId="chequeNumber">
          <Typography style={{ color: "gray", fontSize: 13 }}>
            Cheque Number
          </Typography>
          <Form.Control
            required
            onChange={(e) => setChequeNumberBok(e.target.value)}
            type="text"
            placeholder="Enter Cheque Number"
            style={{ padding: "0.42rem", marginBottom: 14 }}
          />
          <Form.Control.Feedback type="invalid">
            Please Enter Valid Cheque Number
          </Form.Control.Feedback>
        </Form.Group>
      )}

      {paymentsourceb === "Cheque" && (
        <Form.Group as={Col} md="4" controlId="chequeImage">
          <Typography style={{ color: "gray", fontSize: 13 }}>
            Upload Cheque Image
          </Typography>
          <Form.Control
            required
            type="file"
            onChange={(e) => setScreenshotBok(e.target.files[0])}
            style={{ padding: "0.42rem", marginBottom: 14 }}
          />
          <Form.Control.Feedback type="invalid">
            Please Upload Cheque Image
          </Form.Control.Feedback>
        </Form.Group>
      )}

      {paymentsourceb === "UPI" && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              UPI Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => setTransactionIdBok(e.target.value)}
              type="text"
              placeholder="Enter UPI Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group as={Col} md="4" controlId="upiImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => setScreenshotBok(e.target.files[0])}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {paymentsourceb === "Bank" && (
        <>
        <Form.Group as={Col} md="4" controlId="transferDetails">
        
          <Typography style={{ color: "gray", fontSize: 13 }}>
              Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => setTransactionIdBok(e.target.value)}
              type="text"
              placeholder="Enter Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
       
          <Form.Control.Feedback type="invalid">
            Please Enter Valid Transfer Details
          </Form.Control.Feedback>
        </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiImage">
          <Typography style={{ color: "gray", fontSize: 13 }}>
            Upload Screenshot
          </Typography>
          <Form.Control
            required
            type="file"
            onChange={(e) => setScreenshotBok(e.target.files[0])}
            style={{ padding: "0.42rem", marginBottom: 14 }}
          />
          <Form.Control.Feedback type="invalid">
            Please Upload Screenshot
          </Form.Control.Feedback>
        </Form.Group>
        </>
      )}

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Car Parking
                        </Typography>
                        <Form.Select
                          required
                          type="text"
                          value={carPark}
                          onChange={(e) => setCarPark(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                          <option>Select CarParking</option>
                          <option>One Car Park</option>
                          <option>Two Car Park</option>
                          <option>Three Car Park</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Corner
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Amount Paid
                      </Typography>
                      <Form.Control
                        required
                        type="text"
                        value={amountpaidb}
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                        onChange={(e) => setAmountPaidb(e.target.value)}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Amount Paid
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <div style={{ marginBottom: 14 }}>
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Finance Type
                        </Typography>
                        <select
                          onChange={handleFinanceTypeChange}
                          style={{
                            height: "2.3rem",
                            color: "gray",
                            borderRadius: "0.3rem",
                            outline: "none",
                            width: "100%",
                            border: "0.7px solid lightgray",
                          }}
                        >
                          <option>--select--</option>
                          <option>PRE EMI</option>
                          <option>RERA</option>
                          <option>Customized</option>
                        </select>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid finance Type
                      </Form.Control.Feedback>
                    </Form.Group>
                    {financeTypeb === "Customized" && (
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom02"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Installment Count
                        </Typography>
                        <Form.Control
                          type="number"
                          onChange={handleInstallmentCountChange}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Installment Count
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                    {financeTypeb === "Customized" &&
                      installments.map((installment, index) => (
                        <Row key={index}>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId={`dueAmount${index}`}
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Due Amount
                            </Typography>
                            <Form.Control
                              type="text"
                              value={installment.dueAmount}
                              onChange={(e) =>
                                handleInstallmentChange(
                                  index,
                                  "dueAmount",
                                  e.target.value
                                )
                              }
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid Due Amount
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId={`expectedDate${index}`}
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Expected Date
                            </Typography>
                            <Form.Control
                              type="date"
                              value={installment.expectedDate}
                              onChange={(e) =>
                                handleInstallmentChange(
                                  index,
                                  "expectedDate",
                                  e.target.value
                                )
                              }
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid Expected Date
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Row>
                      ))}
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpenbok(false);
                          setValidatedbok(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </DialogContent>
          </Dialog>
        </div> */}


        {/* Booking for multiple payments */}

        <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
            maxWidth="xl"
            open={openbokOne}
            onClose={handleClosebokOne}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div style={{ width: "74rem" }}>
                <Form
                  noValidate
                  validated={ValidatedbokOne}
                  onSubmit={formValidationbokOne}
                >
                  <div className="mb-4 mt-1">
                    <center>
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                        width="145px"
                      />
                    </center>
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Book Customer
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Row>
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <div style={{ marginBottom: 14 }}>
                          <Typography style={{ color: "gray", fontSize: 13 }}>
                            Lead Name
                          </Typography>
                          <select
                            onChange={(e) => getdetlsb(e.target.value)}
                            style={{
                              height: "2.3rem",
                              color: "gray",
                              borderRadius: "0.3rem",
                              outline: "none",
                              width: "100%",
                              border: "0.7px solid lightgray",
                            }}
                            value={clickedBookNameOne}
                          >
                            <option>--Select--</option>
                            {filteredBookItemsOne.map((item) => (
                              <option>
                                {item.customerName},{item.mobileNumber}
                              </option>
                            ))}
                          </select>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Source type
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Name
                        </Typography>
                        <Form.Control
                        required
                          type="text"
                          value={pnameb}
                          onChange={(e) => setPNameb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>

                   
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Mobile{" "}
                        </Typography>
                        <Form.Control
                          required
                          type="number"
                          value={pmobileb}
                          onChange={(e)=>setPMobileb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Mobile
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Alternate Mobile{" "}
                        </Typography>
                        <Form.Control
                          
                          type="text"
                          value={alternatemobb}
                          onChange={(e)=>setAlternateMobb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Email{" "}
                        </Typography>
                        <Form.Control
                        required
                          value={Pemailb}
                          type="text"
                          onChange={(e)=>setPEmailb(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid email
                        </Form.Control.Feedback>
                      </Form.Group>



                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Aadhar Number
                        </Typography>
                        <Form.Control
                          value={aadharnumberb}
                          type="text"
                          disabled
                          required
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter valid Aadhar Number
                        </Form.Control.Feedback>
                      </Form.Group>

                      {/* <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Upload Aadhar
                        </Typography>
                        <Form.Control
                        required
                          onChange={handleAadharImgChange}
                          disabled={Validated}
                          type="file"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        {aadharImg && (
                          <Typography style={{ color: "gray", fontSize: 11 }}>
                            {aadharImg.name}
                          </Typography>
                        )}
                        <Typography
                          style={{
                            color: "gray",
                            fontSize: 11,
                            marginTop: 12,
                          }}
                        >
                          Note : Image Size Needs to be less than 1mb
                        </Typography>

                        <Form.Control.Feedback type="invalid">
                          Please Upload a Valid Aadhar File
                        </Form.Control.Feedback>
                      </Form.Group> */}

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom03"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Pan Number
                        </Typography>
                        <Form.Control
                          value={pannumberb}
                          type="text"
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Pan Number
                        </Form.Control.Feedback>
                      </Form.Group>
                      {/* <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Upload PAN
                        </Typography>
                        <Form.Control
                        required
                          onChange={handlePanImgChange}
                          disabled={Validated}
                          type="file"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        {panImg && (
                          <Typography style={{ color: "gray", fontSize: 11 }}>
                            {panImg.name}
                          </Typography>
                        )}
                        <Typography
                          style={{
                            color: "gray",
                            fontSize: 11,
                            marginTop: 12,
                          }}
                        >
                          Note : Image Size Needs to be less than 1mb
                        </Typography>

                        <Form.Control.Feedback type="invalid">
                          Please Upload a Valid Project Layout File
                        </Form.Control.Feedback>
                      </Form.Group> */}

                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          {" "}
                          Address
                        </Typography>
                        <Form.Control
                          value={addressb}
                          type="text"
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Address
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="6"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          {" "}
                          Current Address
                        </Typography>
                        <Form.Control
                          disabled
                          required
                          value={currentaddressb}
                          type="text"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter valid Current Address
                        </Form.Control.Feedback>
                      </Form.Group>

                      {sessionStorage.getItem("project_type")!=="Villa"  && 
                   
                   <>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Tower
                        </Typography>
                        <Form.Control
                          required
                          disabled
                          type="text"
                          value={towerb}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Tower
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Floor
                        </Typography>
                        <Form.Control
                          required
                          disabled
                          type="text"
                          value={floorb}
                        
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Floor
                        </Form.Control.Feedback>
                      </Form.Group>


                      </>}


                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Flat No
                        </Typography>
                        <Form.Control
                          required
                          type="text"
                          disabled
                          value={flatnob}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Flat No
                        </Form.Control.Feedback>
                      </Form.Group>
                     

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          CRM Head
                        </Typography>
                        <Form.Control
                          required
                          disabled
                          value={crmHead ? crmHead.UserName : ""}
                          type="text"
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                          
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Towards Flat Number
                        </Form.Control.Feedback>
                      </Form.Group>


                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Facing
                        </Typography>

                        <Form.Control
                          required
                          type="text"
                          value={facingb}
                          // onChange={(e) => setFacingb(e.target.value)}
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >

                         
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Facing
                        </Form.Control.Feedback>
                      </Form.Group>

                      {sessionStorage.getItem("project_type")!=="Villa"  && 
                   
                   <>

                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Corner
                        </Typography>
                        <Form.Control
                          required
                          type="text"
                          value={Corner}
                          disabled
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                       
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Corner
                        </Form.Control.Feedback>
                      </Form.Group>

                      </>}

                      {/* <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Car Parking
                        </Typography>
                        <Form.Select
                          required
                          isInvalid={ValidatedbokOne && !carPark}
                          type="text"
                          value={carPark}
                          onChange={handleCarParkChange}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        >
                          <option>Select CarParking</option>
                          <option>One Car Park</option>
                          <option>Two Car Park</option>
                          <option>Three Car Park</option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid CarParking
                        </Form.Control.Feedback>
                      </Form.Group> */}
                    </Row>
                    <Typography style={{ color: "gray", fontSize: 13 }}>
          Payment Source
        </Typography>
                    <Form.Group as={Col} md="4" controlId="paymentSource" className='d-flex flex-row align-items-center'>
       <div className='d-flex flex-row align-items-center'>
        <Form.Check
          type="checkbox"
          label="UPI"
          onChange={handlePaymentSourceChange}
          value="UPI"
        />
        <Form.Check
          type="checkbox"
          label="Bank"
          onChange={handlePaymentSourceChange}
          value="Bank"
        />
        <Form.Check
          type="checkbox"
          label="Cheque"
          onChange={handlePaymentSourceChange}
          value="Cheque"
        />
        <Form.Check
          type="checkbox"
          label="Online"
          onChange={handlePaymentSourceChange}
          value="Online"
        />
        </div>
      </Form.Group>

      {selectedPayments.includes("Online") && (
        <>
          <Form.Group as={Col} md="4" controlId="transferDetails">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Transaction Details
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Online", "transferDetails")}
              type="text"
              placeholder="Enter Transfer Details"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transfer Details
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="onlineScreenshot">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChange(e, "Online", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="onlineAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Online Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Online", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPayments.includes("Cheque") && (
        <>
          <Form.Group as={Col} md="4" controlId="chequeNumber">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Cheque Number
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Cheque", "chequeNumber")}
              type="text"
              placeholder="Enter Cheque Number"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Cheque Number
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="chequeImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Cheque Image
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChange(e, "Cheque", "chequeImage")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Cheque Image
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="chequeAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Cheque Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Cheque", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPayments.includes("UPI") && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              UPI Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "UPI", "transactionId")}
              type="text"
              placeholder="Enter UPI Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChange(e, "UPI", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="upiAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            UPI Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "UPI", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      {selectedPayments.includes("Bank") && (
        <>
          <Form.Group as={Col} md="4" controlId="transactionId">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Bank Transaction ID
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Bank", "transactionId")}
              type="text"
              placeholder="Enter Transaction ID"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Transaction ID
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="bankImage">
            <Typography style={{ color: "gray", fontSize: 13 }}>
              Upload Screenshot
            </Typography>
            <Form.Control
              required
              type="file"
              onChange={(e) => handleFileChange(e, "Bank", "screenshot")}
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Upload Screenshot
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group as={Col} md="4" controlId="bankAmtPaid">
            <Typography style={{ color: "gray", fontSize: 13 }}>
            Bank Amount Paid
            </Typography>
            <Form.Control
              required
              onChange={(e) => handleInputChange(e, "Bank", "amtPaid")}
              type="number"
              placeholder="Enter Amount Paid"
              style={{ padding: "0.42rem", marginBottom: 14 }}
            />
            <Form.Control.Feedback type="invalid">
              Please Enter Valid Amount Paid
            </Form.Control.Feedback>
          </Form.Group>
        </>
      )}

      

<Form.Group as={Col} md="4" controlId="gstPercentage">
        <Typography style={{ color: "gray", fontSize: 13 }}>GST Percentage</Typography>
        <Form.Control
          type="number"
          placeholder="Enter GST Percentage"
          onChange={handleGstChangeBook}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
      </Form.Group>

      {/* Total Amount with GST */}
      <Form.Group as={Col} md="4" controlId="totalAmount">
        <Typography style={{ color: "gray", fontSize: 13 }}>Total Amount with GST</Typography>
        <Form.Control
          type="text"
          readOnly
          value={totalAmountBook.toFixed(2)}
          style={{ padding: "0.42rem", marginBottom: 14 }}
        />
      </Form.Group>
                  
                    {/* {/* <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <div style={{ marginBottom: 14 }}>
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Finance Type
                        </Typography>
                        <select
                          onChange={handleFinanceTypeChange}
                          style={{
                            height: "2.3rem",
                            color: "gray",
                            borderRadius: "0.3rem",
                            outline: "none",
                            width: "100%",
                            border: "0.7px solid lightgray",
                            ...(ValidatedbokOne && !financeTypeb ? { borderColor: 'red' } : {}),
                          }}
                        >
                          <option>--select--</option>
                          <option>PRE EMI</option>
                          <option>RERA</option>
                          <option>Customized</option>
                        </select>
                      </div>
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid finance Type
                      </Form.Control.Feedback>
                    </Form.Group> */}
                    {/* {financeTypeb === "Customized" && (
                      <Form.Group
                        as={Col}
                        md="4"
                        controlId="validationCustom02"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Installment Count
                        </Typography>
                        <Form.Control
                        required
                          type="number"
                          onChange={handleInstallmentCountChange}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Installment Count
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                    {financeTypeb === "Customized" &&
                      installments.map((installment, index) => (
                        <Row key={index}>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId={`dueAmount${index}`}
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Due Amount
                            </Typography>
                            <Form.Control
                               required
                              type="text"
                              value={installment.dueAmount}
                              onChange={(e) =>
                                handleInstallmentChange(
                                  index,
                                  "dueAmount",
                                  e.target.value
                                )
                              }
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid Due Amount
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group
                            as={Col}
                            md="6"
                            controlId={`expectedDate${index}`}
                          >
                            <Typography style={{ color: "gray", fontSize: 13 }}>
                              Expected Date
                            </Typography>
                            <Form.Control
                               required
                              type="date"
                              value={installment.expectedDate}
                              onChange={(e) =>
                                handleInstallmentChange(
                                  index,
                                  "expectedDate",
                                  e.target.value
                                )
                              }
                              style={{ padding: "0.42rem", marginBottom: 14 }}
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Valid Expected Date
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Row>
                      ))}  */}
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpenbokOne(false);
                          setValidatedbokOne(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </DialogContent>
          </Dialog>
        </div>


        {/*ChannelPartner Form*/}
   
        <div>
          <Dialog
            style={{ borderTop: "12px solid rgb(126, 110, 228)" }}
            maxWidth="xl"
            open={openChannerlPForm}
            onClose={handleCloseChannelPForm}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogContent>
              <div style={{ width: "74rem" }}>
                <Form
                  noValidate
                  validated={validatedChannelP}
                  onSubmit={formValidationChannelPForm}
                >
                  <div className="mb-4 mt-1">
                    <center>
                      <img
                        src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                        width="145px"
                      />
                    </center>
                    <Typography
                      style={{
                        textAlign: "center",
                        fontWeight: "500",
                        color: "rgb(126, 110, 228)",
                        fontSize: 21,
                      }}
                    >
                      Channel Partner Form
                    </Typography>
                  </div>
                  <Row className="mb-3">
                    <Row>
                     
                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Name *
                        </Typography>
                        <Form.Control
                          type="text"
                          value={cpname}
                          onChange={(e) => setCpname(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Name
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Mobile{" "}
                        </Typography>
                        <Form.Control
                          
                          type="number"
                          value={cpmobile}
                          onChange={(e)=>setcpmobile(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid Mobile
                        </Form.Control.Feedback>
                      </Form.Group>

                      <Form.Group
                        as={Col}
                        md="3"
                        controlId="validationCustom01"
                      >
                        <Typography style={{ color: "gray", fontSize: 13 }}>
                          Email{" "}
                        </Typography>
                        <Form.Control
                          value={cpemail}
                          type="text"
                          onChange={(e)=>setcpemail(e.target.value)}
                          style={{ padding: "0.42rem", marginBottom: 14 }}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please Enter Valid email
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        RERA NO{" "}
                      </Typography>
                      <Form.Control
                        type="text"
                        placeholder="Enter RERA Number"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                        value={reraNo}
                        onChange={(e) => setReraNo(e.target.value)}
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid RERA NO
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group as={Col} md="4" controlId="validationCustom01">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Aadhar Number
                      </Typography>
                      <Form.Control
                        placeholder="Enter Aadhar Number"
                        onChange={(e) => setCpAadharNumber(e.target.value)}
                        value={cpaadhar}
                        required
                        type="number"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter valid Aadhar Number
                      </Form.Control.Feedback>
                    </Form.Group>
{/* 
                    <Form.Group as={Col} md="4" controlId="validationCustom03">
                      <Typography style={{ color: "gray", fontSize: 13 }}>
                        Channel Id
                      </Typography>
                      <Form.Control
                        required
                        placeholder="Enter Channel ID"
                        // onChange={(e) => setPanNumber(e.target.value)}
                        type="text"
                        style={{ padding: "0.42rem", marginBottom: 14 }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Valid Channel ID Number
                      </Form.Control.Feedback>
                    </Form.Group> */}
                  </Row>
                  <div className="d-flex">
                    <div>
                      <Button
                        type="submit"
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "rgb(126, 110, 228)",
                          color: "white",
                          marginRight: 3,
                        }}
                      >
                        Submit
                      </Button>
                    </div>
                    <div>
                      <Button
                        onClick={() => {
                          setOpenChannelPForm(false);
                          setValidatedChannelPForm(false);
                        }}
                        style={{
                          width: "9rem",
                          height: "2.3rem",
                          backgroundColor: "gray",
                          color: "white",
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </DialogContent>
          </Dialog>
        </div>

{/*Bulk Upload Form*/}   


<div>
<Dialog
      style={{ borderTop: '12px solid rgb(126, 110, 228)' }}
      maxWidth="sm"
      open={openBulkUploadForm}
      onClose={handleCloseBulkUploadForm}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogContent>
        <div style={{ width: '34rem' }}>
          <Form noValidate  validated={validatedBulkUplaod}
                  onSubmit={formValidationBulkUplaodForm}>
            <div className="mb-4 mt-1">
              <center>
                <img
                  src="https://static.vecteezy.com/system/resources/previews/004/648/833/non_2x/user-icon-symbol-3d-design-concept-illustration-vector.jpg"
                  width="145px"
                  alt="User Icon"
                />
              </center>
              <Typography
                style={{
                  textAlign: 'center',
                  fontWeight: '500',
                  color: 'rgb(126, 110, 228)',
                  fontSize: 21,
                }}
              >
                Bulk Upload Form
              </Typography>
            </div>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="validationCustom01">
                <Typography style={{ color: 'gray', fontSize: 13 }}>
                  Upload Excel File
                </Typography>
                <Form.Control
                  type="file"
              
                  accept=".xlsx, .xls"
                  onChange={(e)=>setBfile(e.target.files[0])} 
                  style={{ padding: '0.42rem', marginBottom: 14 }}
                />
              
              </Form.Group>
            </Row>
            <div className="d-flex">
              <div>
                <Button
                  type="submit"
                  style={{
                    width: '9rem',
                    height: '2.3rem',
                    backgroundColor: 'rgb(126, 110, 228)',
                    color: 'white',
                    marginRight: 3,
                  }}
                >
                  Submit
                </Button>
              </div>
              <div>
                <Button
                  onClick={handleCloseBulkUploadForm}
                  style={{
                    width: '9rem',
                    height: '2.3rem',
                    backgroundColor: 'gray',
                    color: 'white',
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </DialogContent>
    </Dialog>
        </div>


        <Dialog open={openblockPop} onClose={handleCloseblockPop} maxWidth="md" fullWidth>
        <DialogTitle>Customer Details</DialogTitle>
        <DialogContent>
        {selectedCustomerblockPop && (
            <Box sx={{ padding: 2 }}>
              <div className="d-flex flex-row aling-items-center justify-content-around">
                <div>
              <Typography variant="h6" component="div" sx={{ marginBottom: 2 }}>
                <strong>Name:</strong> {selectedCustomerblockPop.name}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Email:</strong> {selectedCustomerblockPop.email}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Mobile:</strong> {selectedCustomerblockPop.mobile}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Aadhar No:</strong> {selectedCustomerblockPop.aadharNo}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Sales Executive:</strong> {selectedCustomerblockPop.salesSource}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Flat No:</strong> {selectedCustomerblockPop.tflatNo}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Floor No:</strong> {selectedCustomerblockPop.tfloor}
              </Typography> 
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Tower No:</strong> {selectedCustomerblockPop.ttowerNo}
              </Typography> 
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Permanent Address:</strong> {selectedCustomerblockPop.permanentAddress}
              </Typography>
              </div>

            <div>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Bank Amount Paid:</strong> ₹{selectedCustomerblockPop.bank_amtPaid}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Cheque Amount Paid:</strong> ₹{selectedCustomerblockPop.cheque_amtPaid}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Online Amount Paid:</strong> ₹{selectedCustomerblockPop.online_amtPaid || 'N/A'}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>UPI Amount Paid:</strong> ₹{selectedCustomerblockPop.upi_amtPaid || 'N/A'}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Total Amount Paid:</strong> ₹{selectedCustomerblockPop.blockTotal || 'N/A'}
              </Typography> 
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Overall Status:</strong> {selectedCustomerblockPop.overall_status || 'N/A'}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>GST Amount:</strong> ₹{selectedCustomerblockPop.gstAmount || 'N/A'}
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>GST Percentage:</strong> {selectedCustomerblockPop.gstPercentage || 'N/A'}%
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Signature:</strong> <a href={selectedCustomerblockPop.signature} target="_blank" rel="noopener noreferrer">View Signature</a>
              </Typography>
              <Typography variant="body1" sx={{ marginBottom: 1 }}>
                <strong>Bank Approval Date:</strong> {selectedCustomerblockPop.bank_approvalDate ? new Date(selectedCustomerblockPop.bank_approvalDate).toLocaleDateString() : 'N/A'}
              </Typography>
              </div>
              </div>
              {/* Add more fields as needed */}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseblockPop } color="primary">Close</Button>
        </DialogActions>
      </Dialog>

      {selectedCustomerBookPop && (
        <CustomerDetailDialog
          open={openBookPop}
          onClose={handleCloseBookPop}
          customer={selectedCustomerBookPop}
        />
      )}

    </>
  );
}
